export default {
  "admin": {
    "discounts": {
      "calc": {
        "byPercent": "Direkt in %",
        "discountedSeats": "Rabattierte Plätze (von {{total}})",
        "equivalent": "Ergibt",
        "fromSeats": "Aus Platzzahl",
        "offPercent": "Rabatt auf diese Plätze (%)",
      },
      "compact": {
        "activeBadge": "{{percent}} % aktiv",
        "duration_one": "Laufzeit {{count}} Monat",
        "duration_other": "Laufzeit {{count}} Monate",
        "remove": "Entfernen",
      },
      "duration": {
        "forever": "Unbegrenzt",
        "months_one": "{{count}} Monat",
        "months_other": "{{count}} Monate",
      },
      "form": {
        "duration": {
          "description":
            "Nach Ablauf wertet das Sales-Team den Rabatt neu aus.",
          "label": "Laufzeit",
        },
        "percent": {
          "description": "Sales gibt einen Wert zwischen 1 und 100 an.",
          "label": "Rabatt in Prozent",
        },
        "reason": {
          "description":
            "Wird im Coupon-Metadatenfeld gespeichert (audit-trail).",
          "label": "Begründung",
          "placeholder":
            'z. B. „Stuhl wird als Raum genutzt, 50 % auf einen Platz"',
        },
        "submit": "Rabatt anwenden",
        "title": "Neuen Rabatt anwenden",
      },
      "preview": {
        "discount": "Rabatt ({{percent}} %)",
        "newTotal": "Neuer Rechnungsbetrag",
        "subtotal": "Zwischensumme",
        "title": "Vorschau für die Rechnung am {{date}}",
      },
      "sectionTitle": "Rabatt verwalten",
      "subheading":
        "Der Rabatt wird direkt am laufenden Abo angebracht. Die nächste Rechnung wird automatisch reduziert.",
      "trialingBanner": {
        "body":
          "Das Abo befindet sich noch in der Testphase. Ein hier hinterlegter Rabatt wird ab dem ersten Rechnungslauf am {{date}} aktiv.",
        "title": "Rabatt wird nach Ende der Testphase aktiv",
      },
      "warnings": {
        "fetchFailed": {
          "body":
            "Dentero konnte nicht prüfen, ob in Stripe bereits ein Rabatt aktiv ist. Rabatte erst ändern, wenn diese Prüfung erfolgreich lädt.",
          "title": "Stripe-Rabatte konnten nicht geprüft werden",
        },
        "sharedSubscription": {
          "body":
            "Dieses Abo ist mehreren Praxen zugeordnet. Jeder Rabatt wirkt auf alle Praxen, deshalb vorher mit Finance abstimmen.",
          "title": "Geteiltes Abo",
        },
      },
    },
    "onboardingPackage": {
      "amount": "Betrag",
      "bookedAt": "Gebucht am",
      "invoice": "Rechnung",
      "noInvoice": "Keine Rechnung",
      "note": {
        "label": "Notiz",
        "placeholder": "Interne Notiz, z. B. was noch fehlt",
      },
      "openInvoice": "In Stripe öffnen",
      "plusVat": "zzgl. MwSt.",
      "save": "Speichern",
      "status": "Status",
      "statuses": {
        "accepted": "Abgenommen",
        "documents_received": "Unterlagen erhalten",
        "first_call_done": "Erster Call erledigt",
        "refunded": "Erstattet",
        "requested_documents": "Unterlagen angefragt",
        "setup_in_progress": "Einrichtung läuft",
      },
      "subheadingCheckout":
        "Beim Checkout gebucht. Den Status setzt unser Team von Hand.",
      "subheadingInvoice":
        "Per Rechnung gebucht. Den Status setzt unser Team von Hand.",
      "title": "Onboarding-Paket",
    },
    "settings": {
      "androidAppVersion": {
        "description": "Neueste veröffentlichte Version der Android-App.",
        "label": "Android-App-Version",
        "placeholder": "z. B. 1.2.3",
      },
      "androidStoreUrl": {
        "description": "Link zum Play-Store-Eintrag der App.",
        "label": "Android-Store-Link",
        "placeholder": "https://play.google.com/store/apps/details?id=...",
      },
      "complexAutoApplyThreshold": {
        "description":
          "Ab dieser Konfidenz (0 bis 1) wird ein Komplex mit aktivierter automatischer Anwendung direkt eingebaut. Darunter bleibt er ein Vorschlag.",
        "label": "Komplex-Schwelle",
      },
      "documentationModel": {
        "description":
          "Wird für die verbesserte und strukturierte Behandlungsdokumentation verwendet.",
        "label": "Dokumentation",
        "placeholder": "Modell wählen",
      },
      "featureSpotlights": {
        "description":
          "Zeigt Nutzern eine Karte zu einer Funktion ihres Pakets, die sie noch nie genutzt haben. Nach dem Ausschalten verschwinden die Karten, sobald die Seite neu geladen wird. Admins bekommen selbst nie eine Karte. Für eine Vorschau hängen Sie an eine beliebige Seite ?spotlight_preview= und den Schlüssel realtime_transcription, complexes_setup, complexes_use, befund_chart_live, befund_chart_review oder befund_chart_history an, zum Beispiel /recordings?spotlight_preview=complexes_use. Die Vorschau zeigt die Karte auch bei ausgeschalteten Spotlights und speichert keine Auswahl und keine Statistik.",
        "label": "Feature-Spotlights",
      },
      "geminiPriorityTier": {
        "description":
          "Fragt bei allen Gemini-Anfragen auf Vertex (EU) Priority PayGo an. Kostet das 1,8-Fache des Standardpreises. Ohne freie Kapazität bedient Vertex die Anfrage zum Standardpreis. Ausschalten, um Kosten zu sparen.",
        "label": "Gemini Priority",
      },
      "iosAppVersion": {
        "description": "Neueste veröffentlichte Version der iOS-App.",
        "label": "iOS-App-Version",
        "placeholder": "z. B. 1.2.3",
      },
      "iosStoreUrl": {
        "description": "Link zum App-Store-Eintrag der App.",
        "label": "iOS-Store-Link",
        "placeholder": "https://apps.apple.com/app/...",
      },
      "plausibilityCheckModel": {
        "description":
          "Wird für die Plausibilitätsprüfung der Dokumentation verwendet. luna ist deutlich günstiger als terra, sol ist ~5x teurer.",
        "label": "Plausibilitätsprüfung",
        "placeholder": "Modell wählen",
      },
      "pseudonymization": {
        "description":
          "Ersetzt Personendaten (Namen, Geburtsdaten, Adressen, Telefonnummern, E-Mail-Adressen, Versicherungsnummern) im Transkript durch Platzhalter. Läuft als eigener Schritt mit Gemini Flash (EU). Nur für ASR-Anbieter (Soniox, Mistral, AssemblyAI); die Gemini-Transkription pseudonymisiert bereits im Prompt. Ausschalten speichert Transkripte unredigiert. Nur verwenden, wenn der Anbieter die Transkription blockiert.",
        "label": "Pseudonymisierung",
      },
      "sections": {
        "aiModels": {
          "description":
            "Anbieter und Modelle für Transkription, Dokumentation und Abrechnungsvorschläge.",
          "title": "KI-Modelle",
        },
        "appVersions": {
          "description":
            "Neueste App-Versionen und Store-Links, die im Update-Hinweis angezeigt werden.",
          "title": "App-Versionen",
        },
        "inAppNotices": {
          "description": "Hinweise, die Nutzer in der App sehen.",
          "title": "Hinweise in der App",
        },
      },
      "suggestionModel": {
        "description": "Wird für PKV- und GKV-Abrechnungsvorschläge verwendet.",
        "label": "Abrechnungsvorschläge",
        "placeholder": "Modell wählen",
      },
      "transcriptCorrection": {
        "description":
          "Lässt ein zweites Modell die Transkription anhand der Audiodatei auf Fachbegriffe prüfen. Nur für ASR-Anbieter (Soniox, Mistral, AssemblyAI); bei Gemini-Transkription wirkungslos. Ausschalten senkt die Kosten und behält die reine ASR-Transkription.",
        "label": "Transkriptkorrektur",
      },
      "transcriptionProvider": {
        "description": "Wird für die Transkription neuer Aufnahmen verwendet.",
        "label": "Transkription",
        "placeholder": "Anbieter wählen",
      },
      "transcriptionThinkingLevel": {
        "description":
          'Gemini-Denkaufwand für die Transkription neuer Aufnahmen. "Modellstandard" sendet keine Thinking-Konfiguration und überlässt die Entscheidung dem Modell.',
        "label": "Transkriptions-Denkstufe",
        "levels": {
          "default": "Modellstandard",
          "HIGH": "Hoch",
          "LOW": "Niedrig",
          "MEDIUM": "Mittel",
          "MINIMAL": "Minimal",
        },
        "placeholder": "Denkstufe wählen",
      },
    },
    "subscriptionAdmin": {
      "disabled": {
        "discount": {
          "invalidStatus":
            "Rabatte können nur bei aktiven Abos oder während der regulären Stripe-Testphase geändert werden.",
          "legacy":
            "Dieses Legacy-Abo zuerst auf Tier-Preise migrieren, bevor Dentero-Rabatte gesetzt werden.",
          "noSubscription": "Vor Rabatten zuerst ein Stripe-Abo erstellen.",
        },
        "provision": {
          "hasSubscription": "Diese Praxis hat bereits ein Stripe-Abo.",
          "noPermission":
            "Du hast keine Berechtigung, einen Stripe-Checkout-Link zu erstellen.",
        },
        "trial": {
          "legacy":
            "Dieses Legacy-Abo zuerst auf Tier-Preise migrieren, bevor ein Tier-Test gewährt wird.",
          "noSubscription": "Vor Tier-Tests zuerst ein Stripe-Abo erstellen.",
          "notActive":
            "Tier-Tests können nur für aktive bezahlte Abos gewährt werden.",
          "trialing":
            "Die reguläre Stripe-Testphase gibt bereits vollen kommerziellen Zugriff.",
        },
      },
      "tabs": {
        "discount": "Rabatt",
        "overview": "Übersicht",
        "provision": "Bereitstellung",
        "trial": "Tier-Test",
      },
    },
    "trials": {
      "active": {
        "endEarly": "Sofort beenden",
        "expiresAt": "Endet am",
        "expiresInDays_one": "Endet in {{count}} Tag",
        "expiresInDays_other": "Endet in {{count}} Tagen",
        "grantedBy": "Gewährt von",
        "reason": "Begründung",
        "tier": "Getestetes Tier",
        "title": "Aktiver Test",
      },
      "form": {
        "duration": {
          "description": "Endet automatisch am {{expires}}.",
          "label": "Laufzeit",
          "preset_one": "{{count}} Tag",
          "preset_other": "{{count}} Tage",
        },
        "reason": {
          "description":
            "Wird an der Praxis für den Audit-Trail gespeichert. Keine Patientendaten eintragen.",
          "label": "Begründung",
          "placeholder": 'z. B. „Kunde möchte Pro vor dem Wechsel testen"',
        },
        "submit": "Test gewähren",
        "tier": {
          "label": "Welches Tier soll getestet werden?",
          "perMonth": "Monat",
        },
        "title": "Neuen Tier-Test gewähren",
      },
      "preview": {
        "billingUnchanged": "Abrechnung bleibt im aktuell bezahlten Tier",
        "current": "Aktuell:",
        "duringTrial": "Während des Tests:",
        "noTierSelected": "Noch kein Tier ausgewählt.",
        "revertsOn": "Zurücksetzung am",
        "title": "Vorschau",
      },
      "sectionTitle": "Tier-Tests",
      "subheading":
        "Temporärer Dentero-Feature-Zugang mit automatischer Rückkehr. Stripe-Abrechnung bleibt unverändert.",
    },
  },
  "aiRequests": {
    "attemptsCount_one": "{{count}} Versuch",
    "attemptsCount_other": "{{count}} Versuche",
    "columns": {
      "actions": "Aktionen",
      "cost": "Kosten",
      "createdAt": "Erstellt am",
      "duration": "Dauer",
      "status": "Status",
      "type": "Typ",
    },
    "costUnknown": "Unbekannt",
    "dialog": {
      "compactedNotice":
        "Debug-Payloads und ungenutzte Response-Felder wurden nach 7 Tagen entfernt. Kostenmetadaten bleiben erhalten.",
      "noRawResponse": "Keine Raw Response verfügbar.",
      "noTextData": "Keine Textdaten verfügbar.",
      "noTextProperties": "Keine Text-Eigenschaften gefunden.",
      "noTraceData": "Keine Trace-Daten verfügbar.",
      "triggerLabel": "AI",
    },
    "durationBreakdown": {
      "processing": "Dateiverarbeitung: {{seconds}} s",
      "transcribe": "Transkriptions-Aufruf: {{seconds}} s",
    },
    "openInLangfuse": "Trace in Langfuse öffnen",
    "openSessionInLangfuse": "Session in Langfuse öffnen",
    "openSessionInLangfuseLegacy": "Session ohne Laufnummer in Langfuse öffnen",
    "openSessionInLangfuseRun": "Session {{run}} in Langfuse öffnen",
    "statusLabels": {
      "completed": "Abgeschlossen",
      "failed": "Fehlgeschlagen",
      "pending": "Ausstehend",
      "unknown": "Unbekannt",
    },
    "title": "AI-Anfragen",
    "toggleHistory": "Verlauf ein-/ausblenden",
    "totalCost": "{{cost}}",
    "totalDuration": "{{seconds}} Sekunden",
    "typeLabels": {
      "ComplexTemplateRendering": "Komplex-Vorlagen",
      "GkvAnalogSuggestion": "GKV-Analogvorschlag",
      "GkvAnnotation": "GKV-Annotation",
      "GkvLaboratoryServiceSuggestion": "GKV-Laborleistungsvorschlag",
      "GkvSuggestion": "GKV-Vorschlag",
      "ImprovedDocumentation": "Verbesserte Dokumentation",
      "MaterialDetection": "Materialerkennung",
      "PatientBriefing": "Patienten-Briefing",
      "PkvAnalogSuggestion": "PKV-Analogvorschlag",
      "PkvAnnotation": "PKV-Annotation",
      "PkvLaboratoryServiceSuggestion": "PKV-Laborleistungsvorschlag",
      "PkvSuggestion": "PKV-Vorschlag",
      "PlausibilityCheck": "Plausibilitätsprüfung",
      "Pseudonymization": "Pseudonymisierung",
      "StructuredDocumentation": "Strukturierte Dokumentation",
      "TranscriptCorrection": "Transkriptkorrektur",
      "Transcription": "Transkription",
    },
    "unpricedRequestsNotice_one":
      "({{count}} Anfrage konnte nicht bepreist werden)",
    "unpricedRequestsNotice_other":
      "({{count}} Anfragen konnten nicht bepreist werden)",
    "words": {
      "count": "Wörter:",
      "duration": "Dauer:",
      "hint": "Für Konfidenz + Zeitstempel über ein Wort fahren.",
      "legendHigh": "hoch (≥ {{ceiling}})",
      "legendLow": "niedrige Konfidenz",
      "legendMedium": "mittel",
      "noData": "Keine Zeitdaten auf Wortebene für diese Anfrage.",
      "overallConfidence": "Gesamtkonfidenz:",
      "tooltip": "Konfidenz {{confidence}} % · {{start}}–{{end}}",
      "tooltipPlayable":
        "Konfidenz {{confidence}} % · {{start}}–{{end}} · zum Abspielen klicken",
      "tooltipWithSpeaker":
        "Konfidenz {{confidence}} % · {{start}}–{{end}} · Sprecher {{speaker}}",
      "tooltipWithSpeakerPlayable":
        "Konfidenz {{confidence}} % · {{start}}–{{end}} · Sprecher {{speaker}} · zum Abspielen klicken",
    },
  },
  "analogPositionImports": {
    "new": {
      "description":
        "Lädt Analogpositionen aus einer CSV-Datei in diese Praxis. Vor dem Import werden alle Zeilen zur Prüfung angezeigt.",
      "downloadTemplate": "Vorlage herunterladen",
      "fileLabel": "CSV-Datei",
      "formatHint":
        "Eine Zeile pro Analogposition. Die Beschreibung muss in der Datei eindeutig sein. Regelwerk ist GOZ oder GOÄ, der Faktor liegt zwischen 1,0 und 3,5. Trennzeichen Semikolon oder Komma, Kodierung UTF-8.",
      "submit": "Datei prüfen",
    },
    "preview": {
      "columns": {
        "amount": "Betrag",
        "description": "Beschreibung",
        "factor": "Faktor",
        "reference": "Referenzposition",
        "status": "Status",
      },
      "description":
        "Prüfen Sie die Zeilen und passen Sie bei Bedarf den Faktor an. Nur ausgewählte Zeilen werden importiert.",
      "selectAll": "Alle auswählen",
      "selectRow": "Zeile auswählen",
      "submit_one": "{{count}} Position importieren",
      "submit_other": "{{count}} Positionen importieren",
      "title": "Import prüfen",
    },
    "status": {
      "error": "Fehler",
      "new": "Neu",
      "unchanged": "Unverändert",
      "update": "Änderung",
    },
    "title": "Analogpositionen importieren",
  },
  "analogPositions": {
    "details": {
      "deleteDescription":
        "Die Analogposition wird aus dem Katalog entfernt. Zugehörige Praxis-Setups werden gelöscht. Bereits erfasste Abrechnungspositionen bleiben erhalten, sind dann aber nicht mehr mit diesem Setup verknüpft.",
      "deleteTitle": "Analogposition löschen?",
      "descriptionLabel": "Leistungsbeschreibung",
      "usageDescription_one":
        "Diese Analogposition ist in {{count}} Praxis-Setup konfiguriert.",
      "usageDescription_other":
        "Diese Analogposition ist in {{count}} Praxis-Setups konfiguriert.",
      "usageTitle": "Verwendung",
    },
    "form": {
      "description":
        "Der globale Katalog enthält nur die Leistungsbeschreibungen. Kosten werden in den Praxiseinstellungen konfiguriert.",
      "descriptionLabel": "Leistungsbeschreibung",
      "editTitle": "Analogposition bearbeiten",
      "newTitle": "Neue Analogposition anlegen",
    },
    "index": {
      "add": "Analogposition hinzufügen",
      "description": "Leistungsbeschreibung",
      "usage": "Praxis-Setups",
    },
  },
  "assistants": {
    "edit": {
      "contentLabel": "Inhalt",
      "contentPlaceholder": "Inhalt für diesen Assistenten...",
    },
    "form": {
      "classificationPlaceholder": "Klassifikation auswählen...",
      "description":
        "Wählen Sie die Behandlungsklassifikation aus, für die Sie einen Assistenten erstellen möchten.",
      "newTitle": "Neuer Assistent",
    },
    "index": {
      "add": "Hinzufügen",
      "deleteDescription":
        "Möchten Sie diesen Assistenten wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
      "deleteTitle": "Assistent löschen",
      "empty": "Noch keine Assistenten vorhanden.",
      "updatedAt": "Aktualisiert:",
    },
    "selector": {
      "sections_one": "{{count}} Abschnitt",
      "sections_other": "{{count}} Abschnitte",
      "title": "Dokumentationsassistent wählen",
    },
    "teleprompter": {
      "empty": "Kein Inhalt vorhanden.",
      "fontSize": {
        "decrease": "Schrift verkleinern",
        "increase": "Schrift vergrößern",
      },
      "mode": {
        "read": "Lesemodus",
        "teleprompter": "Auto-Scroll",
      },
      "pause": "Anhalten",
      "resume": "Weiterscrollen",
    },
  },
  "audioRecorder": {
    "chunkPersistenceError":
      "Die Aufnahme konnte nicht lokal zwischengespeichert werden.",
    "micFallback":
      "Ausgewähltes Mikrofon nicht verfügbar. Aufnahme erfolgt über das Standardmikrofon.",
    "microphoneAccessDenied": "Zugriff auf Mikrofone nicht erlaubt.",
    "microphoneInUse":
      "Das Mikrofon wird von einer anderen Anwendung verwendet. Bitte schließen Sie sie und versuchen Sie es erneut.",
    "microphoneNoAudio":
      "Das Mikrofon liefert keinen Ton, die Aufnahme wurde nicht gestartet. Schließen Sie andere Programme, die das Mikrofon verwenden, oder wählen Sie ein anderes Mikrofon.",
    "noMicrophoneFound": "Kein Mikrofon gefunden.",
    "startFailed": "Die Aufnahme konnte nicht gestartet werden.",
    "storageQuotaExceeded":
      "Der lokale Speicher ist fast voll. Laden Sie gespeicherte Aufnahmen hoch oder entfernen Sie sie, um Platz zu schaffen.",
    "unsupported": "Audio-Aufnahme ist in diesem Browser nicht verfügbar.",
  },
  "auth": {
    "forgotPassword": {
      "backToLogin": "Zurück zur Anmeldung",
      "submit": "Jetzt Passwort zurücksetzen",
      "title": "Passwort vergessen?",
    },
    "resetPassword": {
      "newPassword": "Neues Passwort",
      "passwordMismatch": "Passwörter müssen übereinstimmen",
      "title": "Passwort ändern",
    },
    "signIn": {
      "bookDemo": "Jetzt Demo buchen",
      "forgotPassword": "Passwort vergessen?",
      "noAccessYet": "Noch keinen Zugang?",
      "rememberMe": "Angemeldet bleiben",
      "title": "Bei {{brand}} anmelden",
    },
  },
  "benchmarks": {
    "artifacts": {
      "noDebug": "Für diese Auswahl sind noch keine Debug-Artefakte verfügbar.",
    },
    "cases": {
      "editableModelInput": "Bearbeitbare Modelleingabe",
      "expectedLabels": "Erwartete Labels",
      "openFullInput": "Vollständige Eingabe öffnen",
      "readOnlyPreview":
        "Schreibgeschützte Vorschau der Benutzernachricht, die an das Modell gesendet wird.",
      "review": "Review",
      "treatment": "Behandlung",
    },
    "edit": {
      "editFullSystemMessage": "Vollständige Systemnachricht bearbeiten",
      "meta":
        "{{insurance}} · {{model}} · {{sampleCount}} Fälle · Erstellt von {{creator}} · {{createdAt}}",
      "run": "Benchmark ausführen",
    },
    "new": {
      "caseCount": "Anzahl Fälle",
      "lockedSetup":
        "Die Benchmark-Konfiguration ist nach der Vorbereitung gesperrt. Wenn Sie später einen anderen {{insurance}}-Lauf benötigen, bereiten Sie einen neuen Benchmark vor.",
      "model": "Modell",
      "prepare": "Benchmark vorbereiten",
    },
    "runSummary": {
      "cases": "Fälle",
      "created": "Erstellt",
      "creator": "Ersteller",
      "failureMessage": "Fehlermeldung",
      "providerBatchId": "Provider-Batch-ID",
      "status": "Status",
    },
    "show": {
      "cancelBatch": "Batch abbrechen",
      "meta":
        "{{insurance}} · {{model}} · Provider: {{provider}} · {{sampleCount}} Fälle · Erstellt von {{creator}} · {{createdAt}}",
    },
    "tabs": {
      "billing": "Abrechnungs-Benchmarks",
      "transcription": "Transkriptions-Benchmarks",
    },
    "workspace": {
      "deleteDraft": "Entwurf löschen",
      "f1": "F1",
      "noRunsYet": "Noch keine Benchmark-Läufe.",
    },
  },
  "billingPositions": {
    "addMissing": "Fehlende Position hinzufügen",
    "addMissingLaboratory": "Fehlende Laborleistung hinzufügen",
    "addPosition": "Position hinzufügen",
    "aiConfidence": "KI-Konfidenz: {{value}}%",
    "analog": {
      "configuredAmount": "Konfigurierter Betrag: {{amount}}",
      "group": "Analogleistungen",
      "tooltip": "Analogleistung",
      "tooltipWithDescription": "Analogleistung: {{description}}",
    },
    "bulkActionFailed":
      "Nicht alle Positionen konnten aktualisiert werden. Bitte versuchen Sie es erneut.",
    "card": {
      "commentPreview": "Kommentar",
      "deleteRegion": "Position für Region {{region}} löschen",
      "editRegion": "Position für Region {{region}} bearbeiten",
      "editRegionComment": "Kommentar für Region {{region}} bearbeiten",
      "includeRegion": "Position für Region {{region}} hinzufügen",
      "markRegionCorrect": "Region {{region}} als korrekt markieren",
      "markRegionIncorrect": "Region {{region}} als falsch markieren",
      "openPosition": "Position {{code}} öffnen",
      "openRegion": "Position {{code}} für Region {{region}} öffnen",
      "regionCommentPreview": "Kommentar ({{region}})",
      "regionDetails": "Zähne in dieser Region",
      "showLess": "Weniger anzeigen",
      "showMore": "Mehr anzeigen",
    },
    "conflict": {
      "confirm": "Trotzdem hinzufügen",
      "description":
        "Die Position {{position}} steht im Ausschlusskonflikt mit {{conflicts}} in unserer Datenbank.",
      "followup":
        "Möchten Sie sie trotzdem als fehlende Position hinzufügen? Bitte ergänzen Sie einen Kommentar zur Begründung.",
      "mutualExclusion": "{{a}} und {{b}} schließen sich gegenseitig aus.",
      "pluralTitle": "Ausschluss-Konflikte erkannt",
      "title": "Ausschluss-Konflikt erkannt",
    },
    "countTooltip_one": "{{label}}: {{count}} Position",
    "countTooltip_other": "{{label}}: {{count}} Positionen",
    "delete": {
      "description": 'Möchten Sie die Position "{{code}}" wirklich löschen?',
      "descriptionWithRegion_one":
        'Möchten Sie die Position "{{code}}" für Region {{region}} wirklich löschen?',
      "descriptionWithRegion_other":
        'Möchten Sie die Position "{{code}}" für Region {{region}} wirklich löschen? Alle {{count}} Leistungen dieser Karte werden entfernt.',
      "title": "Position löschen",
    },
    "drawer": {
      "analogChargedAmount": "Abrechnungsbetrag",
      "analogTitle": "Analogleistung",
    },
    "edit": {
      "factor": "Faktor",
      "justification": "Begründung",
      "justificationCatalog": "Vordefinierte Begründung",
      "justificationCatalogPlaceholder": "Begründung auswählen",
      "justificationPlaceholder": "Begründung für die Faktorsteigerung...",
      "justificationRequired":
        "Bei einem Faktor über 2,3 ist eine Begründung erforderlich.",
      "region": "Zähne / Region",
      "regionHint":
        "Geben Sie einzelne Zähne oder Bereiche nach FDI an, z. B. 14, 15 oder 15-13.",
      "regionMissing": "Zahnangabe fehlt",
      "regionPerPositionHint":
        "Die Zähne werden je Position geführt und lassen sich für die gesamte Karte nicht gemeinsam ändern.",
      "regionPlaceholder": "z. B. 14, 15 oder 15-13",
      "surfaces": "Flächen",
      "surfacesHint_one": "Anzahl muss zum Code passen ({{count}} Fläche).",
      "surfacesHint_other": "Anzahl muss zum Code passen ({{count}} Flächen).",
      "surfacesHintMin_one":
        "Anzahl muss zum Code passen (mindestens {{count}} Fläche).",
      "surfacesHintMin_other":
        "Anzahl muss zum Code passen (mindestens {{count}} Flächen).",
      "surfacesMissing": "Flächenangabe fehlt",
      "surfacesUnitHint":
        "Flächen beschreiben die Kavität bzw. die Gebührenstufe und sind keine eigene Abrechnungseinheit.",
      "title": "Position bearbeiten: {{code}}",
      "tooth": "Zahn",
      "toothHint": "Geben Sie genau einen Zahn an (FDI).",
      "toothPlaceholder": "z. B. 14",
    },
    "emptyState": {
      "description":
        'Die KI konnte aus der Dokumentation keine Positionen ableiten. Fügen Sie bei Bedarf über "{{addLabel}}" manuell Positionen hinzu.',
      "title": "Keine Abrechnungspositionen",
    },
    "experimentalAlert": {
      "bulletLiability":
        "Dentero übernimmt keine Haftung für die Richtigkeit der Abrechnungsvorschläge.",
      "bulletReport":
        'Nutzen Sie die "Melden"-Funktion, wenn Ihnen die Vorschläge fehlerhaft erscheinen.',
      "bulletVerify":
        "Überprüfen Sie die Vorschläge auf Plausibilität und passen Sie sie bei Bedarf an.",
      "dismiss": "Ich habe verstanden, Hinweis ausblenden.",
      "intro":
        "Die Erstellung der Abrechungsvorschläge ist eine KI-Funktion die sich derzeit in Test und Entwicklung befindet. Die KI kann und wird Fehler machen.",
      "title": "Experimentelle Abrechnungsvorschläge",
    },
    "factorIncrease": "Faktorsteigerung:",
    "grandTotal": {
      "label": "Gesamt",
      "total": "Gesamt {{amount}}",
    },
    "laboratory": {
      "countInstances_one": "{{count}} erkannte Instanz",
      "countInstances_other": "{{count}} erkannte Instanzen",
      "countShort_one": "{{count}} Laborleistung",
      "countShort_other": "{{count}} Laborleistungen",
      "delete": {
        "description":
          'Möchten Sie die Laborleistung "{{code}}" wirklich entfernen?',
        "title": "Laborleistung entfernen",
      },
      "drawer": {
        "confidence": "KI-Konfidenz",
        "count": "Anzahl",
        "position": "Position",
        "serviceType": "Leistungsart",
        "source": "Quelle",
        "title": "Laborleistung {{code}}",
      },
      "editCount": "Anzahl bearbeiten",
      "eigenlabor": "Eigenlabor",
      "fremdlabor": "Fremdlabor",
      "source": "Diese Laborleistung wurde automatisch erkannt.",
      "sourceComplex":
        "Diese Laborleistung wurde aus einem Komplex übernommen.",
      "sourceManual": "Diese Laborleistung wurde manuell hinzugefügt.",
      "title": "Laborleistungen",
      "total": "Summe {{amount}}",
    },
    "materials": {
      "delete": {
        "description":
          'Möchten Sie das Material "{{name}}" wirklich entfernen?',
        "title": "Material entfernen",
      },
      "drawer": {
        "count": "Anzahl",
        "unitPrice": "Stückpreis",
        "unitPricePlaceholder": "z. B. 0,67",
      },
      "edit": "Material bearbeiten",
      "noPrice": "Kein Preis",
      "title": "Materialien",
      "total": "Summe {{amount}}",
      "unitPrice": "Stückpreis",
      "untitled": "Material",
    },
    "missingPositionTooltip": "Fehlende Position (für Review hinzugefügt)",
    "mkv": {
      "badge": "MKV",
      "payerSplit": {
        "kasse": "Kasse (BEMA)",
        "note":
          "Die BEMA-Füllung ist im Preis der GOZ-Füllung enthalten und wird von der Kasse übernommen. Der Patientenanteil ist ein ungefährer Wert.",
        "patient": "Patient (ca.)",
        "trigger": "Kostenaufteilung anzeigen",
      },
      "tooltip":
        "Diese GOZ-Position ist eine Füllung oder Einlagefüllung, die unter die Mehrkostenregelung fällt, und erfordert bei einem gesetzlich versicherten (GKV) Patienten eine Mehrkostenvereinbarung.",
    },
    "previouslyBilled": {
      "badge": "Bereits abgerechnet",
      "tooltip":
        "Bereits am {{date}} für diese:n Patient:in abgerechnet. Diese Position ist {{window}} nur begrenzt erneut abrechenbar.",
      "viewTreatment": "Zur vorherigen Behandlung",
      "window": {
        "same_calendar_year": "innerhalb eines Kalenderjahres",
        "same_day": "am selben Tag",
        "same_half_year": "innerhalb eines Kalenderhalbjahres",
        "same_quarter": "innerhalb eines Quartals",
        "within_four_months": "innerhalb von vier Monaten",
        "within_two_calendar_years": "innerhalb von zwei Kalenderjahren",
      },
    },
    "review": {
      "commentLabel": "Kommentar",
      "done": "Fertig",
      "editComment": "Kommentar bearbeiten",
      "incorrectCommentDescription":
        "Erläutern Sie kurz, warum dieser KI-Vorschlag nicht korrekt ist.",
      "incorrectCommentPlaceholder":
        "Warum ist dieser Vorschlag nicht korrekt?",
      "incorrectCommentTitle": "Kommentar zur falschen Position",
      "lowConfidence_one": "Unsicherer Vorschlag ({{count}})",
      "lowConfidence_other": "Unsichere Vorschläge ({{count}})",
      "markAllCorrect": "Alle als richtig markieren",
      "markCorrect": "Als richtig markieren",
      "markIncorrect": "Als falsch markieren",
      "missingCommentDescription":
        "Erläutern Sie kurz, warum diese Position im Vorschlag fehlt.",
      "missingCommentPlaceholder": "Warum fehlt diese Position?",
      "missingCommentTitle": "Kommentar zur fehlenden Position",
      "modeDescription":
        "Bewerten Sie die KI-Vorschläge mit Daumen hoch oder runter. Ihr Review dient ausschließlich zur Verbesserung der KI und hat keinen Einfluss auf Ihre Dokumentation.",
      "modeTitle": "Review-Modus",
      "noMissingPositions": "Keine Positionen fehlen",
      "positionsEvaluated":
        "{{evaluatedCount}} von {{aiPositionsCount}} Positionen bewertet",
      "submitReview": "Review senden",
      "unknownPosition": "Unbekannte Position",
      "withoutTitle": "Ohne Titel",
    },
    "services": {
      "titlePrivate": "Privatabrechnung (GOZ/GOÄ)",
      "titlePublic": "Kassenabrechnung (BEMA)",
      "total": "Summe {{amount}}",
    },
    "source": {
      "ai": "Diese Position wurde automatisch erkannt.",
      "complex":
        "Diese Position stammt aus einem Komplex; die KI hat sie anhand der Dokumentation bewertet.",
      "manual": "Diese Position wurde manuell hinzugefügt.",
    },
    "surfaces": {
      "CERVICAL": "Zervikal",
      "DISTAL": "Distal",
      "INCISAL": "Inzisal",
      "MESIAL": "Mesial",
      "OCCLUSAL": "Okklusal",
      "ORAL": "Oral",
      "VESTIBULAR": "Vestibulär",
    },
    "table": {
      "count": "Anzahl",
      "factor": "Faktor",
      "position": "Position",
      "region": "Region",
      "titleAndExplanation": "Titel und Erklärung",
    },
    "tabs": {
      "analog": "Analog",
      "laboratory": "Labor",
      "materials": "Material",
      "positions": "GOÄ/GOZ",
      "positionsPrivate": "GOZ/GOÄ",
      "positionsPublic": "BEMA/GOZ/GOÄ",
    },
    "truncatedResults":
      "{{shown}} von {{total}} Treffern – bitte grenzen Sie die Suche weiter ein.",
  },
  "billingReviews": {
    "categories": {
      "billing": "Abrechnung",
      "laboratory": "Labor",
    },
    "deletedUser": "Gelöschter Nutzer",
    "empty": "Noch keine Reviews vorhanden.",
    "emptyBilling": "Noch keine Abrechnungs-Reviews vorhanden.",
    "emptyLaboratory": "Noch keine Labor-Reviews vorhanden.",
    "export": "Exportieren",
    "filters": {
      "allInsurance": "Alle",
    },
    "metrics": {
      "f1": {
        "description": "Gesamtqualität der AI",
        "footer": "Kombiniert Precision und Recall zu einer Gesamtnote",
      },
      "precision": {
        "description": "Wie oft liegt die AI richtig",
        "footer": "Von allen AI-Vorschlägen: wie viele waren korrekt",
      },
      "recall": {
        "description": "Wie viel findet die AI",
        "footer": "Von allen nötigen Positionen: wie viele hat die AI gefunden",
      },
    },
    "noResults": "Keine Reviews mit diesen Filtern gefunden.",
    "resetFilters": "Filter zurücksetzen",
    "searchPlaceholder": "Suche nach Patient, Praxis oder Reviewer",
    "show": {
      "evalTable": {
        "code": "Code",
        "comment": "Kommentar",
        "status": "Status",
        "targetTypes": {
          "analog": "Analog",
          "laboratory": "Labor",
        },
        "title": "Titel",
        "type": "Typ",
      },
      "reviewerComment": "Kommentar vom Reviewer",
      "viewRecording": "Aufnahme ansehen",
    },
    "statusBadges": {
      "correct": "OK",
      "incorrect": "Fehler",
      "missing": "Fehlt",
    },
    "table": {
      "actions": "Aktionen",
      "category": "Bereich",
      "createdAt": "Erstellt",
      "insurance": "Versicherung",
      "practice": "Praxis",
      "ratings": "Bewertungen",
      "recordingId": "Aufnahme-ID",
      "reviewer": "Reviewer",
      "reviewId": "Review-ID",
    },
  },
  "chatReport": {
    "alreadyReported": "Eine Meldung wurde bereits am {{at}} gesendet.",
    "description":
      "Beschreiben Sie, was an den Antworten nicht stimmt. Das Dentero-Team sieht sich den Chat an.",
    "sent": "Chat gemeldet",
    "submit": "Meldung absenden",
    "title": "Chat melden",
    "trigger": "Melden",
  },
  "chats": {
    "index": {
      "columns": {
        "cost": "Kosten",
        "lastActivity": "Letzte Aktivität",
        "messages": "Nachrichten",
        "practice": "Praxis",
        "recording": "Aufnahme",
        "user": "Benutzer",
      },
      "empty": "Noch keine Chats vorhanden.",
      "openRecording": "Aufnahme öffnen",
      "searchPlaceholder": "Nachrichten durchsuchen …",
    },
    "show": {
      "cost": "Kosten: {{cost}}",
      "empty": "Diese Unterhaltung enthält keine Nachrichten.",
      "lastActivity": "Letzte Aktivität: {{date}}",
      "messages_one": "{{count}} Nachricht",
      "messages_other": "{{count}} Nachrichten",
      "openRecording": "Aufnahme öffnen",
    },
  },
  "checkout": {
    "practiceSuccess": {
      "description":
        "Das Dentero-Abonnement für {{practiceName}} wurde erfolgreich abgeschlossen.",
      "readyDescription":
        "Sie können sich mit Ihrem bestehenden Konto anmelden und Dentero wie gewohnt nutzen.",
      "readyTitle": "Dentero ist bereit",
      "title": "Abonnement aktiviert",
    },
    "success": {
      "emailDescription":
        "Wir haben Ihnen eine E-Mail gesendet, um Ihr Passwort festzulegen und Ihr Konto zu aktivieren.",
      "emailHeading": "Prüfen Sie Ihren Posteingang",
      "loginLink": "Zur Anmeldung",
      "subtitle": "Ihre Registrierung war erfolgreich.",
      "title": "Willkommen bei Dentero!",
    },
  },
  "combobox": {
    "clearSelection": "Auswahl zurücksetzen",
    "create": '"{{label}}" erstellen',
    "empty": "Nichts gefunden.",
    "placeholder": "Wählen...",
    "search": "Suchen...",
  },
  "common": {
    "accessibility": {
      "breadcrumb": "Brotkrumen",
      "carousel": "Karussell",
      "more": "Mehr",
      "nextSlide": "Nächste Folie",
      "previousSlide": "Vorherige Folie",
      "slide": "Folie",
      "toggleSidebar": "Seitenleiste ein-/ausblenden",
    },
    "actions": {
      "activate": "Aktivieren",
      "add": "Hinzufügen",
      "apply": "Anwenden",
      "back": "Zurück",
      "cancel": "Abbrechen",
      "close": "Schließen",
      "copy": "Kopieren",
      "deactivate": "Deaktivieren",
      "delete": "Löschen",
      "download": "Herunterladen",
      "edit": "Bearbeiten",
      "install": "Installieren",
      "later": "Später",
      "login": "Anmelden",
      "remove": "Entfernen",
      "reset": "Zurücksetzen",
      "resetPassword": "Passwort zurücksetzen",
      "save": "Speichern",
      "updatePassword": "Passwort ändern",
    },
    "answers": {
      "no": "Nein",
      "yes": "Ja",
    },
    "appName": "Dentero",
    "brands": {
      "dentero": "Dentero",
      "dzr": "Dentero DZR Edition",
    },
    "filters": {
      "all": "Alle",
    },
    "labels": {
      "currentPassword": "Aktuelles Passwort",
      "email": "E-Mail-Adresse",
      "firstName": "Vorname",
      "lastName": "Nachname",
      "password": "Passwort",
      "passwordConfirmation": "Passwort bestätigen",
      "patientId": "Patient-ID",
      "practice": "Praxis",
      "recordedAt": "Aufgezeichnet am",
      "recordedBy": "Aufgezeichnet von",
      "role": "Rolle",
      "title": "Titel",
      "treatmentDate": "Behandlungsdatum",
      "username": "Benutzername",
    },
    "pagination": {
      "ariaLabel": "Seitennavigation",
      "goToFirstPage": "Zur ersten Seite",
      "goToLastPage": "Zur letzten Seite",
      "goToNextPage": "Zur nächsten Seite",
      "goToPreviousPage": "Zur vorherigen Seite",
      "next": "Nächste",
      "pageOf": "Seite {{page}} von {{last}}",
      "previous": "Vorige",
    },
    "states": {
      "active": "Aktiv",
      "admin": "Admin",
      "adminOnlyHint": "Nur für Admins sichtbar",
      "archived": "Archiviert",
      "details": "Details",
      "inactive": "Inaktiv",
      "loading": "Lädt...",
      "new": "Neu",
      "noPractice": "Keine Praxis",
      "unknown": "Unbekannt",
    },
    "themes": {
      "dentero": "Dentero",
      "dzr": "Dentero DZR Edition",
    },
  },
  "community": {
    "join": {
      "cancel": "Abbrechen",
      "consent":
        "Ich bin einverstanden, dass Dentero für mich ein Forumskonto mit meiner E-Mail-Adresse {{email}} anlegt. Andere Mitglieder sehen meine E-Mail-Adresse nicht.",
      "description":
        "Wir legen für Sie ein Konto in unserem Forum an. Sie melden sich dort mit Ihrem Dentero-Konto an.",
      "submit": "Konto erstellen",
      "title": "Der Dentero Community beitreten",
      "usernameHint":
        "Für andere Mitglieder sichtbar. 3 bis 20 Zeichen: Buchstaben, Ziffern, Punkt, Bindestrich und Unterstrich. Verwenden Sie nicht Ihren echten Namen, wenn Sie anonym bleiben möchten.",
      "usernameInvalid":
        "Nur 3 bis 20 Buchstaben, Ziffern, Punkte, Bindestriche oder Unterstriche. Am Ende muss ein Buchstabe oder eine Ziffer stehen, Punkt und Bindestrich nicht am Anfang oder doppelt.",
      "usernameLabel": "Forumsname",
    },
    "joined": {
      "description":
        "Ihr Forumsname ist {{username}}. Beim ersten Öffnen schickt Ihnen das Forum eine E-Mail, mit der Sie Ihre Adresse bestätigen. War der Name schon vergeben, hängt das Forum eine Zahl an.",
      "open": "Community öffnen",
      "title": "Ihr Forumskonto ist bereit",
    },
  },
  "complexes": {
    "ai": {
      "contentLabel": "Inhalt",
      "contentPlaceholder": "Inhalt für diesen Komplex ...",
      "createWithAi": "Mit KI erstellen",
      "improveContent": "Inhalt verbessern",
      "improveWithAi": "Mit KI verbessern",
      "improving": "KI verbessert Inhalt ...",
      "missingTriggers": "Trigger-Wörter eingeben, um Inhalt zu generieren.",
      "moreActions": "Weitere KI-Aktionen",
      "prefilling": "KI erstellt Inhalt ...",
      "recreate": "Neu erstellen ...",
      "recreateConfirm": "Neu erstellen",
      "recreateDescription":
        "Der bisherige Inhalt wird vollständig überschrieben. Fortfahren?",
      "recreateTitle": "Inhalt neu erstellen",
    },
    "badges": {
      "archived": "(archiviert)",
      "suggestOnly": "Nur Vorschlag",
    },
    "billingPositionEdit": {
      "countNotRepeatable":
        "Diese Position ist nur einmal je Behandlung oder je Zahn abrechenbar. Ein Komplex enthält sie deshalb einmal.",
      "factorPlaceholder": "z. B. 2,3",
      "freeTextJustificationsLabel": "Freitext-Begründungen (eine pro Zeile)",
      "loadingJustifications": "Lade Begründungen...",
      "noPredefinedJustifications":
        "Keine vordefinierten Begründungen vorhanden.",
      "predefinedJustificationsLabel": "Vordefinierte Begründungen",
    },
    "billingSection": {
      "emptyTitle": "Keine Positionen hinterlegt",
      "exclusionWarningItem":
        "{{a}} und {{b}} werden üblicherweise nicht gemeinsam abgerechnet.",
      "exclusionWarningTitle": "Hinweis zu möglichen Ausschlüssen",
      "intro":
        "Positionen werden zu den Abrechnungsvorschlägen hinzugefügt, sobald der Komplex angewendet wird.",
    },
    "checklist": {
      "actions": "Aktionen für {{name}}",
      "add": "Komplex hinzufügen",
      "addEmpty": "Keine weiteren Komplexe gefunden.",
      "addSearch": "Komplex suchen",
      "appliedCount_one": "{{count}} angewendet",
      "appliedCount_other": "{{count}} angewendet",
      "apply": "Übernehmen",
      "applying": "wird übernommen …",
      "complete": "vollständig",
      "detected": "Erkannt: „{{reason}}“ · Konfidenz {{confidence}} %",
      "detectedNoReason": "Konfidenz {{confidence}} %",
      "detecting": "Komplexe werden erkannt …",
      "editInSettings": "Komplex in den Einstellungen bearbeiten",
      "inStructured": "Strukt. Doku",
      "kindInText": "im Text",
      "kindReport": "Bericht",
      "kindTemplate": "Vorlage",
      "merged": "eingearbeitet",
      "openSlots_one": "{{count}} offen",
      "openSlots_other": "{{count}} offen",
      "pendingRemoval": "wird beim Neuerstellen entfernt",
      "refill": "Vorlage neu füllen",
      "refillReport": "Bericht neu erstellen",
      "remove": "Komplex entfernen",
      "removed": "entfernt",
      "report": "als Bericht verfasst",
      "restore": "Wiederherstellen",
      "suggestion": "Vorschlag",
      "suggestionCount_one": "{{count}} Vorschlag",
      "suggestionCount_other": "{{count}} Vorschläge",
    },
    "dialog": {
      "archivedSuffix": " (wird nicht mehr angewendet)",
      "description": "Inhalt des Dokumentationskomplexes",
      "loading": "Lade Inhalt...",
    },
    "edit": {
      "autoApply": "Automatisch anwenden",
      "autoApplyHint":
        "Ausgeschaltet bleibt der Komplex ein Vorschlag, den Sie mit einem Klick anwenden.",
      "billingTabPrefix": "Abrechnung",
      "detectionTitle": "Erkennung",
      "editTrigger": "„{{trigger}}“ bearbeiten",
      "emptyContent": "Kein Inhalt vorhanden.",
      "formErrorTitle": "Komplex konnte nicht gespeichert werden",
      "includeInStructured": "In strukturierte Dokumentation übernehmen",
      "includeInStructuredHint":
        "Die KI übernimmt die Inhalte der ausgefüllten Vorlage in die passenden Felder der strukturierten Dokumentation.",
      "mergeIntoDocumentation": "In Dokumentation übernehmen",
      "mergeIntoDocumentationHint":
        "Ausgeschaltet erscheint der Bericht als eigener Abschnitt unter der Dokumentation, statt in die verbesserte Fassung eingearbeitet zu werden. Gilt für neue Aufnahmen.",
      "promptTab": "Prompt",
      "removeTrigger": "„{{trigger}}“ entfernen",
      "tabHasErrors": "Enthält Fehler",
      "triggerWordsHint":
        "Möglichst spezielle Fachbegriffe, keine Alltagswörter. Mit Enter oder Komma trennen. Zum Bearbeiten einen Begriff anklicken.",
      "triggerWordsPlaceholder": "z. B. Extraktion, Ost",
      "unsavedActionMessage": "Es gibt ungespeicherte Änderungen.",
    },
    "form": {
      "continue": "Weiter",
      "description":
        "Verwenden Sie als Trigger-Wörter möglichst spezielle Begriffe (keine häufigen Alltagswörter). Vermeiden Sie Abkürzungen. Je mehr Kontext, desto besser. Mehrere Trigger mit Enter oder Komma trennen.",
      "newTitle": "Neuer Komplex anlegen",
      "prefillWithAi": "Passenden Inhalt mit KI vorschlagen",
      "triggerWordsLabel": "Trigger-Wörter",
      "triggerWordsPlaceholder": "z. B. Extraktion, PSI",
    },
    "index": {
      "activateDescription":
        "Möchten Sie diesen archivierten Komplex wieder aktivieren?",
      "activateTitle": "Komplex aktivieren",
      "add": "Hinzufügen",
      "archiveAction": "Archivieren",
      "archiveDescription":
        "Möchten Sie diesen Komplex archivieren? Archivierte Komplexe werden nicht mehr angewendet.",
      "archiveTitle": "Komplex archivieren",
      "askAssistant": "Mit dem Einrichtungsassistenten ändern",
      "clearSearch": "Suche zurücksetzen",
      "deleteAction": "Endgültig löschen",
      "deleteDescription":
        "Möchten Sie diesen Komplex endgültig löschen? Diese Aktion kann nicht rückgängig gemacht werden. Bereits angewendete Komplexe in bestehenden Behandlungen bleiben erhalten, werden aber nicht mehr angezeigt.",
      "deleteTitle": "Komplex endgültig löschen",
      "description":
        "Komplexe sind vorgefertigte Dokumentationsfragmente, die durch Trigger-Wörter ausgelöst und automatisch in die Dokumentation integriert werden können.",
      "empty": "Noch keine Komplexe vorhanden.",
      "learnMore": "Mehr erfahren",
      "noSearchResults": "Keine Komplexe gefunden.",
      "searchPlaceholder": "Nach Trigger-Wörtern suchen",
    },
    "row": {
      "description":
        "Angehakte Komplexe sind angewendet. Klappen Sie eine Zeile auf, um den Text zu sehen oder eine Vorlage auszufüllen. Vorschläge wurden erkannt, aber nicht übernommen, zum Beispiel weil die Behandlung nur besprochen wurde.",
      "help": "Was bedeuten die Komplexe?",
      "pendingRemoval_one":
        "{{count}} Komplex wird beim Neuerstellen entfernt.",
      "pendingRemoval_other":
        "{{count}} Komplexe werden beim Neuerstellen entfernt.",
      "reprocess": "Dokumentation neu erstellen",
      "reprocessNeeded":
        "Die geänderte Einstellung wird erst übernommen, wenn Sie die Dokumentation neu erstellen.",
      "statusDiscussed": "nur besprochen",
      "statusMentioned": "nur erwähnt",
      "statusTriggerMatch": "Triggerwort im Transkript",
      "title": "Komplexe",
      "useForRecording": "Komplexe für diese Aufnahme verwenden",
    },
    "selection": {
      "apply": "Anwenden",
      "statusExcluded": "nicht angewendet",
      "statusPendingRemoval": "wird beim nächsten Verarbeiten entfernt",
      "title": "Komplexe",
      "toggleAriaLabel": "Komplex „{{name}}“ anwenden",
      "viewAriaLabel": "Komplex „{{name}}“ anzeigen",
    },
    "template": {
      "badge_one": "Exakte Struktur · {{count}} Platzhalter",
      "badge_other": "Exakte Struktur · {{count}} Platzhalter",
      "collapseRepeatedLines": "Zusammenfassen",
      "convertConditional": "Umwandeln",
      "detectedSlots_one": "{{count}} Platzhalter erkannt",
      "detectedSlots_other": "{{count}} Platzhalter erkannt",
      "detectSlots": "Platzhalter und Bedingungen erkennen",
      "insertSlot": "Platzhalter",
      "kinds": {
        "choice": "Auswahl aus Alternativen",
        "condition":
          "Zeile erscheint nur, wenn die Bedingung laut Dokumentation zutrifft",
        "fill": "Wert, den die KI anhand der Beschreibung ausfüllt",
        "list": "Stichpunkte: jeder Punkt erscheint als eigene Zeile mit „-“",
        "repeat":
          "Zeile wird pro Vorkommen wiederholt, z. B. pro Zahn. Mitten in der Zeile wird der Rest der Zeile in derselben Zeile wiederholt, mit Komma getrennt",
      },
      "prompt": {
        "hint":
          "Wird beim Ausfüllen der Platzhalter nach dem Praxis-Prompt angehängt. Vorlagen ohne Platzhalter nutzen sie nicht.",
        "label": "KI-Anweisung für diese Vorlage",
        "placeholder": "z. B. Zahnangaben immer im FDI-Schema",
        "reportHint":
          "Wird nur genutzt, solange der Komplex keinen Inhalt hat. Die KI schreibt dann diesen Teil der Dokumentation nach der Anweisung, zum Beispiel einen OPG-Befund. Sobald der Komplex Inhalt hat, wird der Inhalt eingearbeitet und die Anweisung ignoriert.",
        "reportLabel": "KI-Anweisung für diesen Komplex",
        "test": {
          "description":
            "Füllt die aktuelle Vorlage mit der KI-Anweisung aus dem Formular, ohne zu speichern. Der Text wird ohne Behandler, Datum und Originaltranskript gesendet.",
          "inputLabel": "Dokumentationstext",
          "missingSlots_one": "{{count}} Platzhalter offen:",
          "missingSlots_other": "{{count}} Platzhalter offen:",
          "requestFailed": "Test fehlgeschlagen.",
          "result": "Ergebnis",
          "submit": "Test starten",
          "title": "Vorlage testen",
          "trigger": "Ungespeichert testen",
        },
      },
      "slotDialog": {
        "addOption": "Alternative hinzufügen",
        "choiceLabel": "Alternativen",
        "choicePlaceholder": "z. B. Infiltration",
        "conditionLabel": "Wann soll die Zeile erscheinen?",
        "conditionPlaceholder": "z. B. OPG erstellt",
        "description":
          "Ein Wert wird aus der Dokumentation eingesetzt. Eine Auswahl übernimmt nur die passende Alternative. Eine Wiederholung gibt die Zeile pro Vorkommen aus. Eine Bedingung zeigt die Zeile nur, wenn sie laut Dokumentation zutrifft.",
        "editTitle": "Platzhalter bearbeiten",
        "fillLabel": "Was soll eingesetzt werden?",
        "fillPlaceholder": "z. B. Zahn",
        "insert": "Einfügen",
        "kinds": {
          "choice": "Auswahl",
          "condition": "Bedingung",
          "fill": "Wert",
          "repeat": "Wiederholung",
        },
        "repeatLabel": "Woran wird wiederholt?",
        "repeatPlaceholder": "z. B. Zahn",
        "title": "Platzhalter einfügen",
      },
      "strictStructureHint":
        "Die Vorlage wird Zeile für Zeile exakt übernommen. Die KI füllt nur Platzhalter in geschweiften Klammern und wählt Alternativen anhand der Dokumentation. Zeilen mit {pro Zahn} am Anfang werden pro Zahn wiederholt. Steht {pro Zahn} mitten in der Zeile, wird der Rest der Zeile in derselben Zeile pro Zahn wiederholt. Zeilen mit {wenn …} am Anfang erscheinen nur, wenn die Bedingung laut Dokumentation zutrifft. Offene Platzhalter bleiben sichtbar.",
      "strictStructureInfo": "Was bedeutet exakte Struktur?",
      "strictStructureLabel": "Exakte Struktur einhalten",
      "warningLinePrefix": "Zeile {{line}}: ",
      "warnings": {
        "braceTooLong":
          "{{raw}} ist zu lang, ein Platzhalter hat höchstens {{max}} Zeichen.",
        "choiceNeedsTwoOptions":
          "{{raw}} braucht mindestens zwei Alternativen und wird als Text übernommen.",
        "conditionalLikeFill":
          "{{raw}} sieht aus wie eine Bedingung. Mit {wenn …} am Zeilenanfang erscheint die Zeile nur, wenn sie zutrifft.",
        "conditionBlockStrayEnd":
          "{{raw}} beendet keinen Abschnitt und wird als Platzhalter gelesen.",
        "conditionBlockUnclosed":
          "Zu {{raw}} fehlt eine Zeile {ende}. Ohne sie wird die Bedingung als Platzhalter gelesen.",
        "conditionEmpty":
          "{{raw}} nennt keine Bedingung und wird als Platzhalter gelesen.",
        "conditionInRepeatHeader":
          "{{raw}} lässt sich nicht mit {pro …} kombinieren und wird als Platzhalter gelesen.",
        "conditionNeedsContent":
          "Nach {{raw}} steht kein Text. Die Bedingung wird als Platzhalter gelesen.",
        "conditionNested":
          "{{raw}} steht in einem Abschnitt mit {wenn …}. Bedingungen lassen sich nicht verschachteln. Schließen Sie den Abschnitt vorher mit {ende}, sonst lässt sich der Komplex nicht speichern.",
        "conditionNestedSlot":
          "{{raw}} enthält einen Platzhalter nach „dann“. Stattdessen die Zeile mit {wenn …} beginnen.",
        "conditionNotAtLineStart":
          "{{raw}} gilt nur am Zeilenanfang für die Zeile. Sonst „dann …“ ergänzen. Bis dahin wird es als Platzhalter gelesen.",
        "conditionThenEmpty":
          "In {{raw}} fehlt der Text nach „dann“ oder „sonst“. Es wird als Platzhalter gelesen.",
        "contentTooLong": "{{total}} Zeichen, erlaubt sind höchstens {{max}}.",
        "emptyBraces": "{{raw}} ist leer und wird als Text übernommen.",
        "numericChoice":
          "{{raw}} besteht nur aus Zahlen und wird als Auswahl gelesen.",
        "repeatedLines":
          "Zeilen {{from}} bis {{to}} sind gleich. Mit {{header}} am Zeilenanfang wird die Zeile pro Vorkommen wiederholt.",
        "repeatNeedsPlaceholder":
          "{{raw}} wiederholt eine Zeile ohne Platzhalter.",
        "tooManySlots":
          "{{total}} Platzhalter, erlaubt sind höchstens {{max}}.",
      },
    },
  },
  "confirmation": {
    "description": "Diese Aktion kann nicht rückgängig gemacht werden.",
    "title": "Sind Sie sicher?",
  },
  "connector": {
    "dialog": {
      "channels": {
        "beta": "Beta",
        "stable": "Release",
      },
      "createToken": "Connector-Token erstellen",
      "description":
        "Installieren Sie den Dentero Connector auf dem Windows-PC, auf dem Ihre Praxissoftware läuft.",
      "download": "Herunterladen",
      "title": "Dentero Connector",
      "tokenCreatedHint":
        "Kopieren Sie es jetzt und fügen Sie es bei der Einrichtung in den Connector ein. Es kann nicht erneut angezeigt werden.",
      "tokenCreatedTitle": "Connector-Token erstellt",
      "tokenExists":
        "Es gibt bereits ein Connector-Token mit der Endung {{lastFour}} (erstellt am {{created}}). Es kann nicht erneut angezeigt werden. Falls es verloren gegangen ist, wenden Sie sich an den Dentero-Support.",
      "tokenFailed": "Connector-Token konnte nicht erstellt werden.",
      "tokenLoading": "Suche nach vorhandenem Token…",
      "tokenMissing":
        "Der Connector benötigt ein API-Token, um sich mit Ihrer Praxis zu verbinden.",
      "tokenTitle": "API-Token",
      "userPlaceholder": "Praxismitglied auswählen",
      "version": "Version {{version}}",
    },
  },
  "customization": {
    "acceptSuggestion": "Vorschlag übernehmen",
    "acceptSuggestionKey": "Tab",
    "actions": {
      "archive": "Archivieren",
      "create": "Neu",
      "delete": "Löschen",
      "update": "Ändern",
    },
    "areas": {
      "assistant": "Dokumentationsassistent",
      "complex": "Komplex",
      "custom_prompt": "Eigener Prompt",
      "default_factor": "Standardfaktor",
      "practice": "Praxiseinstellungen",
    },
    "blockers": {
      "dry_run_required":
        "Vor dem Übernehmen ist ein erfolgreicher Testlauf nötig. Bitten Sie den Assistenten, ihn auszuführen.",
      "screening_failed":
        "Die Sicherheitsprüfung hat diesen Prompt abgelehnt. Er kann nicht übernommen werden.",
    },
    "buttons": {
      "apply": "Übernehmen",
      "discard": "Verwerfen",
      "open": "Öffnen",
      "undo": "Rückgängig",
    },
    "clearHistory": {
      "button": "Chatverlauf löschen",
      "confirm": "Verlauf löschen",
      "description":
        "Das löscht die Chats aller Nutzer dieser Praxis mit allen Nachrichten und Änderungsvorschlägen. Übernommene Änderungen bleiben in der Konfiguration und im Änderungsprotokoll.",
      "title": "Chatverlauf der Praxis löschen?",
    },
    "description":
      "Beschreiben Sie, was Dentero in Ihrer Praxis anders machen soll. Der Assistent schlägt passende Änderungen vor. Gespeichert wird nur, was Sie übernehmen.",
    "disclaimer":
      "Der Assistent kann sich irren. Prüfen Sie jede Änderung, bevor Sie sie übernehmen.",
    "dryRun": {
      "failed": "Testlauf ohne Ergebnis",
      "input": "Beispiel-Eingabe",
      "output": "Ergebnis",
      "passed": "Testlauf erfolgreich",
    },
    "empty": {
      "description":
        "Wählen Sie einen Vorschlag oder beschreiben Sie Ihren Wunsch in eigenen Worten.",
      "title": "Was soll Dentero in Ihrer Praxis anders machen?",
    },
    "errors": {
      "generic": "Das hat nicht geklappt. Bitte versuchen Sie es erneut.",
    },
    "fields": {
      "assistant": {
        "classification": "Klassifikation",
        "content": "Hinweise",
        "title": "Titel",
      },
      "complex": {
        "auto_apply": "Automatisch anwenden",
        "content": "Inhalt",
        "trigger_words": "Auslösewörter",
      },
      "custom_prompt": {
        "class_name": "KI-Arbeitsschritt",
        "content": "Anweisungen",
      },
      "default_factor": {
        "factor": "Faktor",
        "justification": "Begründung",
        "regulation_position_id": "Position",
      },
      "practice": {
        "additional_address": "Adresszusatz",
        "address": "Adresse",
        "city": "Ort",
        "complexes_applied_by_default": "Komplexe standardmäßig anwenden",
        "documentation_assistant_enabled_by_default":
          "Dokumentationsassistent standardmäßig an",
        "documentation_download_format": "Download-Format",
        "email": "E-Mail",
        "kzv": "KZV",
        "name": "Praxisname",
        "protect_privacy": "Privatsphäre-Modus",
        "realtime_transcription_enabled_by_default":
          "Live-Transkription standardmäßig an",
        "retention_period_audio": "Aufbewahrung des Audios",
        "skip_ai_requests": "KI-Verarbeitung überspringen",
        "zip": "PLZ",
      },
    },
    "focus": {
      "clear": "Bezug entfernen",
      "complex": "Komplex „{{name}}“",
      "placeholder": "Was soll an Komplex „{{name}}“ anders sein?",
    },
    "oversight": {
      "appliedChanges": "Übernommene Änderungen",
      "auditTrail": "Audit-Trail",
      "empty": "Noch keine Einrichtungs-Chats.",
      "searchPlaceholder": "Nachrichten durchsuchen",
    },
    "placeholder": "Beschreiben Sie, was Dentero anders machen soll",
    "screening": {
      "failed": "Sicherheitsprüfung nicht bestanden",
      "findings": {
        "blank": "Die Anweisungen sind leer.",
        "markdown_image": "Enthält ein Bild.",
        "markup_tag": "Enthält Markup oder Tags.",
        "override_instructions":
          "Fordert dazu auf, Regeln oder Anweisungen zu ignorieren.",
        "reveal_data":
          "Fordert dazu auf, Daten vollständig oder wörtlich auszugeben.",
        "role_marker": "Enthält Rollenangaben wie „System:“.",
        "template_syntax": "Enthält Vorlagen-Syntax.",
        "too_long": "Die Anweisungen sind zu lang.",
        "url": "Enthält einen Link oder eine Webadresse.",
      },
      "passed": "Sicherheitsprüfung bestanden",
    },
    "send": "Senden",
    "status": {
      "applied": "Übernommen",
      "discarded": "Verworfen",
      "pending": "Vorschlag",
      "undone": "Rückgängig gemacht",
    },
    "suggestions": {
      "assistant": "Dokumentationsassistent für Endodontie anpassen",
      "complex": "Komplex anlegen oder ändern",
      "custom_prompt": "Mach die Dokumentation kürzer",
      "default_factor": "Standardfaktor für eine GOZ-Position setzen",
      "practice": "Praxiseinstellungen ändern (z. B. Download als PDF)",
    },
    "title": "Einrichtungsassistent",
    "toolCalls_one": "{{count}} Aufruf gemacht",
    "toolCalls_other": "{{count}} Aufrufe gemacht",
    "tools": {
      "draft_complex_content": "Inhalt entworfen",
      "list_assistants": "Assistenten gelesen",
      "list_complexes": "Komplexe gelesen",
      "list_custom_prompts": "Eigene Prompts gelesen",
      "list_default_factors": "Standardfaktoren gelesen",
      "propose_assistant_delete": "Löschung vorgeschlagen",
      "propose_assistant_override": "Assistent vorgeschlagen",
      "propose_assistant_update": "Assistent-Änderung vorgeschlagen",
      "propose_complex_archive": "Archivierung vorgeschlagen",
      "propose_complex_create": "Komplex vorgeschlagen",
      "propose_complex_update": "Komplex-Änderung vorgeschlagen",
      "propose_custom_assistant": "Assistent vorgeschlagen",
      "propose_custom_prompt_update": "Prompt vorgeschlagen",
      "propose_default_factor_delete": "Löschung vorgeschlagen",
      "propose_default_factor_upsert": "Standardfaktor vorgeschlagen",
      "propose_practice_profile_update": "Stammdaten vorgeschlagen",
      "propose_practice_setting": "Einstellung vorgeschlagen",
      "search_regulation_position": "Positionen gesucht",
      "show_complex": "Komplex gelesen",
      "show_practice_settings": "Einstellungen gelesen",
      "suggest_reply": "Antwort vorgeschlagen",
      "test_custom_prompt": "Testlauf",
    },
    "values": {
      "empty": "(leer)",
      "no": "Nein",
      "yes": "Ja",
    },
    "warnings": {
      "custom_prompt":
        "Eigene Prompts wirken auf jede Aufnahme Ihrer Praxis. Prüfen Sie den Testlauf sorgfältig.",
      "practice": {
        "protect_privacy":
          "Der Privatsphäre-Modus bestimmt, wer Audio und Transkriptionen sehen kann.",
        "retention_period_audio":
          "Die Aufbewahrungsdauer bestimmt, wann Audiodateien endgültig gelöscht werden.",
        "skip_ai_requests":
          "Ohne KI-Verarbeitung entstehen keine Dokumentationen und keine Abrechnungsvorschläge.",
      },
    },
  },
  "customPrompts": {
    "aiRequestTypes": {
      "gkvSuggestion": "GKV-Vorschlag",
      "improvedDocumentation": "Verbesserte Fassung",
      "patientBriefing": "Patienten-Briefing",
      "pkvSuggestion": "PKV-Vorschlag",
      "structuredDocumentation": "Strukturierte Dokumentation",
    },
    "edit": {
      "insertDefaultTemplate": "Standardvorlage einfügen",
      "promptPlaceholder": "Anpassung für diesen Prompt...",
      "promptTab": "Prompt",
      "responseFieldsTab": "Zusätzliche Ausgabefelder",
      "templateHint": "Leer lassen, um die Standardvorlage zu verwenden.",
      "templatePlaceholder": "Liquid-Vorlage für die Ausgabe...",
      "templateTab": "Vorlage (Liquid)",
    },
    "form": {
      "description": "Wählen Sie den Prompt-Typ aus, den Sie anpassen möchten.",
      "newTitle": "Neuer eigener Prompt",
      "typePlaceholder": "Typ auswählen...",
    },
    "index": {
      "add": "Hinzufügen",
      "breadcrumb": "Eigene Prompts",
      "deleteDescription":
        "Möchten Sie diesen eigenen Prompt wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
      "deleteTitle": "Eigenen Prompt löschen",
      "empty": "Noch keine eigenen Prompts vorhanden.",
      "noChanges": "Noch keine Anpassungen vorgenommen.",
      "promptCustomized": "Prompt angepasst",
      "responseFieldsCustomized": "Ausgabefelder angepasst",
      "templateCustomized": "Vorlage angepasst",
      "usingDefaultPrompt":
        "Prompt nicht angepasst - Standardprompt wird verwendet.",
    },
    "responseFields": {
      "add": "Feld hinzufügen",
      "defaultFieldsDescription":
        "Diese Felder werden von Dentero benötigt und können nicht verändert werden.",
      "defaultFieldsTitle": "Standardfelder",
      "descriptionHint":
        "Die Beschreibung wird an das Modell übergeben und in der Vorlagen-Autovervollständigung angezeigt.",
      "descriptionLabel": "Beschreibung",
      "descriptionPlaceholder":
        "Welche Information soll das Modell in diesem Feld ausgeben?",
      "errors": {
        "descriptionRequired": "Eine Beschreibung ist erforderlich.",
        "descriptionTooLong": "Eine Beschreibung ist zu lang.",
        "jsonInvalid": "Das JSON ist ungültig.",
        "jsonShape":
          "Das JSON muss ein Array von Objekten mit key, type, description und optionalem nullable sein.",
        "keyDuplicate": "Dieser Schlüssel wird bereits verwendet.",
        "keyFormat":
          "Nur Kleinbuchstaben, Zahlen und Unterstriche sind erlaubt. Der Schlüssel muss mit einem Buchstaben oder Unterstrich beginnen.",
        "keyRequired": "Ein Schlüssel ist erforderlich.",
        "keyReserved": "Dieser Schlüssel ist für ein Standardfeld reserviert.",
        "tooLarge":
          "Die zusätzlichen Felder sind insgesamt zu groß. Kürzen Sie die Beschreibungen oder entfernen Sie Felder.",
        "typeUnsupported": "Ein Feld verwendet einen nicht unterstützten Typ.",
      },
      "jsonHint":
        "Fügen Sie ein JSON-Array ein. Jedes Objekt braucht key, type und description. nullable ist optional und gilt sonst als true.",
      "keyLabel": "Schlüssel",
      "keyPlaceholder": "z. B. besondere_beobachtungen",
      "limit_one":
        "Es kann höchstens {{count}} zusätzliches Feld angelegt werden.",
      "limit_other":
        "Es können höchstens {{count}} zusätzliche Felder angelegt werden.",
      "modeForm": "Formular",
      "modeJson": "JSON",
      "nullableHint":
        "Erlaubt null, wenn die Dokumentation keine passende Information enthält.",
      "nullableLabel": "Leerer Wert erlaubt",
      "promptPreviewDescription":
        "Diese Feldanweisungen werden automatisch an den Prompt angehängt.",
      "promptPreviewTitle": "Automatisch erzeugte Prompt-Anweisungen",
      "remove": "Feld entfernen",
      "typeLabel": "Typ",
      "warnings": {
        "notUsedInTemplate":
          "Dieses Feld wird in der aktuellen Vorlage nicht verwendet und erscheint daher nicht in der Dokumentation.",
      },
    },
    "test": {
      "description":
        "Testen Sie die Anpassung für diesen Prompt mit einer Beispieldokumentation.",
      "invalidJson": "Ungültiges JSON:",
      "jsonLabel": "JSON",
      "pending": "Wird getestet...",
      "requestFailed": "Prompt-Test fehlgeschlagen",
      "response": "Antwort",
      "result": "Ergebnis",
      "submit": "Testen",
      "title": "Prompt testen",
      "trigger": "Prompt testen",
    },
  },
  "dashboard": {
    "charts": {
      "byStatus": {
        "description": "Bearbeitet vs. ausstehend",
        "title": "Nach Status",
      },
      "byTreater": {
        "description": "Aufnahmen pro Nutzer",
        "title": "Nach Behandler",
      },
      "recordingsByDay": {
        "title": "Aufnahmen pro Tag",
      },
    },
    "documentationPool": {
      "exhausted": {
        "body": "Nichts wird blockiert. Kunden sehen diesen Hinweis nicht.",
        "title": "Der Doku-Pool ist aufgebraucht",
      },
      "period": "{{start}} bis {{end}}",
      "sharedBy": "Alle Praxen im Abo teilen diesen Pool:",
      "title": "Doku-Pool",
      "usedOfLimit": "{{used}} von {{limit}} Dokumentationen genutzt",
      "youUsed_one": "Davon haben Sie {{count}} erstellt",
      "youUsed_other": "Davon haben Sie {{count}} erstellt",
    },
    "emptyState": {
      "noData": "Keine Daten",
    },
    "filters": {
      "allPractices": "Alle Praxen",
      "custom": "Benutzerdefiniert...",
      "period": "Zeitraum",
    },
    "stats": {
      "documentationUsage": {
        "thisMonth": "In diesem Monat",
        "title": "Dokumentationen",
        "usedOfLimit": "{{used}} / {{limit}}",
        "youUsed_one": "Sie haben {{count}} erstellt",
        "youUsed_other": "Sie haben {{count}} erstellt",
      },
      "medianLength": {
        "description": "Pro Aufnahme",
        "footer": "Mittlere Aufnahmedauer",
        "title": "Medianlänge",
      },
      "recordings": {
        "footer": "Gesamtanzahl der Aufnahmen",
        "title": "Aufnahmen",
      },
      "selectedPeriod": "Im gewählten Zeitraum",
      "totalDuration": {
        "description": "Aller Aufnahmen",
        "footer": "Aufgezeichnete Zeit insgesamt",
        "title": "Gesamtdauer",
      },
      "treaters": {
        "footer": "Gesamtanzahl der Behandler",
        "title": "Behandler",
      },
    },
  },
  "dentalChart": {
    "attributes": {
      "acuteApicalAbscess": "akuter apikaler Abszess",
      "apicalPeriodontitis": "apikale Parodontitis",
      "asymptomaticApicalPeriodontitis": "asymptomatische apikale Parodontitis",
      "bridgeAbutment": "Brückenanker",
      "chronicApicalAbscess": "chronischer apikaler Abszess",
      "clasp": "Klammer/Halteelement",
      "condensingOsteitis": "kondensierende Ostitis",
      "cyst": "Zyste",
      "irreversiblePulpitis": "irreversible Pulpitis",
      "nonVital": "avital",
      "percussionSensitive": "perkussionsempfindlich",
      "post": "Stiftaufbau",
      "reversiblePulpitis": "reversible Pulpitis",
      "rootCanalTreated": "wurzelkanalbehandelt",
      "splinted": "verblockt",
      "superstructure": "Suprakonstruktion",
      "symptomaticApicalPeriodontitis": "symptomatische apikale Parodontitis",
      "wisdomToothRemovalIndicated": "Entfernung indiziert",
    },
    "changes": {
      "appliedTitle": "Zahnstatus aktualisiert",
      "closeReview": "Zahnstatus ausblenden",
      "empty": "Keine Befund-Änderungen aus dieser Aufnahme.",
      "emptyEditable":
        "Keine Änderungen erkannt. Du kannst den Zahnstatus hier trotzdem bearbeiten.",
      "openLiveChart": "Aktuellen Zahnstatus öffnen",
      "openReview": "Zahnstatus anzeigen",
      "pending": "Der Zahnstatus zu dieser Aufnahme wird noch erstellt.",
      "queued_one":
        "{{count}} weitere Zahnstatus-Aktualisierung wird noch erstellt.",
      "queued_other":
        "{{count}} weitere Zahnstatus-Aktualisierungen werden noch erstellt.",
      "working": "Zahnstatus wird aktualisiert …",
    },
    "chart": {
      "aiBadge": "KI",
      "letterAria": {
        "b": "{{number}} Brückenglied",
        "bPlanned": "{{number}} Brückenglied, geplant",
        "f": "{{number}} fehlt",
      },
      "showCounterpart": "Anderen Zahn {{number}} anzeigen",
      "statusAria": "{{number}}, {{status}}",
      "statusPlannedAria": "{{number}}, {{status}}, geplant",
    },
    "chartAria": "Odontogramm",
    "editor": {
      "addFinding": "Befund hinzufügen",
      "apply": "Speichern",
      "attributeGroups": {
        "endodontic": "Endodontie",
        "other": "Weitere",
        "prosthetic": "Prothetik",
      },
      "cancel": "Abbrechen",
      "chooseFinding": "Befund wählen",
      "dentition": "Zahnart",
      "failed": "Die Änderung konnte nicht gespeichert werden.",
      "findingLabel": "Befund {{index}}",
      "findingTaken": "Bereits auf dieser Fläche",
      "findingType": "Befund",
      "kzbvCode": "KZBV-Befund",
      "kzbvPlaceholder": "z. B. kw",
      "liveChartHint":
        "Änderungen gelten für den aktuellen Zahnstatus, nicht nur für diese Sitzung.",
      "material": "Material",
      "maxFindings": "Pro Fläche sind höchstens {{count}} Befunde möglich.",
      "maxFindings_one": "Pro Fläche ist höchstens {{count}} Befund möglich.",
      "maxFindings_other":
        "Pro Fläche sind höchstens {{count}} Befunde möglich.",
      "noFindings": "Kein Befund an {{number}} {{surface}}.",
      "notGraded": "ohne Grad",
      "pathology": "Pathologie",
      "permanent": "bleibend ({{number}})",
      "primary": "Milchzahn ({{number}})",
      "radiographicDepth": "Röntgentiefe",
      "recurrent": "rezidivierend (CARS)",
      "removeFinding": "Entfernen",
      "restoration": "Restauration",
      "severity": "ICDAS-Grad",
      "state": "Zustand",
      "status": "Status",
      "surfaceFindings": "Flächenbefunde",
      "title": "Zahn {{number}}",
    },
    "findings": {
      "abrasion": "Abrasion",
      "attrition": "Attrition",
      "caries": "Karies",
      "discoloration": "Verfärbung",
      "erosion": "Erosion",
      "filling": "Füllung",
      "fracture": "Fraktur",
      "hypoplasia": "Schmelzhypoplasie",
      "insufficient-restoration": "insuffiziente Restauration",
      "sealant": "Fissurenversiegelung",
      "wedge-defect": "keilförmiger Defekt",
    },
    "legend": {
      "badges":
        "Kürzel: WF Wurzelfüllung, St Stift, BA Brückenanker, SK Suprakonstruktion, Vb verblockt, −V avital, AP apikale Parodontitis, Zy Zyste",
      "bridge": "Brücke über Pfeiler und Brückenglied",
      "cervicalDot": "Punkt am Zahnhals: zervikaler Befund",
      "changed": {
        "patient": "Geändert seit der vorherigen Version",
        "recording": "In dieser Sitzung geändert",
      },
      "crownDefective": "Krone erneuerungsbedürftig",
      "crownDot": "Punkt auf der Krone: Verfärbung oder Hypoplasie",
      "crownPlanned": "Krone geplant",
      "extractionPlanned": "✕ Extraktion geplant",
      "findingsTitle": "Befunde",
      "gapClosed": "Lückenschluss )(",
      "gapClosedDistal": "distal geschlossen )",
      "gapClosedMesial": "mesial geschlossen (",
      "impacted": "Zahn unter dem Zahnfleisch: retiniert/verlagert",
      "implant": "Schraubensymbol: Implantat",
      "implantPlanned": "Implantat geplant",
      "indirectFilling": "Füllung indirekt (Keramik, Gold, Metall)",
      "innerBand": "Band unter der Krone: Befund lingual oder palatinal",
      "missing": "fehlend",
      "pontic": "Brückenglied",
      "ponticPlanned": "Brückenglied geplant",
      "prosthetic": "Krone / Prothetik",
      "replaced": "ersetzt (e)",
      "splinted": "Verblockung",
      "stateTitle": "Zustand",
      "title": "Legende",
      "toothTitle": "Zahn",
      "unerupted": "Zahn unter dem Zahnfleisch: nicht durchgebrochen",
      "workPlanned": "Füllung, Versiegelung, Wurzelfüllung geplant",
    },
    "live": {
      "handedOver":
        "Der Befund wird aus dem Diktat für die gespeicherte Patientennummer neu erstellt und erscheint in einem Moment.",
      "phase": {
        "fallback": "live nicht verfügbar · kommt nach der Aufnahme",
      },
      "readOnly": "während der Aufnahme nur Ansicht",
      "saved":
        "Befund gespeichert — der Befund, den Sie beim Diktieren gesehen haben, ist jetzt der Befund am Patienten.",
      "stale":
        "Der Befund wurde zwischenzeitlich geändert. Er wird neu berechnet und erscheint in einem Moment.",
      "waiting": "Noch kein Zahn erkannt. Diktieren Sie eine Zahnnummer.",
    },
    "materials": {
      "amalgam": "Amalgam",
      "ceramic": "Keramik",
      "compomer": "Kompomer",
      "composite": "Komposit",
      "glass-ionomer": "Glasionomerzement",
      "gold": "Gold",
      "metal": "Metall",
      "other": "sonstiges",
      "temporary": "Provisorium",
    },
    "origin": {
      "before": "Davor",
      "current": "Aktueller Befund",
      "edit": "Bearbeiten",
      "noHistory": "Zu diesem Zahn liegt kein Verlauf vor.",
      "notCharted": "nicht befundet",
      "openRecording": "Aufnahme öffnen",
      "showInTranscript": "Im Diktat zeigen",
      "title": "Zahn {{number}}",
      "treatedAt": "Behandelt",
      "unexamined": "Nicht befundet",
    },
    "quickCard": {
      "addFindingTitle": "Befund setzen · {{surface}}",
      "aiHint": "KI · diese Aufnahme",
      "emptyFindings": "Keine Befunde an diesem Zahn.",
      "findingCount_one": "{{count}} Befund",
      "findingCount_other": "{{count}} Befunde",
      "findingsBlocked":
        "Für „{{status}}“ sind keine Flächenbefunde möglich. Ändere den Zahnstatus, um Befunde zu erfassen.",
      "findingsBlockedAction": "Zahnstatus ändern",
      "findingsNone": "kein Befund",
      "nextTooth": "Nächster Zahn",
      "prevTooth": "Vorheriger Zahn",
      "savedHint": "Sofort gespeichert",
      "surfaceCross": "Flächenauswahl",
      "tabFindings": "Befunde",
      "tabTooth": "Zahnstatus",
    },
    "review": {
      "editHint": "Zum Korrigieren auf einen Zahn tippen.",
      "frozenNotice":
        "Der Zahnstatus wurde inzwischen geändert und kann hier nicht bearbeitet werden.",
      "noChartAtVisit":
        "Zum Zeitpunkt dieser Behandlung gab es noch keinen Zahnstatus.",
      "notInTranscript":
        "Zahn {{number}} wurde in der Transkription nicht gefunden.",
      "transcriptAria": "Transkription mit markierten Zahnangaben",
      "transcriptEmpty":
        "Für diese Aufnahme liegt noch keine Transkription vor.",
      "transcriptToggle": "Transkription",
    },
    "stage": {
      "announce": "Zahn {{number}}: {{what}}",
      "announceFailed": "Zahn {{numbers}} nicht eingetragen",
      "announceRemoved": "{{what}} entfernt",
      "crossAria": "Flächen von Zahn {{number}}",
      "idleHint": 'zum Beispiel "16 okklusal Karies"',
      "idleTitle": "Zahnnummer sagen",
      "jaw": {
        "lowerLeft": "Unterkiefer links",
        "lowerRight": "Unterkiefer rechts",
        "upperLeft": "Oberkiefer links",
        "upperRight": "Oberkiefer rechts",
      },
      "kind": {
        "canine": "Eckzahn",
        "incisor": "Schneidezahn",
        "molar": "Molar",
        "premolar": "Prämolar",
        "primaryMolar": "Milchmolar",
        "wisdom": "Weisheitszahn",
      },
      "liveTranscriptOffHint":
        "Live-Transkript einschalten, um den Befund mitzuschreiben",
      "liveTranscriptOffTitle": "Live-Transkript ist aus",
      "noChange": "keine Änderung",
      "noFindings": "ohne Befund",
      "overflow": "+{{extra}}",
      "overflow_one": "",
      "overflow_other": "",
      "overflowAria_one": "{{count}} weiterer Zahn genannt",
      "overflowAria_other": "{{count}} weitere Zähne genannt",
      "placedOnPatient": "Befund von Patient {{number}} übernommen",
      "repeat": "Bitte {{number}} noch einmal sagen",
      "repeatShort": "Noch einmal sagen",
      "state": {
        "charted": "Eingetragen",
        "charting": "Wird eingetragen",
        "failed": "Nicht eingetragen",
        "heard": "Gehört",
        "removed": "Zurückgenommen",
        "review": "Befund",
      },
      "toothAria": "Zahn {{number}}",
      "toothLetterAria": {
        "b": "Zahn {{number}}, Brückenglied",
        "bPlanned": "Zahn {{number}}, Brückenglied, geplant",
        "f": "Zahn {{number}}, fehlt",
      },
      "toothStatusAria": "Zahn {{number}}, {{status}}",
      "toothStatusPlannedAria": "Zahn {{number}}, {{status}}, geplant",
      "unassigned": "Patient noch nicht zugeordnet",
    },
    "states": {
      "completed": "durchgeführt",
      "defective": "erneuerungsbedürftig",
      "existing": "vorhanden",
      "planned": "geplant",
      "provisional": "provisorisch",
    },
    "status": {
      "crowned": "überkront",
      "extracted": "extrahiert",
      "gap-closed": "Lückenschluss )(",
      "gap-closed-distal": "distal geschlossen )",
      "gap-closed-mesial": "mesial geschlossen (",
      "impacted": "verlagert/retiniert",
      "implant": "Implantat",
      "missing": "fehlend",
      "partial-crown": "Teilkrone",
      "pontic": "Brückenglied",
      "replaced": "ersetzt",
      "retained-root": "Wurzelrest",
      "sound": "natürlicher Zahn",
      "telescopic-crown": "Teleskopkrone",
      "unerupted": "nicht durchgebrochen",
      "veneer": "Veneer",
    },
    "statusDefective": {
      "crowned": "Krone erneuerungsbedürftig",
      "partial-crown": "Teilkrone erneuerungsbedürftig",
      "pontic": "Brückenglied erneuerungsbedürftig",
      "replaced": "Ersatz erneuerungsbedürftig",
      "telescopic-crown": "Teleskopkrone erneuerungsbedürftig",
      "veneer": "Veneer erneuerungsbedürftig",
    },
    "statusPlanned": {
      "crowned": "Krone geplant",
      "extracted": "Extraktion geplant",
      "implant": "Implantat geplant",
      "partial-crown": "Teilkrone geplant",
      "pontic": "Brückenglied geplant",
      "replaced": "Ersatz geplant",
      "telescopic-crown": "Teleskopkrone geplant",
      "veneer": "Veneer geplant",
    },
    "surfaceFinding": "{{surface}} · {{finding}}",
    "surfaces": {
      "B": "vestibulär/bukkal",
      "C": "zervikal",
      "D": "distal",
      "I": "inzisal",
      "L": "lingual",
      "M": "mesial",
      "O": "okklusal",
      "P": "palatinal",
      "R": "Wurzel",
    },
    "toolbar": {
      "confirmDescription":
        "Das ersetzt den gesamten Zahnstatus: Zähne außerhalb des Schemas werden entfernt, noch nicht erfasste Zähne des Schemas werden als gesund angelegt. Bereits erfasste Zähne behalten ihren Status.",
      "confirmTitle": "Gebisswechsel übernehmen?",
      "presets": {
        "edentulous": "Zahnlos",
        "mixed": "Wechselgebiss",
        "primary": "Milchgebiss",
      },
    },
    "tooth": {
      "editSurfaceAria": "Zahn {{number}}, Fläche {{surface}} bearbeiten",
      "editToothAria": "Zahn {{number}} bearbeiten",
      "examinedAria": "Zahn {{number}}: {{status}}",
      "unexaminedAria": "Zahn {{number}}: nicht befundet",
    },
  },
  "dzrH1": {
    "link": {
      "ariaLabel": "{{code}} in DZR H1 PRO nachschlagen",
      "lookUp": "In DZR H1 PRO nachschlagen",
      "text": "H1",
      "tooltip": "",
    },
  },
  "embed": {
    "leaveConfirm":
      "Eine Aufnahme läuft noch. Wenn Sie zum anderen Patienten wechseln, wird sie beendet. Trotzdem wechseln?",
    "unavailable": {
      "body":
        "Die Dentero-Erweiterung für Teemer ist für Ihre Praxis noch nicht freigeschaltet. Bitte wenden Sie sich an den Dentero-Support.",
      "docsLink": "Mehr im Handbuch",
      "title": "Noch nicht freigeschaltet",
    },
  },
  "environment": {
    "watermark": {
      "development": "Entwicklung",
    },
  },
  "errors": {
    "clipboardCopy": "Kopieren nicht möglich. Bitte manuell kopieren.",
    "network": "Verbindungsfehler. Bitte erneut versuchen.",
  },
  "featureSpotlights": {
    "actions": {
      "back": "Zurück",
      "close": "Tour schließen",
      "done": "Fertig",
      "handbook": "Im Handbuch",
      "later": "Später",
      "next": "Weiter",
      "start": "Zeig es mir",
    },
    "befundChartHistory": {
      "card": {
        "body":
          "Auf der Patientenseite sehen Sie, wie sich der Zahnstatus von Besuch zu Besuch verändert hat. Zu jedem Besuch mit Zahnstatus lässt sich der Stand danach öffnen, samt Transkript.",
        "eyebrow": "In Ihrer Praxis eingerichtet",
        "title": "Frühere Zahnstatus ansehen",
      },
      "tour": {
        "chart": {
          "body":
            "Hier steht der aktuelle Zahnstatus des Patienten. Ein Klick auf einen Zahn zeigt, welche Aufnahme ihn zuletzt geändert hat.",
          "title": "Aktueller Zahnstatus",
        },
        "history": {
          "body":
            "Bei jedem Besuch, der einen Zahnstatus hinterlassen hat, steht diese Schaltfläche. Klicken Sie darauf, um den Zahnstatus nach dem Besuch zu öffnen und mit früheren Ständen zu vergleichen.",
          "title": "Zahnstatus-Verlauf öffnen",
        },
        "list": {
          "body":
            "Hier finden Sie alle Patienten Ihrer Praxis. Wir öffnen jetzt einen Patienten mit früheren Zahnstatus-Ständen.",
          "title": "Patientenliste",
        },
        "sidebar": {
          "body":
            "Über Patienten kommen Sie zu allen Behandlungen eines Patienten und zu seinem Zahnstatus.",
          "title": "Patienten",
        },
      },
    },
    "befundChartLive": {
      "card": {
        "body":
          "Diktieren Sie den Befund, und der Zahnstatus baut sich währenddessen auf. Dafür muss das Live-Transkript an sein. Mit einer Patienten-ID landet der Zahnstatus direkt in der Akte, ohne ID startet er auf einem leeren Zahnstatus.",
        "eyebrow": "In Ihrer Praxis eingerichtet",
        "title": "Zahnstatus live erfassen",
      },
      "tour": {
        "patient": {
          "body":
            "Mit der Patienten-ID landet der Zahnstatus direkt in der Akte dieses Patienten. Ohne ID startet er auf einem leeren Zahnstatus. Tragen Sie die ID später nach, ordnet Dentero ihn dem Patienten zu.",
          "title": "Patienten-ID eintragen",
        },
        "realtime": {
          "body":
            "Der Live-Zahnstatus läuft nur mit Live-Transkript. Schalten Sie es vor der Aufnahme ein. Ist ein Dokumentationsassistent gewählt, bleibt der Live-Zahnstatus aus.",
          "title": "Live-Transkript einschalten",
        },
      },
    },
    "befundChartReview": {
      "card": {
        "body":
          "Zeigen Sie in der Aufnahme auf einen Zahn, und im Transkript sind die Stellen markiert, an denen Sie ihn diktiert haben. So prüfen Sie schnell, ob ein Befund stimmt.",
        "eyebrow": "In Ihrer Praxis eingerichtet",
        "title": "Herkunft eines Befunds prüfen",
      },
      "tour": {
        "chart": {
          "body":
            "Fahren Sie über einen Zahn. Im Transkript sind dann die Stellen markiert, an denen Sie ihn diktiert haben. Bei älteren Aufnahmen zeigt ein Klick auf den Zahn, welche Aufnahme ihn zuletzt geändert hat.",
          "title": "Zahn prüfen",
        },
        "open": {
          "body":
            "Klicken Sie auf Zahnstatus anzeigen, um den Zahnstatus dieser Aufnahme aufzuklappen.",
          "title": "Zahnstatus der Aufnahme öffnen",
        },
        "transcript": {
          "body":
            "Hier öffnen Sie die Transkription. Zähne, die Sie genannt haben, sind markiert. So sehen Sie, ob ein Befund wirklich so diktiert wurde.",
          "title": "Im Transkript nachlesen",
        },
      },
    },
    "beta": {
      "badge": "Beta",
      "feedback":
        'Diese Funktion ist noch in der Beta und kann Fehler enthalten. Wir freuen uns über Ihr Feedback, am einfachsten über "Melden" in der Dokumentation.',
    },
    "complexConditions": {
      "card": {
        "body":
          "Der Zauberstab erkennt in Komplexen mit exakter Struktur jetzt Sätze, die nur bei manchen Patienten zutreffen, und setzt sie in eine Bedingung. Bestehende Komplexe ändern sich nicht von selbst. Klicken Sie je Komplex einmal auf den Zauberstab, prüfen Sie das Ergebnis und speichern Sie.",
        "eyebrow": "Verbessert",
        "title": "Bedingungen per KI erkennen",
      },
      "tour": {
        "content": {
          "body":
            "Prüfen Sie das Ergebnis. Der Editor hebt Bedingungen, Platzhalter und Wiederholungen farbig hervor. Bleibt der Text gleich oder erscheint ein Hinweis, gibt es nichts zu übernehmen.",
          "title": "Ergebnis prüfen",
        },
        "save": {
          "body":
            "Speichern Sie. Wiederholen Sie das für Ihre anderen Komplexe mit exakter Struktur.",
          "title": "Speichern",
        },
        "wand": {
          "body":
            "Klicken Sie auf den Zauberstab und wählen Sie „Platzhalter und Bedingungen erkennen“. Die KI setzt Sätze, die nur bei manchen Patienten zutreffen, in eine Bedingung. Das dauert einige Sekunden.",
          "title": "Mit KI verbessern",
        },
      },
    },
    "complexesSetup": {
      "card": {
        "body":
          "Legen Sie wiederkehrende Behandlungen einmal als Komplex an, mit Dokumentationstext und Abrechnungspositionen. Sagt jemand im Team das Trigger-Wort, übernimmt Dentero den Komplex in die Dokumentation.",
        "eyebrow": "In Ihrem Paket enthalten",
        "title": "Komplexe",
      },
      "tour": {
        "autoApply": {
          "body":
            "Eingeschaltet übernimmt Dentero den Komplex direkt in die Dokumentation. Ausgeschaltet bleibt er ein Vorschlag, den das Team mit einem Klick anwendet.",
          "title": "Automatisch anwenden",
        },
        "billing": {
          "body":
            "Zum Komplex gehören auch die Abrechnungspositionen. Klicken Sie auf Abrechnung.",
          "title": "Abrechnungspositionen",
        },
        "content": {
          "body":
            "Dieser Text landet in der Dokumentation, sobald ein Trigger-Wort fällt. Formulieren Sie ihn so, wie er in der Patientenakte stehen soll. Die KI kann ihn vorschlagen oder verbessern.",
          "title": "Dokumentationstext",
        },
        "create": {
          "body":
            "Ein Komplex ist eine wiederkehrende Behandlung mit fertigem Text und Abrechnungspositionen. Klicken Sie auf Hinzufügen, um den ersten anzulegen.",
          "title": "Ersten Komplex anlegen",
        },
        "dialog": {
          "body":
            "Trigger-Wörter sind die Begriffe, die Sie während der Aufnahme sagen, damit Dentero den Komplex übernimmt, z. B. „PZR“ oder „Ost“. Lassen Sie den Inhalt mit KI vorschlagen und klicken Sie auf Weiter.",
          "title": "Trigger-Wörter vergeben",
        },
        "positions": {
          "body":
            "Fügen Sie die GOZ- und BEMA-Positionen hinzu, die zu dieser Behandlung gehören, getrennt nach GKV und PKV (inklusive Faktorsteigerung und Begründung). Dentero schlägt sie zusammen mit dem Text vor, sobald der Komplex greift.",
          "title": "Positionen hinterlegen",
        },
        "save": {
          "body":
            "Speichern Sie den Komplex. Ab der nächsten Aufnahme reagiert Dentero auf die Trigger-Wörter.",
          "title": "Speichern",
        },
      },
    },
    "complexesUse": {
      "card": {
        "body":
          "Ihre Praxis hat Komplexe angelegt. Sagen Sie das Trigger-Wort während der Aufnahme, und Dentero übernimmt den vorbereiteten Text und die Abrechnungspositionen in Ihre Dokumentation.",
        "eyebrow": "In Ihrer Praxis eingerichtet",
        "title": "Komplexe",
      },
      "tour": {
        "toggle": {
          "body":
            "Hier sehen Sie vor der Aufnahme, ob Komplexe angewendet werden. Lassen Sie den Schalter an und sagen Sie das Trigger-Wort.",
          "title": "Komplexe anwenden",
        },
      },
    },
    "progress": "Schritt {{current}} von {{total}}",
    "realtimeTranscription": {
      "card": {
        "body":
          "Sehen Sie den Text schon während der Behandlung. Beim Speichern wird er zur Grundlage für Dokumentation und Abrechnung, die Audioaufnahme bleibt als Rückfallebene erhalten.",
        "eyebrow": "In Ihrem Paket enthalten",
        "title": "Live-Transkript",
      },
      "tour": {
        "toggle": {
          "body":
            "Schalten Sie hier vor der Aufnahme das Live-Transkript ein. Sie können es bei jeder Aufnahme zu- oder abschalten.",
          "title": "Live-Transkript einschalten",
        },
      },
    },
    "regionLabel": "Funktion entdecken",
    "tourUnavailable": "Die Tour lässt sich hier gerade nicht zeigen.",
    "whatsNew": {
      "description":
        "Neue Funktionen in Ihrem Paket. Jede Tour lässt sich hier erneut starten.",
      "empty": "Für Ihre Praxis gibt es gerade keine Neuigkeiten.",
      "failed":
        "Die Neuigkeiten ließen sich nicht laden. Bitte versuchen Sie es später erneut.",
      "loading": "Wird geladen …",
      "startTour": "Tour starten",
      "title": "Neuigkeiten",
    },
  },
  "featureToggle": {
    "confirmationDescription":
      "Hiermit bestelle ich dieses Feature zahlungspflichtig. Der Betrag wird mit der nächsten Rechnung fällig.",
    "confirmationTitle": "Feature aktivieren",
    "confirmLabel": "Jetzt zahlungspflichtig bestellen",
    "dependencyTooltip": "Voraussetzung nicht erfüllt",
    "enabledTooltip":
      "Um Produkte zu kündigen, kontaktieren Sie support@app.dentero.de",
    "upgradeTooltip":
      "Bitte upgraden Sie Ihr Abo, um dieses Feature zu aktivieren",
  },
  "filterableList": {
    "empty": "Keine Einträge vorhanden.",
    "noResults": "Keine Einträge mit diesem Filter gefunden.",
    "showAll": "Alle Einträge anzeigen",
  },
  "format": {
    "billingInterval": {
      "month": "Monat",
      "year": "Jahr",
    },
    "tenure": {
      "days_one": "{{count}} Tag",
      "days_other": "{{count}} Tage",
      "months_one": "{{count}} Monat",
      "months_other": "{{count}} Monate",
      "weeks_one": "{{count}} Woche",
      "weeks_other": "{{count}} Wochen",
      "years_one": "{{count}} Jahr",
      "years_other": "{{count}} Jahre",
    },
  },
  "handbook": {
    "learnMore": "Mehr erfahren",
  },
  "honorarBenchmark": {
    "apply": "Ø-Faktor {{factor}} übernehmen",
    "applyHint": "Klicken, um den Faktor zu übernehmen.",
    "badge": "Ø Region {{factor}}",
    "compact": "Ø {{factor}}",
    "overview": {
      "averageFactor": "Ø Praxis",
      "billedCount": "Abgerechnet",
      "defaultFactor": "Standardfaktor",
      "description_one":
        "Durchschnittliche Steigerungsfaktoren aus dem DZR HonorarBenchmark für {{count}} Praxis im Umkreis von {{radius}} km um PLZ {{plz}}, verglichen mit Ihren Standardfaktoren und Ihrer PKV-Abrechnung der letzten 90 Tage.",
      "description_other":
        "Durchschnittliche Steigerungsfaktoren aus dem DZR HonorarBenchmark für {{count}} Praxen im Umkreis von {{radius}} km um PLZ {{plz}}, verglichen mit Ihren Standardfaktoren und Ihrer PKV-Abrechnung der letzten 90 Tage.",
      "descriptionEmpty":
        "Durchschnittliche Steigerungsfaktoren aus dem DZR HonorarBenchmark für Praxen in Ihrer Region.",
      "empty":
        "Für Ihre PLZ liegen noch keine Benchmark-Daten vor. Sie werden nach dem Aktivieren und danach wöchentlich abgerufen.",
      "filterLabel": "Positionen filtern",
      "filters": {
        "all": "Alle",
        "below": "Unter Durchschnitt",
        "billed": "Abgerechnet",
        "configured": "Mit Standardfaktor",
      },
      "gap": "Abweichung",
      "missingPlz":
        "In den Praxisdaten ist keine PLZ hinterlegt. Ohne PLZ gibt es keinen regionalen Vergleich.",
      "noMatches": "Keine Positionen für diese Auswahl.",
      "searchPlaceholder": "Code oder Titel suchen",
      "setDefault": "Als Standard festlegen",
      "title": "Honorar-Benchmark",
    },
    "regionColumn": "Ø Region",
    "summary": {
      "factor": "Faktor {{factor}}",
      "factorWithAmount": "Faktor {{factor}} · {{amount}}",
      "title": "Regionaler Durchschnitt",
    },
    "tooltip_one":
      "DZR HonorarBenchmark: Durchschnitt aus {{count}} Praxis im Umkreis von {{radius}} km um PLZ {{plz}}",
    "tooltip_other":
      "DZR HonorarBenchmark: Durchschnitt aus {{count}} Praxen im Umkreis von {{radius}} km um PLZ {{plz}}",
  },
  "indexFilters": {
    "all": "Alle",
    "clearSearch": "Suche löschen",
    "description": "Verwenden Sie die Filter, um die Liste einzugrenzen.",
    "entriesFound_one": "{{count}} Eintrag gefunden",
    "entriesFound_other": "{{count}} Einträge gefunden",
    "filterBy": "Nach {{label}} filtern",
    "openFilters": "Filter öffnen",
    "optionsLoadError":
      "Filteroptionen konnten nicht geladen werden. Bitte versuchen Sie es erneut.",
    "reset": "Filter zurücksetzen",
    "resetAll": "Alle Filter zurücksetzen",
    "resetNamed": "Filter {{label}} zurücksetzen",
    "retryOptions": "Erneut laden",
    "searchPlaceholder": "Suche...",
    "showingRange": "(Zeige {{from}}-{{to}} von {{total}})",
    "title": "Filter",
  },
  "insurance": {
    "short": {
      "private": "PKV",
      "public": "GKV",
    },
  },
  "invitations": {
    "acceptButton": "Einladung annehmen",
    "invitedLine":
      "Sie wurden von {{invitedBy}} eingeladen, der Praxis {{practiceName}} beizutreten.",
    "setPassword": "Bitte setzen Sie ein Passwort für Ihr Konto.",
  },
  "laboratoryServices": {
    "form": {
      "createAction": "Erstellen",
      "createTitle": "Neue Laborleistung anlegen",
      "description":
        "Erstellen Sie eine neue Laborleistung im globalen Katalog. Preise können Sie danach pflegen.",
      "descriptionPlaceholder": "z. B. Modellguss, Vollprothese",
      "positionPlaceholder": "z. B. 0010",
      "typePlaceholder": "Typ auswählen",
    },
    "index": {
      "add": "Hinzufügen",
      "description": "Beschreibung",
      "kzvPriceReference": "KZV-Preisreferenz",
      "position": "Position",
      "searchPlaceholder": "Suche nach Position oder Beschreibung",
      "serviceType": "Leistungsart",
      "tabs": {
        "beb": "BEB",
        "bel": "BEL",
      },
    },
    "priceLevels": {
      "high": "Hoch",
      "low": "Niedrig",
      "medium": "Mittel",
    },
    "prices": {
      "amountPlaceholder": "z. B. 150,00",
      "bebDescription": "Preise nach Preisstufe für BEB-Leistungen.",
      "bebTitle": "BEB-Preise",
      "belDescription": "Preise nach KZV für Eigen- und Fremdlabor.",
      "belTitle": "BEL-Preise",
      "eigenlabor": "Eigenlabor",
      "fremdlabor": "Fremdlabor",
      "kzv": "KZV",
      "notSet": "Nicht gesetzt",
    },
    "show": {
      "deleteDescription":
        "Die Laborleistung wird aus dem Katalog entfernt. Bereits konfigurierte Preise in Praxen bleiben erhalten.",
      "deleteTitle": "Laborleistung löschen?",
    },
  },
  "layout": {
    "navigation": {
      "analogPositions": "Analogpositionen",
      "apiTokens": "API-Tokens",
      "assistants": "Assistenten",
      "auditTrail": "Änderungsprotokoll",
      "benchmarks": "Benchmarks",
      "billingPositions": "Abrechnungspositionen",
      "billingReviews": "Abrechnungs-Reviews",
      "chats": "Frag die KI",
      "community": "Dentero Community",
      "complexes": "Komplexe",
      "costs": "Kosten",
      "customization": "Einrichtungsassistent",
      "customizationChats": "Einrichtungs-Chats",
      "dashboard": "Dashboard",
      "defaultFactors": "Standardfaktoren",
      "dzrEdition": "DZR Edition",
      "handbook": "Handbuch",
      "honorarBenchmark": "Honorar-Benchmark",
      "laboratoryServicePrices": "Laborleistungen",
      "laboratoryServices": "Laborleistungen",
      "materialCatalog": "Material",
      "patients": "Patienten",
      "practice": "Praxis",
      "practices": "Praxen",
      "prompts": "Prompts",
      "recordDocumentation": "Dokumentation aufzeichnen",
      "recordDocumentationWithCount_one":
        "Dokumentation aufzeichnen ({{count}})",
      "recordDocumentationWithCount_other":
        "Dokumentation aufzeichnen ({{count}})",
      "recordings": "Dokumentationen",
      "resumeRecording": "Pausierte Aufzeichnung fortsetzen",
      "resumeRecordingWithCount_one":
        "Pausierte Aufzeichnung fortsetzen ({{count}})",
      "resumeRecordingWithCount_other":
        "Pausierte Aufzeichnung fortsetzen ({{count}})",
      "settings": "Einstellungen",
      "subscriptionStripe": "Abo & Stripe",
      "systemMessages": "Systemnachrichten",
      "treatments": "Behandlungen",
    },
    "privacyFilter": {
      "label": "Datenschutzfilter",
    },
    "sections": {
      "administration": "Administration",
      "configuration": "Konfiguration",
      "integrations": "Integrationen",
      "klinik": "Daten",
      "management": "Verwaltung",
      "resources": "Ressourcen",
    },
    "userMenu": {
      "downloadConnector": "Dentero Connector",
      "installApp": "App installieren",
      "language": "Sprache",
      "logout": "Ausloggen",
      "manageProfile": "Profil verwalten",
      "manageSubscription": "Abonnement verwalten",
      "whatsNew": "Neuigkeiten",
    },
  },
  "markdownEditor": {
    "blockquote": "Zitat",
    "bold": "Fett",
    "bulletList": "Aufzählung",
    "exitFullscreen": "Vollbild verlassen",
    "fullscreen": "Vollbild",
    "heading1": "Überschrift 1",
    "heading2": "Überschrift 2",
    "heading3": "Überschrift 3",
    "italic": "Kursiv",
    "orderedList": "Nummerierte Liste",
    "redo": "Wiederherstellen",
    "showEditor": "Editor anzeigen",
    "showSource": "Markdown-Quelltext anzeigen",
    "strikethrough": "Durchgestrichen",
    "undo": "Rückgängig",
  },
  "materialCatalog": {
    "explainer": {
      "intro":
        "Im Materialkatalog sehen Sie alle Materialien, die in Ihrem Warenwirtschaftssystem {{provider}} hinterlegt sind – mit Katalognummer, Bereich, Bezeichnung und Preis.",
      "managerOnly":
        "Nur Praxisinhaber und Praxisverwaltung können den Materialkatalog aktivieren.",
      "pointDaily":
        "Der Katalog wird einmal täglich aus {{provider}} geholt – Sie können ihn jederzeit selbst aktualisieren.",
      "pointFuture":
        "Ist die Funktion aktiv, werden erkannte Materialien in der Dokumentation markiert.",
      "pointSearch":
        "Sie können den gesamten Katalog durchsuchen und nach Bereichen filtern.",
      "readOnly":
        "Der Katalog wird nur gelesen – in {{provider}} wird nichts verändert.",
    },
    "features": {
      "deactivateConfirmDescription":
        "Der Materialkatalog wird ausgeblendet und die gespeicherten Materialdaten werden gelöscht. Ihr Warenwirtschaftssystem bleibt unverändert. Sie können den Katalog jederzeit neu aktivieren.",
      "deactivateConfirmTitle": "Materialkatalog deaktivieren?",
      "toggleLabel": "Materialkatalog",
    },
    "filters": {
      "category": "Bereich",
    },
    "list": {
      "columns": {
        "catalogNumber": "Katalognummer",
        "category": "Bereich",
        "description": "Beschreibung",
        "name": "Bezeichnung",
        "price": "Preis",
      },
      "empty": "Ihr Materialkatalog enthält keine Einträge.",
      "neverSynced": "Der Katalog wurde noch nicht abgerufen.",
      "searchPlaceholder": "Material suchen …",
      "syncFailed":
        "Der letzte Abruf ist fehlgeschlagen. Bitte versuchen Sie es erneut.",
      "syncing": "Der Katalog wird gerade abgerufen …",
    },
    "sync": {
      "action": "Jetzt aktualisieren",
      "lastError": "Letzter Fehler: {{message}}",
      "lastSyncedAt": "Letzter Abruf: {{time}}",
      "neverSynced": "Noch kein Abruf erfolgt",
      "running": "Wird abgerufen …",
      "source": "Quelle: {{provider}}",
      "states": {
        "failed": "Fehlgeschlagen",
        "never": "Noch nicht abgerufen",
        "ok": "Aktuell",
        "running": "Wird abgerufen",
      },
    },
    "title": "Material",
    "unknownProvider": "Ihrem Warenwirtschaftssystem",
  },
  "microphone": {
    "accessBlocked": "Mikrofonzugriff blockiert",
    "allowAccess": "Bitte Mikrofonzugriff erlauben",
    "allowAccessHelp": {
      "chrome":
        "Öffnen Sie das Seiteninfo-Symbol (Schloss oder Zahnrad) in der Adressleiste, stellen Sie Mikrofon auf Zulassen und laden Sie diese Seite neu.",
      "edge":
        "Öffnen Sie das Schloss-Symbol in der Adressleiste, stellen Sie Mikrofon auf Zulassen und laden Sie diese Seite neu.",
      "firefox":
        "Öffnen Sie das Berechtigungssymbol in der Adressleiste (oder das durchgestrichene Mikrofon), heben Sie die Mikrofon-Blockierung auf und laden Sie diese Seite neu. Firefox fragt Sie dann erneut nach dem Zugriff.",
      "other":
        "Erlauben Sie den Mikrofonzugriff für diese Website in den Browser-Einstellungen und laden Sie diese Seite neu.",
      "safari":
        "Öffnen Sie Safari → Einstellungen → Websites → Mikrofon, setzen Sie diese Website auf Zulassen und laden Sie diese Seite neu.",
    },
    "label": "Mikrofon",
    "lockedHint":
      "Beenden oder verwerfen Sie die aktuelle Aufnahme, um das Mikrofon zu wechseln.",
    "noAudioFromDevice":
      "Unter Windows kann ein anderes Programm – etwa Praxissoftware, Diktier- oder Telefonsoftware – das Mikrofon exklusiv belegen. Schließen Sie solche Programme oder wählen Sie ein anderes Mikrofon.",
    "noSignal": "Kein Mikrofonsignal erkannt",
    "select": "Mikrofon wählen",
    "signalHint":
      "Wenn Ihr Mikrofon funktioniert, sollten hier grüne Balken zu sehen sein.",
    "testStartFailed": "Mikrofon konnte nicht gestartet werden.",
    "unnamedDevice": "Mikrofon {{id}}...",
    "unsupported":
      "Audio-Aufnahme ist in diesem Browser nicht verfügbar. Bitte verwenden Sie einen aktuellen Browser wie Chrome, Firefox oder Safari.",
    "unsupportedShort": "Audio-Aufnahme ist in diesem Browser nicht verfügbar",
  },
  "newVersionToast": {
    "appUpdateAction": "Jetzt aktualisieren",
    "appUpdateTitle": "Eine neue App-Version ist verfügbar",
    "later": "Später",
    "recordingInProgress":
      "Beenden Sie zuerst die Aufnahme, dann können Sie neu laden.",
    "recordingInProgressAppUpdate":
      "Beenden Sie zuerst die Aufnahme, dann können Sie aktualisieren.",
    "reload": "Neu laden",
    "title": "Eine neue Version ist verfügbar",
  },
  "patients": {
    "briefing": {
      "disclaimer":
        "KI-generiert. Bitte doppelt prüfen. Keine medizinische Handlungsempfehlung.",
      "empty": "Das Briefing wird nach der nächsten Dokumentation erstellt.",
      "pending": "Das Briefing wird aktualisiert.",
      "title": "Briefing",
      "updatedAt": "Stand: {{date}}",
    },
    "chart": {
      "currentStateWithDate": "Aktueller Stand · {{date}}",
      "empty": "Für diesen Patienten liegt noch kein Befund vor.",
      "historyTitle": "Zahnstatus-Verlauf",
      "position": "{{current}} von {{total}}",
      "proposal": {
        "confirm": "Übernehmen",
        "description":
          "Aus der Dokumentation vorgeschlagen. Der Zahnstatus zeigt die Vorschau, bis Sie übernehmen.",
        "failed": "Der Vorschlag konnte nicht übernommen werden.",
        "queued_one": "{{count}} weiterer Vorschlag wird noch erstellt.",
        "queued_other": "{{count}} weitere Vorschläge werden noch erstellt.",
        "title_one": "{{count}} vorgeschlagene Änderung",
        "title_other": "{{count}} vorgeschlagene Änderungen",
      },
      "stepNewer": "Neuerer Stand",
      "stepOlder": "Älterer Stand",
      "title": "Zahnstatus",
      "unexamined": "Noch keine Zähne befundet.",
      "viewingHistorical": "Historischer Stand vom {{date}} — nur Ansicht.",
      "viewState": "Zahnstatus nach dieser Behandlung anzeigen",
      "viewStateShort": "Zahnstatus",
    },
    "index": {
      "lastVisit": "zuletzt {{date}}",
      "searchPlaceholder": "Nach Patientennummer suchen",
      "sort": {
        "countAsc": "Anzahl Dokumentationen (aufsteigend)",
        "countDesc": "Anzahl Dokumentationen (absteigend)",
        "recent": "Neueste Dokumentationen",
      },
      "timespan": {
        "clear": "Zeitraumfilter zurücksetzen",
        "label": "Zeitraum",
        "options": {
          "custom": "Benutzerdefiniert",
          "last_30_days": "Letzte 30 Tage",
          "last_7_days": "Letzte 7 Tage",
          "last_90_days": "Letzte 90 Tage",
          "last_month": "Letzter Monat",
          "this_month": "Dieser Monat",
        },
      },
      "treatmentCount_one": "{{count}} Dokumentation",
      "treatmentCount_other": "{{count}} Dokumentationen",
    },
    "label": "Patient {{number}}",
    "timeline": {
      "empty": "Für diesen Patienten liegen noch keine Dokumentationen vor.",
      "treatmentCount_one": "{{count}} Dokumentation",
      "treatmentCount_other": "{{count}} Dokumentationen",
    },
  },
  "planLocked": {
    "billingTitle": "Abrechnung",
    "complexesTitle": "Komplexe",
    "features": {
      "analog_positions": {
        "description":
          "Hinterlegen Sie die Analogpositionen nach § 6 Abs. 1 GOZ, die Ihre Praxis verwendet, samt fester Beträge. Sie werden in der PKV-Abrechnung automatisch vorgeschlagen, sobald die Dokumentation eine analog zu berechnende Leistung beschreibt.",
        "title": "Analogpositionen",
      },
      "complexes": {
        "description":
          "Komplexe sind vorbereitete Behandlungsabläufe Ihrer Praxis. Nennen Sie in der Aufnahme nur das Stichwort, und die Dokumentation wird um den hinterlegten Ablauf und die dazugehörigen Abrechnungspositionen ergänzt.",
        "title": "Komplexe",
      },
      "documentation_assistant": {
        "description":
          "Der Doku-Assistent blendet während der Aufnahme eine Checkliste für die jeweilige Behandlungsart ein. So fehlt nichts, was für eine vollständige Dokumentation und Abrechnung zählt. Assistenten lassen sich für Ihre Praxis anpassen.",
        "title": "Assistenten",
      },
      "factors": {
        "description":
          "Legen Sie fest, mit welchem Steigerungsfaktor und welcher Begründung GOZ- und GOÄ-Positionen vorgeschlagen werden. Faktor und Begründung werden in jeden Abrechnungsvorschlag übernommen.",
        "title": "Standardfaktoren",
      },
      "laboratory_service_prices": {
        "description":
          "Pflegen Sie die Preise Ihres Eigenlabors nach BEB und BEL. Laborleistungen in der Dokumentation werden erkannt und mit Ihren Praxispreisen für die Abrechnung vorgeschlagen.",
        "title": "Laborleistungen",
      },
      "material_catalog": {
        "description":
          "Erkannte Materialien werden in der Dokumentation markiert, und die Materialien aus Ihrem Warenwirtschaftssystem werden aufgelistet. Die Praxisverwaltung schaltet die Funktion ein oder aus.",
        "title": "Materialkatalog",
      },
    },
    "includedIn": "Im Paket {{tier}} enthalten.",
    "page": {
      "handbookLink": "Im Handbuch nachlesen",
      "noPortalHint":
        "Zum Paketwechsel wenden Sie sich an support@app.dentero.de.",
      "tierNote":
        "Dieses Feature ist im Paket {{tier}} enthalten. Ihr aktuelles Paket enthält es nicht.",
      "upgradeHint":
        "Das Paket wechseln Sie im Stripe Kundenportal. Neue Module sind direkt nach dem Wechsel verfügbar.",
      "upgradeLink": "Paket in Stripe wechseln",
    },
    "plausibilityTitle": "Plausibilität",
    "tiers": {
      "exclusive": "Exclusive",
      "premium": "Premium",
    },
    "tooltip": "Nicht im aktuellen Paket enthalten.",
  },
  "practiceAnalogPositions": {
    "bzaekSource": "BZÄK-Quelle",
    "deleteDescription":
      "Die Position wird nicht mehr für manuelle Auswahl oder Vorschläge in dieser Praxis verwendet.",
    "deleteTitle": "Analogposition aus Praxis entfernen?",
    "description":
      "Wählen Sie die in dieser Praxis verwendeten Analogpositionen und hinterlegen Sie den festen Betrag. Als Orientierung kann der BZÄK-Stundensatz von 407 EUR dienen.",
    "empty": "Für diese Praxis sind noch keine Analogpositionen konfiguriert.",
    "form": {
      "amountLabel": "Betrag in EUR",
      "amountPlaceholder": "z. B. 407,00",
      "calculatedAmountLabel": "Berechneter Betrag:",
      "createOption": 'Neue Analogposition "{{label}}" erstellen',
      "desiredReferenceFactorLabel": "Faktor",
      "desiredReferenceFactorPlaceholder": "z. B. 2,3",
      "highFactorHint":
        "Ein Faktor höher als 2,3 sollte nur in seltenen Ausnahmefällen verwendet werden, da es zu Erstattungsproblemen führen kann.",
      "modeAmount": "Zielbetrag",
      "modeReference": "GOZ/GOÄ-Position",
      "namingHint":
        "Der Name der Analogposition wird verwendet, um anhand des dokumentierten Behandlungstextes zu erkennen, wann diese Analogposition zutrifft. Wählen Sie den Namen daher sorgfältig, klar und verständlich.",
      "positionLabel": "Analogposition",
      "positionPlaceholder": "Analogposition auswählen oder erstellen",
      "referenceFactorLabel": "Faktor",
      "referencePositionPlaceholder": "Position wählen",
    },
    "import": "Importieren",
    "referenceSuggestions": {
      "empty": "Keine passenden GOZ/GOÄ-Referenzen für diesen Betrag.",
      "heading": "Referenzvorschläge",
      "loading": "Vorschläge werden geladen …",
      "summary":
        "Faktor {{factor}} · Referenzbetrag {{billed}} · Abweichung zum Zielbetrag {{difference}}",
    },
    "table": {
      "amount": "Euro",
      "position": "Position",
      "referenceCode": "GOZ/GOÄ",
      "referenceFactor": "Faktor",
    },
    "title": "Analogpositionen",
  },
  "practiceCosts": {
    "billingExempt": "Billing-exempt",
    "details": {
      "cachedTokens": " / Cached {{total}}",
      "columns": {
        "amount": "Betrag",
        "cost": "Kosten",
        "interval": "Intervall",
        "model": "Modell",
        "position": "Position",
        "quantity": "Menge",
        "requests": "Requests",
        "tokens": "Tokens",
        "type": "Typ",
      },
      "context": {
        "activeComplexes": "Aktive Komplexe",
        "activeMembers": "Aktive Mitglieder",
        "activeMembersValue": "{{active}} von {{total}}",
        "audioRetention": "Audio-Aufbewahrung",
        "billingFeature": "Billing-Feature",
        "customPrompts": "Custom Prompts",
        "description":
          "Zusätzliche Signale, die Kosten oder Kostenverständnis beeinflussen",
        "factors": "Faktorsteigerung",
        "title": "Weitere relevante Kontextdaten",
      },
      "noSubscription": "Kein zugeordnetes Abo vorhanden.",
      "requestsByType": {
        "description":
          "Zusammengeführt nach Request-Typ und Modell mit Tokenverbrauch und geschätzten Kosten",
        "empty": "Keine AI-Requests im Analysezeitraum.",
        "title": "AI-Requests nach Typ",
      },
      "subscriptionContext": {
        "noDirectMargin": "Keine direkte Margen-Zuordnung",
        "shared": "Geteilt",
        "title": "Abo-Kontext",
      },
      "tokenBreakdown": "In {{input}} / Out {{output}}",
      "unpricedRequests": "{{total}} ohne Kostenbasis",
    },
    "sharedSubscription_one": "Geteiltes Abo über {{count}} Praxis",
    "sharedSubscription_other": "Geteiltes Abo über {{count}} Praxen",
    "stats": {
      "activeUsers": {
        "description": "Mit Aufnahmen im Zeitraum",
        "footer_one": "{{count}} Nutzer aktuell in der Praxis",
        "footer_other": "{{count}} Nutzer aktuell in der Praxis",
        "title": "Aktive Nutzer",
      },
      "aiCosts": {
        "description": "Geschätzte interne Kosten",
        "title": "AI-Kosten",
      },
      "aiRequests": {
        "description": "Alle Request-Typen",
        "title": "AI-Requests",
      },
      "audioTime": {
        "description": "Aufnahmevolumen",
        "footer_one": "{{count}} Aufnahme",
        "footer_other": "{{count}} Aufnahmen",
        "title": "Audiozeit",
      },
      "costPerDoc": {
        "description": "Durchschnitt",
        "footer": "{{value}} / Audio-Min.",
        "title": "Kosten / Doku",
      },
      "documentations": {
        "description": "Neu erstellt",
        "title": "Dokumentationen",
      },
      "failed": {
        "description": "AI-Requests",
        "title": "Fehlgeschlagen",
      },
      "margin": {
        "title": "Marge",
      },
      "retried": {
        "description": "Requests mit mehreren Versuchen",
        "title": "Wiederholt",
      },
      "seats": {
        "description_one": "{{count}} aktives Mitglied",
        "description_other": "{{count}} aktive Mitglieder",
        "footer": "Aktuell bezahlte Seats",
        "title": "Sitze",
      },
      "subscriptionValue": {
        "footer": "Nur zahlungspflichtige Tage {{windowLabel}}",
        "noActive": "Kein aktives Abo",
        "title": "Abo-Wert",
      },
    },
  },
  "practiceDefaultFactors": {
    "deleteDescription":
      "Der Standardfaktor gilt dann nicht mehr für neue Vorschläge und manuell hinzugefügte Positionen. Bereits vorhandene Behandlungen bleiben unverändert.",
    "deleteTitle": "Standardfaktor entfernen?",
    "description":
      "Legen Sie fest, mit welchem Faktor und welcher Begründung eine GOZ- oder GOÄ-Position vorgeschlagen wird.",
    "empty": "Für diese Praxis sind noch keine Standardfaktoren eingerichtet.",
    "form": {
      "create": "Standardfaktor hinzufügen",
      "description":
        "Der Faktor und die Begründung werden bei jedem neuen Vorschlag dieser Position übernommen.",
      "editTitle": "Standardfaktor bearbeiten",
      "factorLabel": "Faktor",
      "factorPlaceholder": "z. B. 3,5",
      "justificationCatalogEmpty": "Keine vordefinierten Begründungen",
      "justificationCatalogLabel": "Vordefinierte Begründung",
      "justificationCatalogPlaceholder": "Begründung auswählen",
      "justificationLabel": "Begründung",
      "justificationPlaceholder":
        "Freitext, der auf der Position gespeichert wird",
      "newTitle": "Standardfaktor einrichten",
      "positionLabel": "Position",
      "positionPlaceholder": "GOZ- oder GOÄ-Position wählen",
    },
    "table": {
      "code": "Position",
      "factor": "Faktor",
      "justification": "Begründung",
      "title": "Bezeichnung",
      "type": "Art",
    },
    "title": "Standardfaktoren",
  },
  "practiceLaboratoryServicePrices": {
    "index": {
      "overridden": "Überschrieben",
    },
    "prices": {
      "bebDescription": "Praxisspezifische BEB-Preise nach Preisstufe.",
      "catalogDefault": "Katalogstandard",
      "reset": "Zurücksetzen",
      "resetDescription":
        "Der Praxispreis wird entfernt und der Katalogpreis wieder verwendet.",
      "resetTitle": "Preis zurücksetzen?",
    },
  },
  "practiceMemberships": {
    "activateUser": "Nutzer/in aktivieren",
    "currentUser": "Das sind Sie",
    "deactivateUser": "Nutzer/in deaktivieren",
    "demoteDialog": {
      "description":
        "Der Nutzer verliert den Admin-Status und damit den Zugang zu Admin-Funktionen.",
      "title": "Admin-Rechte entfernen?",
    },
    "documentationUsed_one": "{{count}} Dokumentation ({{month}})",
    "documentationUsed_other": "{{count}} Dokumentationen ({{month}})",
    "documentationUsedThisPeriod_one":
      "{{count}} im laufenden Abrechnungszeitraum",
    "documentationUsedThisPeriod_other":
      "{{count}} im laufenden Abrechnungszeitraum",
    "emailLockedHint":
      "Die Login-E-Mail kann nur die Person selbst in ihrem Profil ändern.",
    "existingUserLookup": {
      "accountName": "Konto: {{name}}.",
      "alreadyMember":
        "Diese Nutzerin / dieser Nutzer ist bereits Mitglied der Praxis.",
      "continue": "Weiter",
      "denteroManagedExisting":
        "Diese E-Mail-Adresse kann nicht zu dieser Praxis hinzugefügt werden, da sie bereits einer anderen Praxis zugeordnet ist. Bitte wählen Sie eine andere E-Mail-Adresse.",
      "existingAccount":
        "Diese E-Mail-Adresse gehört bereits zu einem bestehenden Dentero-Konto.",
      "existingAccountInPractices_one":
        "Diese E-Mail-Adresse gehört bereits zu einem bestehenden Dentero-Konto (in einer anderen Praxis).",
      "existingAccountInPractices_other":
        "Diese E-Mail-Adresse gehört bereits zu einem bestehenden Dentero-Konto (in {{count}} anderen Praxen).",
      "existingAccountWillAdd":
        "Das bestehende Konto wird dieser Praxis hinzugefügt.",
      "failed": "Die E-Mail-Adresse konnte nicht geprüft werden.",
      "noPermission":
        "Sie können dieses Konto nicht selbst hinzufügen, weil es auch zu Praxen gehört, die Sie nicht verwalten, oder dem Dentero-Team gehört. Wenden Sie sich an den Dentero-Support.",
      "rateLimited":
        "Zu viele Prüfungen. Bitte einen Moment warten und es erneut versuchen.",
      "staysDeactivated":
        "Das Konto ist deaktiviert und bleibt es auch nach dem Hinzufügen.",
    },
    "formDialog": {
      "editTitle": "Nutzerin/Nutzer bearbeiten",
      "newTitle": "Neue Nutzerin/Nutzer anlegen",
      "trialingDescription":
        "Während der Testphase kosten Sitze nichts. Ab Testende zahlen Sie für jeden gebuchten Sitz. Freie Sitze können Sie vorher entfernen.",
    },
    "inactive": "Inaktiv",
    "lastActive": "Zuletzt aktiv:",
    "manageUploadLink": "Upload-Link verwalten",
    "never": "nie",
    "promoteToAdmin": "Zu Admin befördern",
    "removeAdminRights": "Admin-Rechte entfernen",
    "removeFromPractice": "Aus Praxis entfernen",
    "reviewer": {
      "description":
        "Erlaubt das Reviewen von KI-Abrechnungsvorschlägen auf Aufnahmen.",
      "title": "Reviewer für Billing-Vorschläge",
    },
    "reviewerPermission": "Zusatzberechtigung für Billing-Review",
    "rolePlaceholder": "Rolle wählen",
    "roles": {
      "manager": "Manager",
      "user": "Nutzer",
    },
    "seatCharge": {
      "activateConfirm": "Aktivieren und Sitz kostenpflichtig buchen",
      "activateTitle": "Nutzer/in aktivieren?",
      "createConfirm": "Anlegen und Sitz kostenpflichtig buchen",
      "inviteConfirm": "Einladen und Sitz kostenpflichtig buchen",
      "note":
        "Alle Sitze sind belegt. Sie buchen dabei 1 Sitz für {{price}} pro {{interval}} zzgl. MwSt. dazu. Der anteilige Betrag für den laufenden Abrechnungszeitraum steht auf der nächsten Rechnung.",
      "noteNoPrice":
        "Alle Sitze sind belegt. Sie buchen dabei 1 kostenpflichtigen Sitz dazu.",
      "noteTrial":
        "Alle Sitze sind belegt. Sie buchen dabei 1 Sitz dazu. Er kostet ab Testende {{price}} pro {{interval}} zzgl. MwSt.",
    },
    "sendInvite": "Einladung senden",
    "uploadLink": {
      "description":
        "Aktivieren Sie den Link für diese Nutzerin/diesen Nutzer, damit Audiodateien ohne Login hochgeladen werden können.",
      "publicLinkLabel": "Öffentlicher Upload-Link",
    },
    "uploadLinkActive": "Upload-Link aktiv",
  },
  "practices": {
    "apiTokens": {
      "createdHint":
        "Kopiere diesen Token jetzt — er wird kein zweites Mal angezeigt.",
      "createdTitle": "Token erstellt",
      "description":
        "API-Tokens gewähren über die Dentero-API Lesezugriff auf die Aufnahmen und Dokumentationen dieser Praxis. Jeder Token handelt als das ausgewählte Praxismitglied.",
      "empty": "Noch keine API-Tokens.",
      "generate": "Token erstellen",
      "generateDescription":
        "Erstelle einen Token für den Zugriff auf die Daten dieser Praxis über die Dentero-API als bestimmtes Praxismitglied. Er wird nur einmal angezeigt.",
      "lastUsed": "zuletzt verwendet {{date}}",
      "nameLabel": "Name",
      "namePlaceholder": "z. B. PVS-Integration",
      "neverUsed": "nie verwendet",
      "revoke": "Widerrufen",
      "revokeConfirmDescription":
        "Anwendungen, die diesen Token verwenden, verlieren sofort den Zugriff. Dies kann nicht rückgängig gemacht werden.",
      "revokeConfirmTitle": "Diesen Token widerrufen?",
      "title": "API-Tokens",
      "tokenMeta": "•••• {{lastFour}} · erstellt {{created}}",
      "userLabel": "Benutzer",
      "userMeta": "für {{name}}",
      "userPlaceholder": "Praxismitglied auswählen",
    },
    "assistants": {
      "edit": {
        "contentLabel": "Inhalt",
        "contentPlaceholder": "Inhalt für diesen Assistenten...",
        "titleLabel": "Titel",
      },
      "form": {
        "continue": "Weiter",
        "description":
          "Erstellen Sie einen eigenen Dokumentationsassistenten für diese Praxis.",
        "newTitle": "Neuer Assistent",
        "titleLabel": "Titel",
        "titlePlaceholder": "z. B. Notfall-Dokumentation",
      },
      "index": {
        "add": "Hinzufügen",
        "breadcrumb": "Dokumentationsassistenten",
        "deleteDescription":
          "Möchten Sie diesen Assistenten wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden. Bei einer Überschreibung greift danach wieder der globale Assistent.",
        "deleteTitle": "Assistent löschen",
        "empty": "Noch keine Assistenten vorhanden.",
        "inherited": "Global",
        "override": "Überschreiben",
      },
    },
    "costs": {
      "billingInterval": {
        "monthly": "Monatlich",
        "yearly": "Jährlich",
      },
      "fixedWindow": "Seit {{date}}",
      "marginDescription": {
        "direct": "Abo minus AI-Kosten",
        "noSubscription": "0 EUR Umsatz minus AI-Kosten",
        "partial": "Teilweise Kostenbasis",
        "unattributable": "Nicht direkt zuordenbar",
      },
      "marginFooter": {
        "default": "Abo-Wert im Analysezeitraum minus AI-Kosten",
        "noSubscription": "Kein Abo-Umsatz im Analysezeitraum",
        "shared": "Abo wird mit anderen Praxen geteilt",
      },
      "noSubscription": "Kein Abo",
      "retention": {
        "1_week": "1 Woche",
        "24_hours": "24 Stunden",
        "immediately": "Sofort",
        "indefinite": "Unbegrenzt",
      },
      "subscriptionPeriodDescription":
        "Aktuelle Stripe-nahe Konfiguration, auf bezahlte Tage {{windowLabel}} umgelegt",
      "subscriptionStatus": {
        "active": "Aktiv",
        "canceled": "Gekündigt",
        "incomplete": "Unvollständig",
        "incomplete_expired": "Abgelaufen",
        "past_due": "Zahlung ausstehend",
        "paused": "Pausiert",
        "trialing": "Testphase",
        "unpaid": "Unbezahlt",
      },
      "unknown": "Unbekannt",
    },
    "deletion": {
      "confirmSelectedSchedule": "Gewählter Löschzeitpunkt: {{schedule}}",
      "deleteImmediately": "Sofort löschen",
      "description":
        "Sind Sie sicher, dass diese Praxis zur Löschung vorgemerkt werden soll?",
      "immediateWarning":
        "Eine sofortige Löschung kann nicht rückgängig gemacht werden!",
      "mark": "Zur Löschung vormerken",
      "options": {
        "immediately": "Sofort",
        "oneWeek": "in einer Woche",
        "thirtyDays": "in 30 Tagen",
      },
      "removeMarker": "Löschmarkierung entfernen",
      "title": "Praxis wirklich zur Löschung vormerken?",
    },
    "details": {
      "acceptRisk": "Akzeptieren",
      "additionalAddress": "Adresszusatz",
      "address": "Adresse",
      "audioRetention": "Speicherungsdauer der Sprachaufzeichnung",
      "audioRetentionTooltip":
        "Die Sprachaufzeichnung wird nach dem ausgewählten Zeitraum automatisch gelöscht.<br />Die pseudonymisierte Dokumentation bleibt erhalten.",
      "changeRetentionDescription":
        "Alle Sprachaufzeichnungen, die älter als {{period}} sind, werden unwiderruflich gelöscht, wenn diese Einstellung übernommen wird.",
      "changeRetentionTitle": "Speicherungsdauer ändern?",
      "city": "Stadt",
      "confirmRetention": "Bestätigen",
      "correctionNeedsRawAsr":
        "Nur verfügbar, wenn die Transkription über Soniox, Mistral oder AssemblyAI läuft.",
      "deletion": "Praxis löschen",
      "deletionNone": "Keine geplante Löschung",
      "deletionScheduledStatus": "Löschung vorgemerkt ({{date}})",
      "deletionTooltip":
        "Nach dem gewählten Zeitpunkt wird die Praxis vollständig und unwiderruflich gelöscht.<br />Eine aktiv gesetzte Vormerkung können Sie wieder aufheben, solange die Praxis noch nicht gelöscht wurde.",
      "enableImmediateDeletionTitle": "Sofortige Löschung aktivieren?",
      "immediateDeletionDescription":
        "Wenn diese Option aktiviert ist, werden Sprachaufzeichnungen direkt nach erfolgreicher Transkription unwiderruflich gelöscht. Die Korrektheit der Transkription kann danach nicht mehr anhand der Originalaufnahme überprüft werden.<br /><br /><bold>Achtung:</bold> Alle bereits vorhandenen Sprachaufzeichnungen dieser Praxis werden ebenfalls unwiderruflich gelöscht.<br /><br />Mit der Aktivierung akzeptieren Sie dieses Risiko.",
      "kzv": "KZV",
      "name": "Name",
      "notProvided": "Nicht angegeben",
      "pvsSystem": "Praxisverwaltungssystem",
      "transcriptCorrectionModel": "Modell für Transkriptkorrektur",
      "transcriptionModel": "Transkriptionsmodell",
      "useDefaultSetting": "Standard verwenden",
      "useGlobalSetting": "Globale Einstellung verwenden",
      "usingDefaultSetting": "Verwendet aktuell den Standard {{label}}.",
      "usingGlobalSetting":
        "Verwendet aktuell die globale Einstellung {{label}}.",
      "zip": "PLZ",
    },
    "features": {
      "analogPositions": "Analogpositionen (PKV)",
      "automaticBilling": "Automatische Abrechnung",
      "befundChart": "01 Befund",
      "beta": "Beta",
      "billing": "Abrechnung",
      "chunkedDocumentationCopy": "Gestückeltes Kopieren",
      "chunkedDocumentationCopyInfo": "Information zu gestückeltem Kopieren",
      "chunkedDocumentationCopyTooltip":
        "Aktiviert die Option, dass die Dokumentation stückweise kopiert werden kann. Dies ist relevant für PVS-Systeme deren Dokumentation nicht mehr als 1000 Zeichen zulässt.",
      "complexes": "Komplexe",
      "confirmation": {
        "enableAnalogPositionsDescription":
          "Möchten Sie die PKV-Analogleistungen und das Setup der Analogpositionen für diese Praxis aktivieren?",
        "enableAnalogPositionsTitle": "Analogpositionen aktivieren",
        "enableComplexesDescription":
          "Möchten Sie die Komplexe für diese Praxis aktivieren?",
        "enableComplexesTitle": "Komplexe aktivieren",
        "enableDokuAssistantDescription":
          "Möchten Sie den Doku-Assistenten für diese Praxis aktivieren?",
        "enableDokuAssistantTitle": "Doku-Assistent aktivieren",
        "enableFeatureDescription":
          'Möchten Sie das Feature "{{label}}" für diese Praxis aktivieren?',
        "enableFeatureTitle": "{{label}} aktivieren",
      },
      "connector": "Dentero Connector",
      "customizationChat": "Einrichtungsassistent",
      "dependencyBilling": "Abrechnung muss aktiviert sein",
      "dependencyTeemer": "Teemer muss verbunden sein",
      "dokuAssistant": "Doku-Assistent",
      "factors": "Faktoren & Begründungen",
      "integrationsTitle": "Integrationen & Anpassungen",
      "laboratoryServicePrices": "Laborleistungen",
      "orderDescription":
        'Hiermit bestelle ich das Feature "{{featureLabel}}" für {{licenseCount}} {{userWord}} ({{perUser}}/{{userWord}}/{{intervalLabel}}, gesamt {{total}}/{{intervalLabel}}). Der Betrag wird mit der nächsten Rechnung fällig.',
      "orderWithoutPrice":
        'Hiermit bestelle ich das Feature "{{featureLabel}}" zahlungspflichtig.',
      "patientBriefing": "Patienten-Briefing",
      "plausibilityCheck": "Plausibilitätsprüfung",
      "plausibilityCoverage": "Plausibilität über Besuche",
      "realtimeTranscription": "Live-Transkription",
      "teemerBillingCheck": "Abrechnungs-Check",
      "teemerExtension": "Teemer-Erweiterung für Chrome",
      "theme": "Design",
      "title": "Features",
      "trialDateSuffix": " (endet am {{date}})",
      "trialDescription":
        '"{{featureLabel}}" ist während Ihrer Testphase{{datePart}} kostenlos als Vorschau verfügbar. Mit der Aktivierung wird das Feature erst nach Testende zahlungspflichtig: {{perUser}}/{{userWord}}/{{intervalLabel}} ({{total}}/{{intervalLabel}} für {{licenseCount}} {{userWord}}).',
      "upgradeAutomaticBilling":
        "Nur Admins können automatische Abrechnung aktivieren",
      "upgradeBeta": "Nur Admins können Beta-Features aktivieren",
      "userWord_one": "Nutzer/in",
      "userWord_other": "Nutzer/innen",
    },
    "form": {
      "createTitle": "Neue Praxis anlegen",
      "emailHint":
        "Diese E-Mail wird für die Weiterleitung von E-Mails verwendet, falls behandelnde Personen keine eigenen E-Mail-Adressen haben.",
    },
    "index": {
      "add": "Hinzufügen",
      "cachedAt": "Datenstand:",
      "churnRisk": "Churn-Risiko",
      "churnRiskTooltip":
        "Churn-Risiko: In den letzten 30 Tagen gab es keinen Login und keine Dokumentation. Die Praxis könnte das Abo kündigen.",
      "churnValues": {
        "risk": "Churn-Risiko",
      },
      "credits": "Kontingent",
      "creditsPracticeUsed": "{{used}} aus dieser Praxis",
      "creditsRemaining": "{{remaining}} übrig",
      "creditsValues": {
        "reached": "Kontingent erreicht",
      },
      "deletionScheduled": "Löschung: {{date}}",
      "empty": "Noch keine Praxen vorhanden.",
      "lastRecording": "Letzte Aufnahme",
      "members": "Mitglieder",
      "priceValues": {
        "legacy": "Legacy",
        "older": "Alter Preis",
      },
      "recordings": "Aufnahmen",
      "searchPlaceholder": "Suche nach Praxis, Ort, Adresse oder Mitglied",
      "sinceUntil": "Seit/Bis",
      "stats": {
        "cost": {
          "short": "Kst.",
        },
        "margin": {
          "title": "Marge",
        },
        "revenue": {
          "short": "Ums.",
        },
      },
      "status": "Status",
      "statusValues": {
        "cancelled": "Gekündigt",
        "markedForDeletion": "Löschung vorgemerkt",
        "noStatus": "Kein Status",
        "subscribed": "Abonniert",
        "testing": "Testphase",
      },
      "tierValues": {
        "basic": "Basic",
        "exclusive": "Exclusive",
        "premium": "Premium",
      },
      "windowStartsAt": "Berechnung seit:",
    },
    "integrations": {
      "ivoris": {
        "connectionError":
          "Verbindung zu Ivoris war nicht erfolgreich. Bitte überprüfen Sie Ihre Eingaben.",
        "description": "Bitte geben Sie die notwendigen Daten für Ivoris ein.",
        "linknameLabel": "Linkname",
        "loadingProfiles": "Laden...",
        "loadProfiles": "Profile laden",
        "profileLabel": "Profil",
        "profilePlaceholder": "Profile laden, um eine Auswahl zu treffen",
        "selectProfileError": "Bitte wählen Sie ein Profil aus.",
        "title": "Ivoris-Integration",
      },
      "teemer": {
        "appointmentStatistics": {
          "available": "Verfügbar",
          "check": "Jetzt prüfen",
          "checkedAt": "Zuletzt geprüft: {{date}}",
          "neverChecked": "Noch nicht geprüft",
          "title": "Termindaten",
          "unavailable": "Nicht verfügbar",
          "unknown": "Unbekannt",
        },
        "autoSync":
          "Sobald die Dokumentation fertig ist, wird sie ohne Freigabe in die passende Teemer-Sitzung übertragen.",
        "autoSyncBilling":
          "Nach der Dokumentation folgen die ausgewählten Abrechnungspositionen der Versicherung, die Teemer für die Sitzung meldet. Übertragene Positionen lassen sich nur in Teemer wieder entfernen.",
        "autoSyncBillingTitle": "Abrechnung automatisch an Teemer senden",
        "autoSyncTitle": "Dokumentation automatisch an Teemer senden",
        "chunking":
          "Teemer akzeptiert pro Kommentar maximal 1000 Zeichen. Ist diese Option aktiv, wird längere Dokumentation automatisch in mehrere Teile aufgeteilt, damit sie in Teemer editierbar bleibt. Ist sie inaktiv, werden längere Dokumentationen von Teemer abgelehnt.",
        "chunkingTitle": "Dokumentation in mehreren Teilen übertragen",
        "description": "Bitte geben Sie die notwendigen Daten für Teemer ein.",
        "domainExample":
          "Zum Beispiel <example>pvsXX.teemer.de/praxissteuerung</example>",
        "domainLabel": "Domain",
        "sealHelp":
          "Einzeln: <single>TT</single> oder mehrere mit Komma getrennt: <multiple>TT, AB, XY</multiple>",
        "sealShortName": "Stempelkürzel",
        "title": "Teemer-Integration",
        "tokenLabel": "Token",
      },
    },
    "ivoris": {
      "noRedisError": "Kein Redis-Fehler festgestellt",
      "noStoredError": "Kein Fehler gespeichert",
      "notConfigured": "Nicht hinterlegt",
      "patientCacheDescription": "Redis-Status des Ivoris-Patienten-Mappings.",
      "patientCacheTitle": "Patienten-Cache",
      "rows": {
        "cachePresent": "Cache vorhanden",
        "integration": "Integration",
        "lastError": "Letzter Fehler",
        "lastJobRun": "Letzter Job-Lauf",
        "lastSuccessfulSync": "Letzte erfolgreiche Synchronisation",
        "lastSynchronisedTreatment": "Letzte synchronisierte Behandlung",
        "patientsInCache": "Patienten im Cache",
        "profileId": "Profil-ID",
        "profileIndex": "Profil-Index",
        "redisError": "Redis-Fehler",
        "redisKey": "Redis-Key",
        "status": "Status",
        "synchronisedTreatments": "Synchronisierte Behandlungen",
      },
      "startSync": "Sync starten",
      "status": {
        "failure": "Fehler vorhanden",
        "ok": "Unauffällig",
        "running": "Läuft",
      },
      "statusDescription":
        "Integrations-, Synchronisations- und Dokumentationsstatus.",
      "statusTitle": "Status",
      "syncRunning": "Sync läuft",
      "timestampMissing": "Aktuell nicht gespeichert",
      "unreadable": "Nicht lesbar",
    },
    "seats": {
      "addAction": "Sitze hinzufügen",
      "addConfirm_one": "{{count}} Sitz kostenpflichtig buchen",
      "addConfirm_other": "{{count}} Sitze kostenpflichtig buchen",
      "addDescription": "Wie viele Sitze möchten Sie hinzufügen?",
      "addPendingNotice":
        "Es ist bereits eine Entfernung vorgemerkt. Zurücknehmen kostet nichts.",
      "addProrated":
        "Der anteilige Betrag für den Rest des Abrechnungszeitraums steht auf der nächsten Rechnung.",
      "addResult": "Danach {{total}} Sitze",
      "addResultPrice":
        "Danach {{total}} Sitze, {{amount}} pro {{interval}} zzgl. MwSt.",
      "addTitle": "Sitze hinzufügen",
      "barLabel": "{{occupied}} Sitze belegt, {{free}} frei",
      "cancelRemoval": "Entfernen zurücknehmen",
      "countLabel": "Anzahl Sitze",
      "decrease": "Anzahl verringern",
      "hintAllPending":
        "Alle freien Sitze sind bereits zum Entfernen vorgemerkt.",
      "hintOccupied":
        "Deaktivieren Sie zuerst einen Benutzer, um einen Sitz freizugeben.",
      "increase": "Anzahl erhöhen",
      "legend":
        "<occupied>{{occupied}}</occupied> belegt · <free>{{free}}</free> frei",
      "legendPending_one": "{{count}} wird zum {{date}} entfernt",
      "legendPending_other": "{{count}} werden zum {{date}} entfernt",
      "pendingNotice_one":
        "Ab {{date}} {{next}} statt {{current}} Sitze. Bis dahin bleibt der Sitz bezahlt und nutzbar.",
      "pendingNotice_other":
        "Ab {{date}} {{next}} statt {{current}} Sitze. Bis dahin bleiben die Sitze bezahlt und nutzbar.",
      "pricePerSeat": "{{price}} pro Sitz und {{interval}} zzgl. MwSt.",
      "removeAction": "Freie Sitze entfernen",
      "removeConfirm_one": "{{count}} Sitz zum {{date}} entfernen",
      "removeConfirm_other": "{{count}} Sitze zum {{date}} entfernen",
      "removeConfirmNoDate_one": "{{count}} Sitz entfernen",
      "removeConfirmNoDate_other": "{{count}} Sitze entfernen",
      "removeDescription": "Wie viele freie Sitze sollen entfernt werden?",
      "removeSummary_one":
        "Bis {{date}} bleiben {{current}} Sitze bezahlt und nutzbar. Ab {{nextDate}} {{next}} Sitz. Keine Gutschrift.",
      "removeSummary_other":
        "Bis {{date}} bleiben {{current}} Sitze bezahlt und nutzbar. Ab {{nextDate}} {{next}} Sitze. Keine Gutschrift.",
      "removeSummaryNoDate_one":
        "Zum Ende des Abrechnungszeitraums bleibt {{next}} Sitz. Keine Gutschrift.",
      "removeSummaryNoDate_other":
        "Zum Ende des Abrechnungszeitraums bleiben {{next}} Sitze. Keine Gutschrift.",
      "removeTitle": "Freie Sitze entfernen",
      "sharedWith_one":
        "Gemeinsames Abo mit {{count}} weiteren Praxis. Die Sitze gelten für alle Praxen im Abo.",
      "sharedWith_other":
        "Gemeinsames Abo mit {{count}} weiteren Praxen. Die Sitze gelten für alle Praxen im Abo.",
      "summary_one": "{{occupied}} von {{count}} Sitz belegt",
      "summary_other": "{{occupied}} von {{count}} Sitzen belegt",
      "title": "Sitze",
    },
    "settings": {
      "complexesAppliedByDefault": "Komplexe standardmäßig anwenden",
      "documentationAssistantEnabledByDefault":
        "Dokumentationsassistent standardmäßig aktivieren",
      "documentationDownloadFormat": "Dokumentation herunterladen als",
      "documentationDownloadFormatInfo":
        "Information zum Format für heruntergeladene Dokumentationen",
      "documentationDownloadFormatOptions": {
        "pdf": "PDF (.pdf)",
        "txt": "Textdatei (.txt)",
      },
      "documentationDownloadFormatTooltip":
        "Gilt für alle Download-Schaltflächen bei Dokumentationen in der Aufnahme und in der Aufnahmeliste. Das PDF enthält Praxisname, Behandlungsdatum und Patientennummer.",
      "protectPrivacy": "Privatsphäre-Modus",
      "protectPrivacyInfo": "Information zum Privatsphäre-Modus",
      "protectPrivacyTooltip":
        "Wenn diese Einstellung aktiv ist, können nur die Ersteller/innen einer Aufnahme die Sprachaufzeichnung abspielen oder herunterladen und die Roh-Transkription sehen.",
      "realtimeTranscriptionEnabledByDefault":
        "Live-Transkription standardmäßig aktivieren",
      "realtimeTranscriptionEnabledByDefaultInfo":
        "Information zur Live-Transkription",
      "realtimeTranscriptionEnabledByDefaultTooltip":
        "Legt fest, ob das Live-Transkript bei neuen Aufnahmen bereits aktiv ist. Es transkribiert direkt im Browser während der Aufnahme; andernfalls wird die Aufnahme nach dem Hochladen transkribiert. Praxen können es pro Aufnahme jederzeit selbst zuschalten.",
      "skipAiRequests": "KI-Anfragen überspringen (Test)",
      "skipAiRequestsInfo": "Über das Überspringen von KI-Anfragen",
      "skipAiRequestsTooltip":
        "Nur für Tests außerhalb der Produktion. Wenn aktiviert, werden neue Aufnahmen nicht transkribiert und es läuft keine KI-Dokumentation oder Abrechnung — sie erscheinen als „Keine Sprache erkannt“. Spart KI-Anbieterkosten.",
      "title": "Einstellungen",
    },
    "show": {
      "addMember": "Hinzufügen",
      "emptyMembers": "Noch keine behandelnden Personen vorhanden.",
      "ivoris": "Ivoris",
      "membersHeading": "Nutzer/innen",
      "scheduledDeletion": "Geplante Löschung am {{date}}",
    },
    "subscription": {
      "badges": {
        "legacyTransition": "Legacy-Übergang",
        "manual": "Manuell",
        "noStripe": "Kein Stripe-Abo",
        "packageModel": "Paketmodell",
      },
      "billingModel": {
        "legacyTransition": "Legacy-Übergang",
        "manual": "Manuell",
        "none": "Kein Abo",
        "preStripe": "Pre-Stripe",
        "tier": "Tier",
      },
      "fields": {
        "interval": "Intervall",
        "package": "Paket",
        "seats": "Sitze",
        "status": "Status",
      },
      "internal": {
        "adminBadge": "Admin",
        "description":
          "Für Migration, Rabatte und Supportfälle. Normale Kundenänderungen laufen über das Stripe Kundenportal.",
        "title": "Interne Stripe-Verwaltung",
      },
      "modules": {
        "activeCount": "{{active}}/{{total}} aktiv",
        "heading": "Module im Paket",
        "headingTrialing": "Module während Testphase",
        "noneIncluded": "In diesem Paket sind keine Zusatzmodule enthalten.",
        "trialingHint":
          "Während der Testphase sind alle Module aktiv. Nach Ende der Testphase bleiben nur die im bezahlten Paket enthaltenen Module aktiv.",
      },
      "overview": {
        "title": "Abo-Übersicht",
      },
      "package": {
        "legacyFeatureSubscription": "Bisheriges Feature-Abo",
        "manualAgreement": "Manuelle Vereinbarung",
        "none": "Kein Abo",
      },
      "portal": {
        "description":
          "Verwalten Sie Paket, Rechnungen und Zahlungsdaten im Stripe Kundenportal.",
        "manageButton": "Abo in Stripe verwalten",
        "noStripeBadge": "Kein Stripe-Abo",
        "title": "Abo & Abrechnung",
      },
      "priceMove": {
        "atRenewal":
          "Der neue Preis gilt ab der nächsten Verlängerung. Der laufende Monat bleibt beim alten Preis.",
        "confirm": "Preis übernehmen",
        "description":
          "Zeigt die nächste Rechnung, bevor der aktuelle Katalogpreis gesetzt wird.",
        "descriptionLegacy":
          "Stellt das bisherige Modul-Abo auf das gewählte Paket um. Zusatzmodule entfallen ohne Gutschrift. Vorher zeigt die Vorschau die nächste Rechnung.",
        "effectiveAt": "Wirksam ab",
        "preview": "Vorschau",
        "sharedRefusal":
          "Geteilte Abos werden hier nicht umgestellt. Die Änderung erfolgt manuell in Stripe.",
        "targetTier": "Paket",
        "title": "Preis auf den aktuellen Katalog setzen",
        "total": "Nächste Rechnung",
      },
      "priceStatus": {
        "legacy": "Legacy",
        "noAddons": "Keine Zusatzmodule",
        "older": "Alter Preis",
        "perSeat": "{{amount}} pro Sitz",
        "unavailable": "Stripe liefert keinen Preis.",
      },
      "provision": {
        "description":
          "Sendet der Praxis einen Dentero-Link. Erst wenn die Praxis ihn öffnet, startet Stripe Checkout und verknüpft das Abo nach erfolgreicher Zahlung.",
        "fieldInterval": "Intervall",
        "fieldPackage": "Paket",
        "seatsHint":
          "Sitze werden für den Checkout aus den aktiven Nutzer/innen der Praxis abgeleitet. Mindestens 1 Sitz. Der Link ist 7 Tage gültig.",
        "submit": "Link senden",
        "title": "Checkout-Link senden",
        "trialDescription":
          "Aus = Abo startet direkt. An = 14 Tage Testphase, wie beim Signup.",
        "trialLabel": "Kostenfreie Testphase",
      },
      "seatsOccupied": "{{used}}/{{limit}} belegt",
      "subscriptionStatus": {
        "active": "Aktiv",
        "canceled": "Gekündigt",
        "incomplete": "Zahlung ausstehend",
        "none": "Kein Abo",
        "pastDue": "Zahlung offen",
        "paused": "Pausiert",
        "trialing": "Testphase",
        "unpaid": "Unbezahlt",
      },
    },
    "usage": {
      "exhausted": "Der Doku-Pool ist aufgebraucht",
      "period": "{{start}} bis {{end}}",
      "perSeat_one": "{{limit}} pro Sitz × {{count}} Sitz",
      "perSeat_other": "{{limit}} pro Sitz × {{count}} Sitze",
      "sharedBy": "Alle Praxen im Abo teilen diesen Pool:",
      "title": "Dokumentationsverbrauch",
      "usedOfLimit": "{{used}} / {{limit}}",
    },
  },
  "pwaInstall": {
    "description": "Als App installieren für schnellen Zugriff.",
    "dismissAriaLabel": "Schließen",
    "safari": {
      "step1": "Klicke auf Datei in der Menüleiste.",
      "step2": 'Wähle "Zum Dock hinzufügen...".',
    },
    "stepsLabel": "So geht's:",
    "title": "{{brand}} installieren",
    "treatmentDescription":
      "Als App installieren für schnellen Zugriff während der Behandlung, ohne Browser-Tabs.",
  },
  "recordingDrafts": {
    "chunkPersistenceInterrupted":
      "Die lokale Zwischenspeicherung wurde unterbrochen. Die bisher erfasste Aufnahme bleibt erhalten.",
    "localReadFailed":
      "Die lokale Aufnahme konnte nicht gelesen werden. Bitte versuchen Sie den Upload erneut.",
    "missingLocalRecording":
      "Die lokale Aufnahme konnte nicht mehr gefunden werden.",
    "pruned_one":
      "Die älteste lokale Aufnahme in der Warteschlange wurde entfernt, um Speicherplatz freizugeben.",
    "pruned_other":
      "Die {{count}} ältesten lokalen Aufnahmen in der Warteschlange wurden entfernt, um Speicherplatz freizugeben.",
    "recovered":
      "Die Aufnahme wurde lokal wiederhergestellt und wartet auf Ihren nächsten Schritt.",
    "savedOffline":
      "Die Aufnahme wurde lokal gesichert. Verbinden Sie sich erneut mit dem Internet und laden Sie sie dann hoch.",
    "uploadFailed":
      "Die Aufnahme wurde lokal gesichert, aber der Upload ist fehlgeschlagen. Sie können ihn erneut versuchen.",
    "uploadInterrupted":
      "Der vorherige Upload wurde unterbrochen. Sie können ihn erneut versuchen.",
  },
  "recordings": {
    "actions": {
      "cancelPending": "Ausstehende Anfragen abbrechen",
      "copied": "Kopiert!",
      "copyChunk": "Teil {{index}} kopieren",
      "copyChunks": "Dokumentation in Teilen kopieren",
      "copyComplex": "„{{name}}“ kopieren",
      "copyDocumentation": "Dokumentation kopieren",
      "copyEmpty": "Kein Inhalt zum Kopieren.",
      "copyFetchFailed": "Inhalt konnte nicht geladen werden.",
      "copyImprovedOriginal": "Verbesserte Fassung kopieren",
      "copySummary": "Zusammenfassung kopieren",
      "deleteRecording": "Aufnahme löschen",
      "document": "Dokumentieren",
      "downloadDocumentation": "Dokumentation herunterladen",
      "downloadEmpty": "Kein Inhalt zum Herunterladen.",
      "downloadFetchFailed": "Inhalt konnte nicht geladen werden.",
      "downloadImprovedOriginal": "Verbesserte Fassung herunterladen",
      "drawerTitle": "Aktionen",
      "markPending": "Als ausstehend markieren",
      "markProcessed": "Als bearbeitet markieren",
      "more": "Weitere Aktionen",
      "nextPending": "Nächste ausstehende Aufzeichnung",
      "processing": "wird verarbeitet...",
      "reprocess": "Erneut verarbeiten",
      "showAiRequests": "AI-Anfragen anzeigen",
    },
    "aiGenerated": "KI-generiert",
    "appendAudio": {
      "appendModeHeaderTitle": "Audio hinzufügen",
      "fieldsLockedHint": "Aus der ursprünglichen Aufnahme übernommen",
      "focusHint": "Diese Aufnahme wird an „{{name}}“ angehängt.",
      "focusHintUntitled":
        "Diese Aufnahme wird an die bestehende Aufnahme angehängt.",
      "queueItemTooltip": "Wird an diese Aufnahme angehängt",
      "transcriptionPending":
        "Bitte warten Sie, bis die Transkription abgeschlossen ist.",
      "trigger": "Audio hinzufügen",
      "uploadFailedFallback": "Audio konnte nicht hinzugefügt werden.",
    },
    "audio": {
      "adjustRetention": "Aufbewahrungseinstellungen anpassen",
      "deleted":
        "Die Sprachaufzeichnung wurde nach der eingestellten Aufbewahrungsfrist automatisch gelöscht.",
      "deletedShort": "Gelöscht",
      "playerLabel": "Audio-Aufzeichnung: {{name}}",
      "quality": "Qualität",
      "title": "Audio",
      "unavailable": "Audio ist nicht mehr verfügbar.",
    },
    "audioPlayer": {
      "download": "Herunterladen",
      "forward": "15 Sekunden vorspulen",
      "pause": "Pause",
      "play": "Abspielen",
      "rewind": "15 Sekunden zurück",
      "speed": "Wiedergabegeschwindigkeit",
    },
    "audioQuality": {
      "fair": "Audioqualität: mittel",
      "flags": {
        "clipped": "Stellenweise übersteuert",
        "distant_mic": "Mikrofon weit entfernt",
        "long_dead_air": "Lange Abschnitte ohne Sprache",
        "mic_left_on": "Mikrofon lief weiter",
        "mic_too_close": "Mikrofon zu nah",
        "narrowband": "Dumpfer Klang",
        "no_speech": "Keine Sprache erkannt",
        "recording_mostly_empty": "Aufnahme größtenteils leer oder defekt",
      },
      "good": "Audioqualität: gut",
      "level": {
        "fair": "mittel",
        "good": "gut",
        "poor": "schlecht",
        "unknown": "unbekannt",
        "unusable": "unbrauchbar",
      },
      "poor": "Audioqualität: schlecht",
      "title": "Audioqualität",
      "unknown": "Audioqualität: unbekannt",
      "unusable": "Audioqualität: unbrauchbar",
    },
    "billing": {
      "billingViewLabel": "Abrechnungsansicht",
      "forInsurance": "Abrechnung für",
      "reviewedBadge": "Gereviewt",
      "reviewSuggestions": "KI-Vorschläge reviewen",
    },
    "billingCheck": {
      "and": "und",
      "approx": "ca. {{amount}}",
      "badgeNotBilled_one": "{{count}} nicht abgerechnet",
      "badgeNotBilled_other": "{{count}} nicht abgerechnet",
      "badgeNotDocumented_one": "{{count}} nicht dokumentiert",
      "badgeNotDocumented_other": "{{count}} nicht dokumentiert",
      "badgePending": "Abrechnung in Teemer noch nicht bestätigt",
      "billedInTeemer": "In Teemer abgerechnet, {{times}}×",
      "billedInTeemer_one": "",
      "billedInTeemer_other": "",
      "collapse": "Einklappen",
      "collapsedOk_one": "{{count}} ohne Unterschied",
      "collapsedOk_other": "{{count}} ohne Unterschied",
      "disclaimer":
        "KI-gestützte Auswertung. Bitte im Einzelfall prüfen. Dentero übernimmt keine Haftung für die Richtigkeit. Die Entscheidung über die Abrechnung liegt bei der Praxis.",
      "estimate": "geschätzt {{range}}",
      "expand": "Ausklappen",
      "filter": {
        "all": "Alle",
        "findings": "Mit Hinweisen",
        "notBilled": "Dokumentiert, nicht abgerechnet",
        "notDocumented": "Abgerechnet, nicht dokumentiert",
        "ok": "Ohne Unterschied",
        "pending": "Noch nicht in Teemer bestätigt",
      },
      "howItWorks": "Wie funktioniert das?",
      "inDocumentation": "In der Dokumentation:",
      "insurance": {
        "private": "Privat (PKV)",
        "public": "Kasse (GKV)",
      },
      "inTreatments_one": "in {{count}} Behandlung",
      "inTreatments_other": "in {{count}} Behandlungen",
      "nextStepNotBilled":
        "Prüfen Sie, ob die Leistung in Teemer nachgetragen werden kann.",
      "nextStepNotDocumented":
        "Diese Leistung steht nicht in der Dokumentation. Ergänzen Sie die Dokumentation oder prüfen Sie die Abrechnung.",
      "noFindings": "Keine Unterschiede zur Teemer-Abrechnung gefunden.",
      "notBilledHeading": "Dokumentiert, aber nicht abgerechnet",
      "notDocumentedHeading": "Abgerechnet, aber nicht dokumentiert",
      "notDocumentedInline":
        "in Teemer abgerechnet, steht nicht in der Dokumentation",
      "period": "{{start}} bis {{end}}",
      "range": "{{min}} bis {{max}}",
      "summarySub":
        "Ihre Dokumentation im Vergleich mit der bestätigten Teemer-Abrechnung",
      "summarySubWithPeriod":
        "Ihre Dokumentation im Vergleich mit der bestätigten Teemer-Abrechnung, {{period}}",
      "tab": "Abrechnungs-Check",
      "tabHeadline_one":
        "{{count}} Unterschied zwischen Dokumentation und Teemer-Abrechnung",
      "tabHeadline_other":
        "{{count}} Unterschiede zwischen Dokumentation und Teemer-Abrechnung",
      "tabSub":
        "Dentero hat die Dokumentation mit der Abrechnung verglichen, die am {{date}} aus Teemer übernommen wurde.",
      "tabSubUndated":
        "Dentero hat die Dokumentation mit der aus Teemer übernommenen Abrechnung verglichen.",
      "tile": {
        "notBilled": "Dokumentiert, aber nicht abgerechnet",
        "notDocumented": "Abgerechnet, aber nicht dokumentiert",
        "ok": "Ohne Unterschied",
        "okDetail": "Dokumentation und Abrechnung passen",
      },
      "title": "Abrechnungs-Check",
      "tooth": "Zahn {{teeth}}",
      "upgradeBox":
        "Sehen Sie diese Unterschiede schon vor der Abrechnung. Abrechnungsvorschläge sind im Paket {{tier}} enthalten.",
      "upgradeLine":
        "Mit Abrechnungsvorschlägen sehen Sie diese Unterschiede schon vor der Abrechnung. Sie sind im Paket {{tier}} enthalten.",
      "upgradeLink": "Mehr zu Abrechnungsvorschlägen",
    },
    "billingRequest": {
      "creatingDescription": "Der Abrechnungsvorschlag wird gerade erstellt.",
      "creatingTitle": "Wird erstellt...",
      "errorDescription":
        "Der Vorschlag konnte nicht verarbeitet werden. Bitte versuchen Sie es erneut.",
      "errorTitle": "Fehler aufgetreten",
      "generate": "Abrechnungsvorschlag erstellen",
      "initialDescription":
        "Erstellen Sie Abrechnungsvorschläge für die aktuelle ausgewählte Versicherungsart.",
      "initialPrivate":
        "Mithilfe von KI werden Abrechnungspositionen für privat Versicherte aus GOZ und GOÄ vorgeschlagen.",
      "initialPublic":
        "Mithilfe von KI werden Abrechnungspositionen für gesetzlich Versicherte aus BEMA, GOZ und GOÄ vorgeschlagen.",
      "initialTitle": "Abrechnungsvorschläge erstellen",
      "preparingDescription":
        "Der Vorschlag startet automatisch, sobald die verbesserte Fassung fertig ist.",
      "preparingTitle": "Wird vorbereitet...",
    },
    "chat": {
      "button": "Frag die KI",
      "clear": "Verlauf löschen",
      "clearConfirmDescription":
        "Möchten Sie den Chatverlauf für diese Aufnahme wirklich löschen? Dies kann nicht rückgängig gemacht werden.",
      "clearConfirmTitle": "Chatverlauf löschen?",
      "close": "Schließen",
      "disclaimer":
        "Sie interagieren mit einem KI-System. Der Assistent hilft bei Dokumentation und Abrechnung dieser Aufnahme.",
      "empty":
        "Stellen Sie eine Frage zu dieser Aufnahme, z. B. warum eine Abrechnungsposition vorgeschlagen wurde.",
      "errors": {
        "empty": "Bitte geben Sie eine Nachricht ein.",
        "generic":
          "Die Antwort konnte nicht erstellt werden. Bitte versuchen Sie es erneut.",
      },
      "noMedicalAdvice": "Keine medizinische Beratung.",
      "placeholder": "Frage zu dieser Aufnahme stellen ...",
      "send": "Senden",
      "title": "Frag die KI",
      "tools": {
        "fetch_ai_reasoning": "KI-Begründung gelesen",
        "fetch_billing_positions": "Abrechnungspositionen gelesen",
        "fetch_combinations": "Kombinationen gelesen",
        "fetch_complexes": "Praxis-Komplexe gelesen",
        "fetch_custom_prompts": "Eigene Prompts geprüft",
        "fetch_documentation": "Dokumentation gelesen",
        "fetch_dzr_h1": "DZR H1 PRO abgefragt",
        "fetch_exclusions": "Ausschlüsse gelesen",
        "fetch_justifications": "Begründungen gelesen",
        "fetch_transcription": "Transkription gelesen",
        "web_search": "Web durchsucht",
      },
    },
    "complexesBadge": {
      "label_one": "{{count}} Komplex angewendet",
      "label_other": "{{count}} Komplexe angewendet",
    },
    "complexTemplates": {
      "choiceHint": "Eine oder mehrere Alternativen auswählen.",
      "conditionDoesNotApply": "Trifft nicht zu",
      "conditionFalse": "Weggelassen: {{label}}",
      "conditionTrue": "Trifft zu: {{label}}",
      "edit": "Text bearbeiten",
      "editCancel": "Abbrechen",
      "editDiscard": "Bearbeitung verwerfen",
      "edited": "Manuell bearbeitet",
      "editSave": "Speichern",
      "evidence": "Beleg",
      "fillPlaceholder": "Wert eingeben",
      "generate": "Komplex füllen",
      "generateDescription":
        "Die KI füllt diese Vorlage aus der verbesserten Dokumentation.",
      "listHint": "Ein Stichpunkt pro Zeile.",
      "rerenderedSinceEdit":
        "Ein späteres Diktat hat die Vorlage neu gefüllt. Verwerfen Sie die Bearbeitung, um den neuen Text zu übernehmen.",
      "slotMissing": "Offen: {{label}}",
      "slotOptions": "Alternativen: {{options}}",
      "stale":
        "Der Komplex wurde seit dieser Fassung geändert. Erneut verarbeiten, um die aktuelle Vorlage zu verwenden.",
    },
    "controls": {
      "clickToRecord": "Klicken zum Aufzeichnen",
      "discard": "Aufnahme verwerfen",
      "listenRecording": "Aufnahme anhören",
      "microphoneUnavailable": "Mikrofon nicht verfügbar",
      "paused": "Pausiert - anhören, fortsetzen oder speichern",
      "playingPreview": "Wiedergabe läuft...",
      "processShort": "Speichern",
      "recording": "Aufnahme läuft - klicken zum Pausieren",
      "recordingFinished": "Aufnahme beendet - speichern oder verwerfen",
      "saveAndProcess": "Aufzeichnung speichern und verarbeiten",
      "saveShort": "Speichern",
      "starting": "Aufnahme wird gestartet",
      "stopPreview": "Wiedergabe stoppen",
    },
    "details": {
      "liveTake": {
        "awaiting":
          "Der Live-Befund wird in den Zahnstatus übernommen, sobald die Patientennummer eingetragen ist.",
        "awaitingShort": "Wartet auf Patientennummer",
        "check":
          "Der Befund dieses Besuchs steht noch im Zahnstatus von Patient {{number}}, weil dieser inzwischen geändert wurde. Bitte dort prüfen.",
        "checkShort": "Befund auch bei Patient {{number}} prüfen",
        "confirm":
          "Der Live-Befund ist noch nicht übernommen. Bitte prüfen, ob {{number}} die Patientennummer ist, und speichern.",
        "confirmShort":
          "Patientennummer bestätigen, um den Befund zu übernehmen",
      },
      "openAuditTrail": "Änderungsprotokoll anzeigen",
      "openPatientRecord": "Patientenakte öffnen",
      "patientNumberDictated": "aus Diktat erkannt",
      "saveChangeDescription":
        "Die folgende Zeile in der strukturierten Dokumentation wird aktualisiert. Der übrige Text bleibt erhalten:",
      "saveChangeTitle": "Änderung speichern?",
      "source": {
        "api": "Aufgenommen in der App",
        "liveRecording": "Aufgenommen im Browser",
        "uploadLink": "Hochgeladen per Link",
      },
      "treaterAccessTransfer":
        "Zugriff auf Audio und Transkript geht an den neuen Behandler; Sie können den eigenen Zugriff verlieren",
      "treaterChangeDescription":
        "Möchten Sie den Behandler dieser Aufnahme ändern?",
      "treaterChangeTitle": "Behandler ändern?",
      "treaterPlaceholder": "Behandler auswählen",
      "treaterPrivacyDescription":
        "Im Privatsphäre-Modus ändert sich mit dem Behandler auch der Zugriff:",
      "updatedPatientIdInDocumentation": "Patient-ID",
      "updatedTreaterInDocumentation": "Behandler",
      "updatedTreatmentDateInDocumentation": "Behandlungsdatum",
      "via": "via",
    },
    "documentation": {
      "adjust": "Dokumentation anpassen",
      "adjustShort": "Anpassen",
      "editPlaceholder": "Dokumentation bearbeiten...",
      "rerender": "Neu erstellen",
      "rerenderConfirm":
        "Die KI erstellt die strukturierte Dokumentation mit den übernommenen Vorlagen neu. Ihre manuellen Änderungen gehen dabei verloren.",
      "rerenderTitle": "Strukturierte Dokumentation neu erstellen?",
      "saving": "Speichern...",
      "templatesChanged":
        "Vorlagen wurden geändert. Erstellen Sie die strukturierte Dokumentation neu, um die Änderungen zu übernehmen.",
      "title": "Dokumentation",
    },
    "drafts": {
      "description": "Aufnahmen, die noch hochgeladen werden müssen.",
      "duration": "Aufnahmedauer",
      "notSet": "Nicht gesetzt",
      "onlineOnly": "Nur online verfügbar",
      "recordedAt": "Aufnahmedatum",
      "remove": "Aufnahme entfernen",
      "removeDialog": {
        "confirm": "Entfernen",
        "description":
          "Diese lokale Aufnahme und alle dazugehörigen Daten werden entfernt. Diese Aktion kann nicht rückgängig gemacht werden.",
        "title": "Aufnahme entfernen?",
      },
      "retry": "Erneut hochladen",
      "status": {
        "actionNeeded": "Aktion nötig",
        "interrupted": "Unterbrochen",
        "ready": "Bereit",
        "uploading": "Lädt hoch",
      },
      "title": "Upload-Warteschlange",
      "upload": "Hochladen",
      "uploadAlreadyRunning": "Upload läuft bereits",
    },
    "export": {
      "button": "Exportieren",
      "exporting": "Wird exportiert…",
    },
    "filters": {
      "allSuggestions": "Alle",
      "withoutSuggestions": "Ohne Vorschläge",
      "withSuggestions": "Mit Vorschlägen",
    },
    "form": {
      "patientIdHint":
        "Die Patienten-ID können Sie auch als Teil der Aufzeichnung einsprechen und dient zur Zuordnung im PVS.",
      "selectDate": "Datum wählen",
    },
    "improvedOriginal": {
      "complexDetected":
        "Komplex erkannt. Unten anwenden, wenn er passen soll.",
      "complexesDisabled":
        "Komplexe können während der Verarbeitung nicht geändert werden.",
      "failedDescription":
        "Bitte erneut versuchen. Falls der Fehler weiterhin auftritt, wenden Sie sich an den Support.",
      "noAppliedComplexes":
        "Für diese Aufnahme sind Komplexe aktiv, aber in der aktuellen Fassung wurden keine Komplexe angewendet.",
      "previousComplexes": "Zuvor angewandte Komplexe",
      "reprocess": "Erneut verarbeiten",
      "title": "Verbesserte Fassung",
    },
    "index": {
      "batch": {
        "clearSelection": "Auswahl aufheben",
        "deleteDialog": {
          "description":
            "Diese Aktion kann nicht rückgängig gemacht werden. Alle ausgewählten Dokumentationen und deren Daten werden unwiderruflich gelöscht.",
          "title_one": "{{count}} Dokumentation löschen?",
          "title_other": "{{count}} Dokumentationen löschen?",
        },
        "deleteSelected": "Ausgewählte löschen",
        "markPending": "Als ausstehend markieren",
        "markProcessed": "Als bearbeitet markieren",
        "selectAll": "Alle auswählen",
        "selectAllPage": "Alle auf dieser Seite auswählen",
        "selected": " ausgewählt",
      },
      "liveView": "Live-Ansicht",
      "markAs": "Als {{status}} markieren",
      "poolCount": {
        "label": "Doku-Pool",
        "usedOfLimit": "{{used}} / {{limit}}",
      },
      "searchPlaceholder":
        "Suche nach Patient-ID, Stichwörtern oder Beschreibung",
      "selection": {
        "selectRecording": "{{name}} auswählen",
      },
    },
    "ivoris": {
      "lookupMissingData":
        "Patienten-ID oder Behandlungsdatum fehlt für den Abgleich.",
      "notFound": "Kein Ivoris-Patient gefunden für",
      "noTreatmentDate": "Kein Behandlungsdatum",
      "notSynchronised": "Nicht synchronisiert",
      "patientFound": "Patient gefunden",
      "patientId": "Patienten-ID: {{value}}",
      "requiresStructuredDocumentation":
        "Strukturierte Dokumentation muss abgeschlossen sein.",
      "resetStatus": "Status zurücksetzen",
      "syncDocumentation": "Dokumentation übertragen",
      "synchronised": "Synchronisiert",
      "treatmentDate": "Behandlungsdatum: {{value}}",
    },
    "materialAnnotations": {
      "catalogNumber": "Katalognummer: {{number}}",
      "notInCatalog": "Nicht im Katalog",
      "open_one": "Materialdetails öffnen",
      "open_other": "{{count}} Materialdetails öffnen",
      "title": "Erkanntes Material",
    },
    "metadata": {
      "audioTooltip": "Audiodauer und Audioqualität",
      "billing": {
        "failed": "fehlgeschlagen",
        "laboratoryServices_one": "{{count}} Laborleistung",
        "laboratoryServices_other": "{{count}} Laborleistungen",
        "pending": "wird erstellt",
        "positions_one": "{{count}} Position",
        "positions_other": "{{count}} Positionen",
      },
      "createdAtTooltip": "Erstellt am",
      "createdBy": "Erstellt von",
      "liveTakeAwaiting": "Live-Befund wartet auf Patientennummer",
      "liveTakeNeedsCheck": "Befund bei einem anderen Patienten prüfen",
      "openPatient": "Patient {{number}} öffnen",
      "patientIdNotSet": "Patient-ID nicht gesetzt",
    },
    "mobileSections": {
      "audio": "Audio",
      "billing": "Abrechnung",
      "chart": "Zahnstatus",
      "details": "Details",
      "improved": "Verbesserte Fassung",
      "structured": "Dokumentation",
    },
    "new": {
      "cockpit": {
        "assistantChange": "Wechseln",
        "assistantPanelTitle": "Assistent",
        "captureSectionDescription":
          "Mikrofon, Komplexe und Live-Transkript für diese Aufnahme.",
        "captureSectionTitle": "Aufnahme-Setup",
        "compactQueued_one": "{{count}} Upload wartet",
        "compactQueued_other": "{{count}} Uploads warten",
        "complexesPopoverTitle": "Komplexe anwenden",
        "complexesShort": "Komplexe",
        "complexesShortWithCount_one": "Komplex ({{count}})",
        "complexesShortWithCount_other": "Komplexe ({{count}})",
        "contextSectionDescription":
          "Diese Angaben helfen bei der Zuordnung im PVS.",
        "contextSectionTitle": "Dokumentationskontext",
        "controls": {
          "idleState": "Bereit",
          "pause": "Pause",
          "pausedState": "Pausiert",
          "readyState": "Bereit",
          "record": "Aufnehmen",
          "recordingState": "Live",
          "resume": "Weiter",
          "resumeRecording": "Aufnahme fortsetzen",
        },
        "dateUnset": "Datum wählen",
        "detailsDescription": "Praxis, Behandler und lokale Uploads.",
        "detailsTitle": "Aufnahmedetails",
        "detailsTrigger": "Details",
        "dividerAria": "Bereiche neu aufteilen",
        "draftsTriggerAria_one":
          "Upload-Warteschlange öffnen, {{count}} Aufnahme",
        "draftsTriggerAria_other":
          "Upload-Warteschlange öffnen, {{count}} Aufnahmen",
        "editLockedWhileRecording": "Während der Aufnahme nicht änderbar",
        "focus": {
          "enableLiveCta": "Live-Transkript aktivieren",
          "idleDescription":
            "Starten Sie die Aufnahme über die Steuerung unten. Details lassen sich oben anpassen.",
          "idleTitle": "Bereit für die Aufnahme",
          "pausedDescription":
            "Hören Sie die Aufnahme an, setzen Sie sie fort oder speichern Sie sie unten.",
          "pausedTitle": "Aufnahme pausiert",
          "recordingDescription":
            "Die Aufnahme läuft. Aktivieren Sie das Live-Transkript, um Sprache in Echtzeit zu sehen.",
          "recordingTitle": "Aufnahme läuft",
        },
        "headerTitle": "Neue Dokumentation",
        "lowerPaneAria": "Unteres Arbeitsfeld",
        "microphoneShort": "Mic",
        "patientIdPlaceholder": "123…",
        "patientIdUnset": "keine ID",
        "patientUnset": "Patient offen",
        "queueSheet": {
          "empty": "Keine lokal gespeicherten Aufnahmen.",
        },
        "realtimeInactive": "Aus",
        "realtimeShort": "Transkription",
        "segmented": {
          "assistant": "Assistent",
          "recording": "Aufnahme",
          "transcript": "Transkript",
        },
        "setup": {
          "assignment": "Zuordnung",
          "assistantRow": "Dokumentationsassistent",
          "capture": "Aufnahme",
          "drafts": "Entwürfe",
          "off": "Aus",
          "on": "Ein",
          "ready": "Bereit zur Aufnahme",
          "realtimeFootnote":
            "Der Text erscheint schon während der Aufnahme. Die Audioaufnahme bleibt als Rückfallebene erhalten.",
          "recording": "Aufnahme läuft",
          "save": "Aufzeichnung speichern",
          "title": "Aufzeichnen",
        },
        "setupDescription": "Mikrofon, Komplexe und Live-Transkript.",
        "setupTitle": "Aufnahme-Setup",
        "setupTrigger": "Setup",
        "takeSettings": {
          "open": "Einstellungen",
          "patientLocked":
            "Ab dem ersten Zahn im Befund nicht mehr änderbar. Der Befund gehört zu diesem Patienten.",
          "title": "Einstellungen",
        },
        "transcriptSheet": {
          "description":
            "Das Live-Transkript dieser Aufnahme. Die Aufnahme läuft weiter.",
          "open": "Transkript",
          "title": "Transkript",
        },
        "treaterPlaceholder": "Behandler wählen",
        "viewSwitch": {
          "assistantBadge": "{{name}} · {{current}}/{{total}}",
          "chartFailedNotice":
            "Der Live-Befund wurde abgebrochen. Die Aufnahme läuft weiter. Der Befund wird nach dem Stopp aus dem Transkript erstellt.",
          "chartTickFailedNotice":
            "Der Zahnstatus konnte gerade nicht aktualisiert werden. Die Aufnahme läuft weiter.",
          "dismissNotice": "Hinweis schließen",
          "hint": "Beides läuft weiter, auch wenn es nicht sichtbar ist.",
        },
      },
      "complexes": {
        "active": "Komplexe aktiv",
        "armedStripTitle": "Aktive Komplexe",
        "inactive": "Komplexe inaktiv",
        "infoAriaLabel": "Erklärung zu Komplexen anzeigen",
        "switchAriaLabel": "Komplexe für diese Aufnahme anwenden",
        "tooltip":
          "Durch Einsprechen der Trigger-Wörter können Sie Komplexe in die Dokumentation integrieren.",
      },
      "discardDialog": {
        "confirm": "Aufnahme verwerfen",
        "description": "Möchten Sie die aktuelle Aufnahme wirklich verwerfen?",
        "title": "Aufnahme verwerfen?",
      },
      "documentationAssistant": {
        "befundBlocked":
          "Im 01 Befund nicht verfügbar. Für eine Vorlage das Live-Transkript ausschalten.",
        "chooseTemplate": "Vorlage wählen",
        "chooseTemplateHint":
          "Die gewählte Vorlage erscheint unter dem Live-Transkript.",
        "clearTemplate": "Vorlage entfernen",
        "description":
          "Blendet während der Aufnahme den Assistenten für strukturierte Dokumentation ein.",
        "label": "Assistent",
        "selectedTemplate": "Gewählt: {{name}}",
        "switchAriaLabel": "Assistent für diese Aufnahme anzeigen",
      },
      "interrupted": {
        "description":
          "Die bisher aufgezeichneten Audiodaten bleiben lokal erhalten. Sie können sie jetzt speichern oder verwerfen.",
        "title": "Aufnahme wurde unterbrochen",
      },
      "leaveDialog": {
        "confirm": "Verwerfen und verlassen",
        "title": "Aufnahme verwerfen?",
      },
      "microphone": {
        "stopTest": "Test beenden",
        "test": "Testen",
      },
      "noAudio": {
        "description":
          "Es wird kein Ton aufgenommen. Prüfen Sie, ob das richtige Mikrofon ausgewählt und nicht stummgeschaltet ist.",
        "kept": "Die bisherige Aufnahme bleibt erhalten.",
        "running": "Die Aufnahme läuft weiter.",
        "tabTitle": "KEIN TON!",
        "title": "Kein Ton vom Mikrofon erkannt",
      },
      "noSpeech": {
        "notice": "Keine Sprache erkannt. Die Aufnahme läuft weiter.",
      },
      "offline": {
        "badge": "Warteschlange pausiert",
        "description":
          "Neue Aufnahmen gehen in die Warteschlange, bis wieder eine Verbindung besteht.",
        "title": "Offline",
      },
      "realtimeTranscription": {
        "acknowledgement": {
          "confirm": "Live-Transkript aktivieren",
          "description":
            "Das Audiosignal wird während der Aufnahme live transkribiert. Beim Speichern wird das Live-Transkript zur Grundlage für Dokumentation und Abrechnung. Die Audioaufnahme bleibt als sichere Rückfallebene erhalten.",
          "title": "Live dokumentieren – ohne auf die Verarbeitung zu warten",
        },
        "audioStillRecording":
          "Die Audioaufnahme läuft normal weiter und wird beim Speichern transkribiert.",
        "connecting": "Live-Transkript wird verbunden…",
        "connectionState": {
          "connected": "Verbunden",
          "connecting": "Verbindung wird aufgebaut…",
          "error": "Fehler",
          "idle": "Inaktiv",
          "paused": "Pausiert",
          "reconnecting": "Verbindung wird wiederhergestellt…",
          "stopping": "Transkript wird abgeschlossen…",
        },
        "emptyPlaceholder":
          "Das Live-Transkript erscheint hier, sobald Sie sprechen.",
        "error":
          "Live-Transkript konnte nicht verbunden werden. Die Aufnahme läuft weiter. Bitte erneut aktivieren oder später versuchen.",
        "errors": {
          "finalizationFailed":
            "Das Live-Transkript konnte nicht vollständig abgeschlossen werden. Beim Speichern wird automatisch die Audioaufnahme verwendet.",
          "noMicrophoneStream":
            "Für das Live-Transkript ist gerade kein Mikrofonsignal verfügbar.",
          "sessionExpired":
            "Die maximale Dauer der Live-Transkription wurde erreicht. Die Audioaufnahme läuft weiter.",
          "signedOut":
            "Sie wurden abgemeldet. Melden Sie sich in einem neuen Tab erneut an. Die Audioaufnahme läuft weiter, das Live-Transkript bleibt aber aus.",
          "tokenFetchFailed":
            "Live-Transkript konnte nicht authentifiziert werden. Die Aufnahme läuft weiter. Bitte erneut aktivieren oder später versuchen.",
          "transcriptionFailed":
            "Live-Transkript konnte nicht verbunden werden. Die Aufnahme läuft weiter. Bitte erneut aktivieren oder später versuchen.",
          "unavailable":
            "Live-Transkription nicht verfügbar. Die Aufnahme läuft weiter und wird nach dem Speichern transkribiert.",
          "unavailableBefund":
            "Der Befund wird nach dem Speichern aus der Aufnahme erstellt.",
        },
        "errorTitle": "Live-Transkript",
        "live": "Live",
        "micMuted":
          "Mikrofon stummgeschaltet – es wird gerade keine Sprache erfasst.",
        "paused": "Live-Transkript pausiert",
        "qualityHint":
          "Für bessere Ergebnisse: kurz sprechen, Hintergrundgeräusche reduzieren und das Mikrofon nah am Mund halten.",
        "scrollToLatest": "Zum aktuellen Text",
        "sourceOfTruth":
          "Wird beim Speichern für Dokumentation und Abrechnung übernommen.",
        "speakerLabel": "Sprecher {{speaker}}",
        "states": {
          "connected": "Live",
          "connecting": "Verbindung wird aufgebaut",
          "error": "Verbindung unterbrochen",
          "idle": "Bereit",
          "paused": "Pausiert",
          "reconnecting": "Verbindung wird wiederhergestellt",
          "stopping": "Transkript wird abgeschlossen",
        },
        "title": "Live-Transkript",
        "toggleLabel": "Echtzeit-Transkription",
        "unavailable":
          "Echtzeit-Transkription ist für diese Praxis nicht verfügbar.",
        "waitingForSpeech": "Warten auf Sprache…",
      },
      "silentSaveDialog": {
        "confirm": "Trotzdem speichern",
        "description":
          "In dieser Aufnahme wurde kein Ton erkannt. Sie wird als „Keine Sprache erkannt“ gespeichert und nicht transkribiert. Prüfen Sie das Mikrofon oder speichern Sie trotzdem.",
        "title": "Kein Ton in der Aufnahme",
      },
      "tabs": {
        "recording": "Aufnahme",
      },
      "title": "Neue Dokumentation",
      "treater": "Behandler",
      "workflow": {
        "befund": "01 Befund",
        "befundHeaderTitle": "01 Befund erfassen",
        "chartStageAnalyzingDescription":
          "Der Transkript-Ausschnitt wird auf Befundänderungen geprüft.",
        "chartStageAnalyzingTitle": "Analysiere Befund…",
        "chartStageConfirm": "Übernehmen",
        "chartStageDiscardAll": "Alles verwerfen",
        "chartStageEmptyDescription":
          "Zähne ohne Eintrag sind unbeurteilt. Tippen Sie auf Zahn oder Fläche für manuelle Korrekturen.",
        "chartStageEmptyDiff": "Noch keine Änderungen vorgeschlagen.",
        "chartStageIdleDescription":
          "Starten Sie die Aufnahme, um Befundänderungen per Sprache vorzuschlagen.",
        "chartStageIdleTitle": "Odontogramm bereit",
        "chartStageListeningDescription":
          "Gesprochene Befunde erscheinen als Vorschläge, sobald die Analyse verfügbar ist.",
        "chartStageListeningTitle": "Aufnahme läuft",
        "chartStageLoadingDescription": "Der aktuelle Zahnstatus wird geladen.",
        "chartStageLoadingTitle": "Zahnstatus laden…",
        "chartStageManualBadge": "manuell",
        "chartStageNeedsPatientDescription":
          "Für den 01-Befund ist eine gültige Patientennummer erforderlich.",
        "chartStageNeedsPatientTitle": "Patientennummer fehlt",
        "chartStageOfflineDescription":
          "01 Befund benötigt eine Online-Verbindung mit Live-Transkription.",
        "chartStageOfflineTitle": "Offline",
        "chartStagePendingCount_one": "{{count}} Änderung",
        "chartStagePendingCount_other": "{{count}} Änderungen",
        "chartStagePendingTitle": "Ausstehende Vorschläge",
        "chartStageProposalLabel": "Vorschlag {{index}} · {{opCount}} Ops",
        "chartStageStaleError":
          "Der Zahnstatus wurde zwischenzeitlich geändert. Bitte neu laden.",
        "chartStageTitle": "Odontogramm",
        "chartStageUndo": "Rückgängig",
        "offlineUnsupported":
          "01 Befund benötigt eine Online-Verbindung mit Live-Transkription.",
        "patientLater":
          "Optional. Ohne Nummer wird der Befund übernommen, sobald sie eingetragen ist.",
        "realtimeRequired": "01 Befund benötigt Live-Transkription",
        "selectorAria": "Aufnahmemodus wählen",
        "treatment": "Dokumentation",
      },
    },
    "patientHistory": {
      "button": "Patientenhistorie",
      "close": "Schließen",
      "empty": "Keine weiteren Behandlungen für diesen Patienten.",
      "loadError":
        "Die Patientenhistorie konnte nicht geladen werden. Bitte versuchen Sie es erneut.",
      "recordedAt": "{{value}} Uhr",
      "title": "Patientenhistorie",
    },
    "plausibility": {
      "allCovered":
        "Keine kritischen Lücken – alle für Abrechnung und Nachweis erforderlichen Angaben sind dokumentiert.",
      "appendPane": {
        "description":
          "Diese Punkte hat die Plausibilitätsprüfung als offen markiert. Diktieren Sie die fehlenden Angaben – sie werden nach der Verarbeitung in die Dokumentation übernommen.",
        "tab": "Offene Punkte",
      },
      "coveredHeading_one": "{{count}} abgedeckter Punkt",
      "coveredHeading_other": "{{count}} abgedeckte Punkte",
      "description":
        "Diese Angaben fehlen in der Dokumentation, obwohl sie für die Abrechnung oder den Nachweis gegenüber Kasse und Patient erforderlich sind.",
      "feedback": {
        "down": "Nicht hilfreich",
        "failed": "Die Bewertung konnte nicht gespeichert werden.",
        "question": "War diese Prüfung hilfreich?",
        "up": "Hilfreich",
      },
      "headerBadge_one": "{{count}} kritische Dokumentationslücke",
      "headerBadge_other": "{{count}} kritische Dokumentationslücken",
      "indexBadge": "Kritische Dokumentationslücken",
      "nonCriticalHeading_one": "{{count}} weiterer Hinweis (nicht kritisch)",
      "nonCriticalHeading_other": "{{count}} weitere Hinweise (nicht kritisch)",
      "notApplicableHeading_one": "{{count}} nicht anwendbarer Punkt",
      "notApplicableHeading_other": "{{count}} nicht anwendbare Punkte",
      "status": {
        "covered": "dokumentiert",
        "missing": "fehlt",
        "not_applicable": "nicht anwendbar",
        "partial": "unvollständig",
      },
      "tab": "Plausibilität",
      "title": "Offene Dokumentationspunkte",
    },
    "privacy": {
      "protectedContent":
        "Der Privatsphäre-Modus ist aktiv. Diese Aufnahme gehört nicht dem aktuell angemeldeten Nutzer.",
      "revealButton": "Trotzdem anzeigen",
    },
    "report": {
      "alreadyReported": "Eine Meldung wurde bereits am {{at}} gesendet.",
      "description": "Bitte geben Sie einen Grund für die Meldung ein.",
      "submit": "Meldung absenden",
      "title": "Aufzeichnung melden",
      "trigger": "Melden",
    },
    "requestEmpty": {
      "description": "Der Inhalt steht in Kürze zur Verfügung.",
      "title": "Wird erstellt...",
    },
    "show": {
      "shortSummaryPlaceholder": "Kurzbeschreibung eingeben",
      "treatmentSummaryPlaceholder": "Zusammenfassung eingeben",
    },
    "status": {
      "noRecording": "Keine Aufnahme",
      "pending": "Ausstehend",
      "processed": "Bearbeitet",
      "unprocessable": "Nicht verarbeitet",
    },
    "statusTitle": {
      "correctionRunning": "Transkript wird geprüft…",
      "failed": "Verarbeitung fehlgeschlagen",
      "noName": "Keine Bezeichnung gefunden",
      "notProcessed": "Noch nicht verarbeitet",
      "processing": "Wird verarbeitet...",
      "transcriptionRetrying":
        "Transkription dauert länger als üblich, wird erneut versucht...",
      "transcriptionRunning": "Transkription läuft...",
      "unprocessable": {
        "audio_too_long": "Aufnahme zu lang (max. 5 Stunden)",
        "default": "Aufnahme konnte nicht verarbeitet werden",
        "no_speech": "Keine Sprache erkannt",
        "unreliable_transcription": "Transkription unzuverlässig",
      },
    },
    "storagePrune": {
      "cancel": "Abbrechen und selbst verwalten",
      "confirm": "Älteste Aufnahmen löschen",
      "description_one":
        "Der lokale Speicher ist fast voll, daher kann keine neue Aufnahme gestartet werden. Löschen Sie die älteste hochzuladende Aufnahme in der Warteschlange ({{size}}), um Platz zu schaffen, oder brechen Sie ab und verwalten Sie die Warteschlange selbst.",
      "description_other":
        "Der lokale Speicher ist fast voll, daher kann keine neue Aufnahme gestartet werden. Löschen Sie die {{count}} ältesten hochzuladenden Aufnahmen in der Warteschlange ({{size}}), um Platz zu schaffen, oder brechen Sie ab und verwalten Sie die Warteschlange selbst.",
      "title": "Speicher fast voll",
    },
    "structuredDocumentation": {
      "notAvailable": "Nicht vorhanden",
      "processingError": "Fehler bei der Verarbeitung",
    },
    "transcription": {
      "adjust": "Transkription anpassen",
      "confirmDialog": {
        "discardConfirm": "Verwerfen",
        "discardDescription":
          "Die Änderungen an der Transkription wurden noch nicht gespeichert.",
        "modelLabel": "Transkriptionsmodell",
        "overwrites": {
          "billing": "Abrechnungsvorschläge",
          "documentation": "Dokumentation",
          "improved": "Verbesserte Fassung",
        },
        "retranscribeDescription":
          "Die Aufzeichnung wurde bereits verarbeitet. Wenn Sie fortfahren, werden folgende Daten überschrieben:",
        "saveDescription":
          "Der bearbeitete Text wird als Transkription (Rohfassung) gespeichert und ersetzt den bisherigen Inhalt dieses Feldes.",
        "title": "Fortfahren und überschreiben?",
      },
      "correcting": "Transkript wird geprüft…",
      "mergeFailed": "Audio konnte nicht zusammengeführt werden",
      "merging": "Audio wird zusammengeführt...",
      "modes": {
        "edit": "Bearbeiten",
        "read": "Lesen",
      },
      "reset": "Zurücksetzen",
      "retranscribe": "Neu transkribieren",
      "retranscriptionRequest": {
        "description":
          "Eine erneute Transkription starten wir für Sie. Beschreiben Sie kurz, was mit der aktuellen Transkription nicht stimmt – unser Support meldet sich bei Ihnen.",
        "placeholder":
          "z. B. Die Fachbegriffe wurden falsch erkannt, es wurde die falsche Behandlung aufgezeichnet ...",
        "submit": "Anfrage senden",
        "title": "Erneute Transkription anfragen",
        "trigger": "Erneute Transkription anfragen",
      },
      "retrying":
        "Transkription dauert länger als üblich, wird erneut versucht...",
      "running": "Transkription läuft...",
      "title": "Transkription",
    },
    "transferWindow": {
      "active": "Transferfenster aktiv",
      "coachmark": {
        "description":
          "Öffnen Sie ein separates Transferfenster mit Dokumentationen. So können Sie nach Fällen suchen und Texte schneller ins PVS übernehmen.",
        "dismiss": "Verstanden",
        "openNow": "Jetzt öffnen",
        "title": "Schneller ins PVS übertragen",
      },
      "open": "Transferfenster öffnen",
      "title": "Transfermodus",
      "tooltip":
        "Öffnet eine reduzierte Ansicht zum schnellen Kopieren ins PVS",
    },
  },
  "recordingSession": {
    "captureRecovered":
      "Das Mikrofon ist ausgefallen. Die Aufnahme läuft automatisch weiter – der bisherige Teil liegt gespeichert in der Warteschlange.",
    "discardedLocalRecording": "Lokale Aufnahme verworfen.",
    "longRecordingWarning":
      "Diese Aufnahme läuft schon recht lange. Denken Sie daran, sie zu speichern.",
    "maxDurationReached":
      "Die maximale Aufnahmedauer von {{hours}} Stunden wurde erreicht. Die Aufnahme wurde automatisch gespeichert.",
    "prepareFailed": "Die Aufnahme konnte nicht lokal vorbereitet werden.",
    "saveFailed":
      "Die Aufnahme konnte nicht gespeichert werden. Sie befindet sich in der Warteschlange und kann erneut hochgeladen werden.",
    "saveFailedNotQueued":
      "Die Aufnahme konnte nicht gespeichert werden. Bitte versuchen Sie es erneut, bevor Sie die Seite verlassen.",
    "segmentsMissing":
      "Ein Teil der Aufnahme war lokal nicht mehr vorhanden und fehlt in der gespeicherten Aufnahme.",
    "unsavedBeforeUnload":
      "Die aktuelle Aufnahme ist noch nicht gespeichert. Wenn Sie die Seite verlassen, geht die Aufnahme verloren.",
    "unsavedNavigation":
      "Die aktuelle Aufnahme ist noch nicht gespeichert. Möchten Sie sie verwerfen und die Seite verlassen?",
  },
  "regulationPositions": {
    "billingDimensions": {
      "cardinalities": {
        "once_per_locator": "Einmal pro Lokalisierung",
        "once_per_treatment": "Einmal pro Behandlung",
        "repeatable_per_locator": "Wiederholbar pro Lokalisierung",
        "repeatable_per_treatment": "Wiederholbar pro Behandlung",
      },
      "cardinality": "Kardinalität",
      "earliestAfterMonths": "Frühestens nach (Monate)",
      "groupable": "Gruppierbar",
      "locator": "Lokalisierung",
      "locators": {
        "none": "Keine",
        "teeth_region": "Zahnregion",
        "tooth": "Zahn",
        "tooth_surfaces": "Zahn + Flächen",
      },
      "maxCount": "Max. Anzahl",
      "noTimeframe": "Keine Häufigkeitsbeschränkung",
      "requiresSurfaces": "Flächen erforderlich",
      "source": "Quelle",
      "timeframeWindow": "Häufigkeitsfenster",
      "title": "Abrechnungsdimensionen",
      "unit": "Abrechnungseinheit",
      "units": {
        "cavity": "Kavität",
        "implant": "Implantat",
        "jaw": "Kiefer",
        "jaw_section": "Kieferabschnitt",
        "operation_site": "Operationsgebiet",
        "restoration": "Restauration",
        "root_canal": "Wurzelkanal",
        "service": "Leistung",
        "session": "Sitzung",
        "span": "Spanne",
        "tooth": "Zahn",
      },
    },
    "card": {
      "addToBillingSuggestions": "Zu Abrechnungsvorschlägen hinzufügen",
      "emptyWithTitle": "Keine {{title}} vorhanden",
    },
    "details": {
      "amount": "Betrag",
      "category": "Bereich",
      "noCategory": "Kein Bereich",
      "noTitle": "Kein Titel",
      "select": "Auswählen",
      "short": "Kurzform",
    },
    "dialog": {
      "excludedPositions": "Ausgeschlossene Positionen:",
      "loadingDetails": "Lade weitere Details...",
    },
    "drawer": {
      "combinations": "Kombinationen",
      "exclusions": "Ausschlüsse",
    },
    "form": {
      "createAction": "Erstellen",
      "createTitle": "Neue Abrechnungsposition anlegen",
      "description":
        "Erstellen Sie eine neue Abrechnungsposition. Nach dem Anlegen können Sie alle Details bearbeiten.",
      "positionPlaceholder": "z. B. 0010, Ä1, 01",
      "typePlaceholder": "Typ auswählen",
    },
    "index": {
      "add": "Hinzufügen",
      "combinationsShort": "Komb.",
      "exclusionsShort": "Ausschl.",
      "justificationsShort": "Begr.",
      "points": "Punkte",
      "position": "Position",
      "searchPlaceholder": "Suche nach Code oder Titel",
      "type": "Typ",
    },
    "justifications": {
      "description":
        "Begründungen werden verwendet, um Faktorsteigerungen zu erklären.",
      "empty": "Keine Begründungen vorhanden",
      "placeholder": "Neue Begründung eingeben...",
      "title": "Begründungen",
    },
    "relations": {
      "loading": "Lädt...",
      "placeholder": "Position auswählen...",
    },
    "show": {
      "archiveAction": "Archivieren",
      "archiveDescription":
        "Archivierte Positionen werden aus Vorschlägen und Listen ausgeblendet. Diese Aktion kann rückgängig gemacht werden.",
      "archiveTitle": "Position archivieren?",
      "combinations": "Kombinationen",
      "deleteDescription":
        "Die Position wird unwiderruflich aus der Datenbank gelöscht. Alle verknüpften Kombinationen und Ausschlüsse werden ebenfalls entfernt.",
      "deleteTitle": "Position löschen?",
      "exclusions": "Ausschlüsse",
      "noCombinations": "Keine Kombinationen vorhanden",
      "noExclusions": "Keine Ausschlüsse vorhanden",
      "restoreAction": "Wiederherstellen",
      "restoreDescription":
        "Die Position wird wieder aktiv und in allen Listen angezeigt.",
      "restoreTitle": "Position wiederherstellen?",
    },
  },
  "systemMessages": {
    "banner": {
      "defaultTitle": "Neues Update",
      "destructiveTitle": "Wichtiger Hinweis",
      "learnMore": "Mehr erfahren",
      "showLess": "Weniger anzeigen",
      "showMore": "Mehr anzeigen",
      "warningTitle": "Warnung",
    },
    "form": {
      "createAction": "Erstellen",
      "editDescription": "Bearbeite die Systemnachricht.",
      "editTitle": "Systemnachricht bearbeiten",
      "linkLabel": "Link-URL (optional)",
      "linkPlaceholder": "https://support.dentero.app/...",
      "messageLabel": "Nachricht",
      "messagePlaceholder": "Nachricht eingeben...",
      "newDescription": "Erstelle eine neue Systemnachricht für alle Benutzer.",
      "newTitle": "Neue Systemnachricht",
      "typeLabel": "Typ",
    },
    "index": {
      "empty": "Noch keine Systemnachrichten vorhanden.",
      "newMessage": "Neue Nachricht",
      "table": {
        "actions": "Aktionen",
        "createdAt": "Erstellt",
        "message": "Nachricht",
        "status": "Status",
        "type": "Typ",
      },
    },
    "row": {
      "active": "Aktiv",
      "archive": "Archivieren",
      "confirmDelete": "Systemnachricht wirklich löschen?",
      "copy": "Kopieren",
      "edit": "Bearbeiten",
      "publish": "Veröffentlichen",
    },
    "statuses": {
      "archived": "Archiviert",
      "draft": "Entwurf",
      "published": "Veröffentlicht",
    },
    "variants": {
      "default": "Info",
      "destructive": "Fehler",
      "warning": "Warnung",
    },
  },
  "teemer": {
    "billing": {
      "clickToSync": "Klicken zum Übertragen",
      "countMismatch":
        "Teemer hat {{actual}} statt {{expected}} Leistungen gebucht. Bitte in Teemer prüfen.",
      "countNotFound":
        "Teemer hat keine der {{expected}} Leistungen gebucht. Bitte in Teemer prüfen.",
      "empty": "Keine Leistungen vorhanden",
      "incompleteHelp":
        "Zahn oder Flächen fehlen. Teemer markiert die Leistung als unvollständig.",
      "resetStale": "Hängende Übertragung zurücksetzen",
      "resetSync": "Übertragungsstatus zurücksetzen",
      "syncCount_one": "{{count}} Leistung übertragen",
      "syncCount_other": "{{count}} Leistungen übertragen",
      "syncFailureHelp":
        "Diese Leistung konnte nicht zu Teemer synchronisiert werden und muss manuell der Behandlung hinzugefügt werden.",
      "syncFailureSessionNotFound":
        "Keine passende Teemer-Sitzung gefunden. Bitte Sitzung prüfen und erneut übertragen.",
      "syncRunning": "Übertragung läuft...",
      "title": "Leistungen",
      "warning":
        "Bitte prüfen Sie die Abrechnungsvorschläge unbedingt auf Korrektheit und Vollständigkeit nach der Übertragung!",
    },
    "comparison": {
      "aligned": "Übereinstimmend",
      "denteroSide": "{{brand}}",
      "empty": "Für diese Versicherung gibt es auf keiner Seite Positionen.",
      "onlyInDentero": "Nur in {{brand}}",
      "onlyInTeemer": "Nur in Teemer",
      "reason": "Begründung",
      "status": "Abgleich",
      "suggestionsTab": "Vorschläge",
      "syncedWarning":
        "Unsere Vorschläge wurden bereits an Teemer übertragen. Übereinstimmungen können daher aus unserer eigenen Übertragung stammen.",
      "tab": "Teemer-Abgleich",
      "teemerSide": "Teemer",
      "unmapped": "Nicht zugeordnet",
    },
    "document": {
      "autoSync": {
        "failed": {
          "comment_rejected":
            "Automatische Übertragung fehlgeschlagen: Teemer hat den Kommentar abgelehnt.",
          "connection_error":
            "Automatische Übertragung fehlgeschlagen: Teemer ist nicht erreichbar.",
          "generic": "Automatische Übertragung fehlgeschlagen.",
          "partial": "Teil {{posted}} von {{total}} übertragen.",
          "sessions_unavailable":
            "Automatische Übertragung fehlgeschlagen: Teemer-Sitzungen waren nicht abrufbar.",
          "timeout":
            "Automatische Übertragung fehlgeschlagen: Teemer hat nicht rechtzeitig geantwortet.",
          "unauthorized":
            "Automatische Übertragung fehlgeschlagen: Teemer hat die Anmeldung abgelehnt.",
        },
        "movedAfterSync":
          "Der frühere Kommentar liegt in Teemer bei einem anderen Patienten oder Datum und muss dort entfernt werden.",
        "partialRepost":
          "Eine manuelle Übertragung sendet alle Teile erneut. {{posted}} von {{total}} wurden bereits übertragen.",
        "secondComment":
          "Eine erneute Übertragung fügt in Teemer einen weiteren Kommentar hinzu.",
        "skipped": {
          "already_synchronised":
            "Automatische Übertragung übersprungen: bereits manuell übertragen.",
          "ambiguous_session":
            "Automatische Übertragung übersprungen: mehrere Teemer-Sitzungen. Bitte Sitzung wählen.",
          "disabled":
            "Automatische Übertragung übersprungen: die Einstellung ist aus.",
          "generic": "Automatische Übertragung übersprungen.",
          "missing_patient_id":
            "Automatische Übertragung übersprungen: keine Patientennummer.",
          "missing_treated_at":
            "Automatische Übertragung übersprungen: kein Behandlungsdatum.",
          "no_matching_session":
            "Automatische Übertragung übersprungen: keine passende Teemer-Sitzung. Bitte später manuell übertragen.",
          "session_not_found":
            "Automatische Übertragung übersprungen: die gespeicherte Teemer-Sitzung ist nicht mehr vorhanden. Bitte Sitzung wählen.",
          "unprocessable":
            "Automatische Übertragung übersprungen: keine verwertbare Dokumentation.",
        },
        "syncedAt": "Automatisch synchronisiert am {{date}}",
      },
      "heading": "Dokumentation",
      "includedInStructuredDocumentation":
        "Bereits in der strukturierten Dokumentation enthalten",
      "lastTransferredPrefix": "Zuletzt übertragen:",
      "rememberSelection": "Auswahl für künftige Behandlungen merken",
      "selectionLegend": "Inhalt des Teemer-Kommentars",
      "separateEntries": "Jedes Dokument als eigenen Eintrag senden",
      "structuredDocumentation": "Strukturierte Dokumentation",
    },
    "externalPositions": {
      "importedAt": "Importiert: {{date}}",
      "importFailed":
        "Import dauerhaft fehlgeschlagen am {{date}}. Der nächtliche Import überspringt diese Sitzung.",
      "notImported":
        "Abrechnungspositionen wurden noch nicht importiert. Sie erscheinen nach dem nächtlichen Import einer bestätigten Teemer-Sitzung.",
      "unmappedTooltip":
        "Diese Teemer-Position konnte keinem Abrechnungscode zugeordnet werden.",
    },
    "noSessionFound": "Keine Teemer-Sitzung gefunden für",
    "patientId": "Patienten-ID: {{value}}",
    "productName": "Teemer",
    "sessionSection": {
      "heading": "Sitzung",
      "multiCount_one": "{{count}} Sitzung",
      "multiCount_other": "{{count}} Sitzungen",
      "staleWarning": "Sitzung nicht mehr gültig, bitte erneut auswählen.",
    },
    "sessionStartOnDate": "am {{date}} um {{time}} Uhr",
    "sessionStartTime": "um {{time}} Uhr",
    "sessionState": {
      "CHECKED": "Geprüft",
      "CONFIRMED": "Bestätigt",
      "ENDED": "Beendet",
      "STARTED": "Gestartet",
    },
    "syncDialog": {
      "billingPart": " und Leistungen",
      "description": "Dokumentation{{billingPart}} an Teemer übertragen",
      "title": "Synchronisierung",
    },
    "syncStatus": {
      "docPending": "ausstehend",
      "docSynced": "synchronisiert",
      "failed":
        "Automatische Teemer-Übertragung braucht eine manuelle Synchronisierung",
      "needsSync": "Teemer Synchronisierung ausstehend",
      "partial": "Teemer teilweise synchronisiert",
      "partialDetail":
        "Teemer teilweise synchronisiert: Dokumentation {{docStatus}}, Leistungen {{synced}} von {{total}} synchronisiert",
      "synced": "Teemer vollständig synchronisiert",
    },
    "treatmentDate": "Behandlungsdatum: {{value}}",
  },
  "teemerSessions": {
    "allTreaters": "Alle Behandler",
    "appointments": {
      "arrived": "Im Wartezimmer",
      "arrivedSince": "Im Wartezimmer seit {{time}}",
      "loading": "Termine werden geladen …",
      "scheduled": "Geplant",
    },
    "documentDisabled": {
      "alreadyRecorded": "Für diese Sitzung gibt es bereits eine Aufnahme.",
      "notPrimaryPractice":
        "Aufnahmen werden immer Ihrer Hauptpraxis zugeordnet, daher können Sie in dieser Praxis nicht dokumentieren.",
      "notStarted":
        "Dokumentieren ist möglich, sobald die Behandlung in Teemer begonnen hat.",
    },
    "duration": {
      "actual_one": "{{count}} Min.",
      "actual_other": "{{count}} Min.",
      "loading": "Dauer wird geladen",
      "planned_one": "geplant {{count}} Min.",
      "planned_other": "geplant {{count}} Min.",
    },
    "liveView": "Live-Ansicht",
    "nextDay": "Nächster Tag",
    "noSessionsForDay":
      "Keine Teemer-Sitzungen oder Termine für diesen Tag gefunden.",
    "noSessionsForTreater":
      "Keine Teemer-Sitzungen oder Termine für den ausgewählten Behandler gefunden.",
    "previousDay": "Vorheriger Tag",
    "refresh": "Liste aktualisieren",
    "sortNewestFirst": "Neueste zuerst anzeigen",
    "sortOldestFirst": "Älteste zuerst anzeigen",
    "sortOrderToggle": "Sortierung umschalten",
  },
  "transcriptionBenchmarks": {
    "diff": {
      "added_one": "+{{count}} hinzugefügt",
      "added_other": "+{{count}} hinzugefügt",
      "legend": "Vergleich von {{left}} (Basis) mit {{right}}.",
      "removed_one": "−{{count}} entfernt",
      "removed_other": "−{{count}} entfernt",
      "tooLarge":
        "Der markierte Diff wird für diese langen Transkripte übersprungen ({{left}} vs. {{right}} Wörter), damit die Seite reaktionsschnell bleibt.",
      "unchanged_one": "{{count}} unverändert",
      "unchanged_other": "{{count}} unverändert",
    },
    "index": {
      "empty": "Noch keine Benchmark-Läufe.",
      "manageSamples": "Beispiele verwalten",
      "newRun": "Neuer Lauf",
      "providers": "Anbieter",
      "recentRuns": "Letzte Läufe",
      "recentRunsDescription":
        "Die neuesten Benchmark-Läufe mit Status, Anbietern und bester Wortfehlerrate.",
      "title": "Transkriptions-Benchmark",
    },
    "metrics": {
      "cost": "Kosten",
      "duration": "Dauer",
      "noReference": "Keine Referenz",
      "ratio": "Verhältnis",
      "tooltips": {
        "cost":
          "Geschätzte Anbieterkosten für die Transkription dieses Audioclips.",
        "duration":
          "Tatsächliche Zeit, die der Anbieter für die Transkription des Clips benötigt hat.",
        "ratio":
          "Verarbeitungszeit im Verhältnis zur Audiolänge. Unter 1× ist schneller als Echtzeit; niedriger ist besser.",
        "wer":
          "Word Error Rate – Anteil der Wörter, die von der Referenztranskription abweichen (ohne Berücksichtigung von Groß-/Kleinschreibung, Satzzeichen und Zahlenformat). Niedriger ist besser.",
      },
      "wer": "WER",
    },
    "new": {
      "addComparison": "Vergleich hinzufügen",
      "advancedSettings": "Erweiterte Einstellungen",
      "configurationA": "Konfiguration A",
      "configurationADescription": "Die Basiskonfiguration für diesen Lauf.",
      "configurationB": "Konfiguration B",
      "configurationBDescription":
        "Ein anderes Modell oder andere Einstellungen mit A vergleichen.",
      "configurationsMustDiffer":
        "Konfiguration A und B müssen sich unterscheiden.",
      "configurationsSectionDescription":
        "Eine Konfiguration ausführen oder eine zweite für den direkten Vergleich hinzufügen.",
      "configurationsSectionTitle": "Lauf konfigurieren",
      "createSample": "Beispiel erstellen",
      "description":
        "Quell-Audio auswählen, ein Modell konfigurieren und optional eine zweite Konfiguration vergleichen.",
      "includeThoughts": "Denken mitprotokollieren",
      "includeThoughtsHint":
        "Gibt die internen Denk-Schritte des Modells zurück (nur Gemini). Hilft bei der Untersuchung von Thinking-Budget-Überschreitungen.",
      "model": "Modell",
      "modelPlaceholder": "Modell auswählen",
      "noSamples": "Noch keine Beispiele.",
      "noSamplesHint":
        "Erstelle ein Ground-Truth-Beispiel, um die Wortfehlerrate zu messen.",
      "prompt": "Prompt überschreiben",
      "promptPlaceholder":
        "Optional: Standard-Transkriptions-Prompt überschreiben",
      "readySummary_one": "Bereit, {{count}} Konfiguration auszuführen.",
      "readySummary_other": "Bereit, {{count}} Konfigurationen auszuführen.",
      "recordingDuration": "{{minutes}} Min.",
      "recordingFilter": {
        "all": "Alle Aufnahmen (längste zuerst)",
        "failedAttempts": "Mit fehlgeschlagenen Transkriptionsversuchen",
      },
      "recordingFilterLabel": "Filter",
      "recordingNoDuration": "—",
      "recordingNoFailedRecordings":
        "Keine Aufnahmen mit fehlgeschlagenen Versuchen.",
      "recordingNoRecordings": "Keine passenden Aufnahmen.",
      "recordingNoRecordingsHint":
        "Ändere den Filter oder kehre zurück, nachdem geeignetes Audio hochgeladen wurde.",
      "recordingNoTranscription": "Keine Transkription",
      "recordingPlaceholder": "Aufnahme auswählen (längste zuerst)",
      "recordingSource": "Aufnahme aus DB",
      "recordingStatus": "Letzte Transkription: {{status}}",
      "recordingStatusCompleted": "Abgeschlossen",
      "recordingStatusFailed": "Fehlgeschlagen",
      "recordingStatusPending": "Ausstehend",
      "removeComparison": "Entfernen",
      "run": "Benchmark starten",
      "runComparison": "Vergleich starten",
      "runSummary_one": "{{count}} Konfiguration",
      "runSummary_other": "{{count}} Konfigurationen",
      "sample": "Ground-Truth-Beispiel",
      "sampleHint":
        "Jedes Beispiel bündelt Audio mit seinem Referenztranskript. Jeder Anbieter wird damit (WER) bewertet.",
      "samplePlaceholder": "Beispiel auswählen",
      "sampling": {
        "frequency_penalty": "Frequency Penalty",
        "frequency_penaltyInfo":
          "Bestraft Tokens umso stärker, je häufiger sie vorkommen. Höhere Werte reduzieren Wiederholungen.",
        "hint":
          "Leer = Modellstandard. Gilt nur für den Gemini-Aufruf dieser Konfiguration.",
        "presence_penalty": "Presence Penalty",
        "presence_penaltyInfo":
          "Bestraft bereits verwendete Tokens unabhängig von ihrer Häufigkeit. Höhere Werte fördern neue Formulierungen.",
        "temperature": "Temperatur",
        "temperatureInfo":
          "Steuert die Zufälligkeit. Höhere Werte erzeugen variablere Ausgaben.",
        "title": "Sampling-Überschreibungen",
        "top_p": "Top-P",
        "top_pInfo":
          "Beschränkt die Auswahl auf die wahrscheinlichsten Tokens. Niedrigere Werte erzeugen fokussiertere Ausgaben.",
      },
      "selectBaselineToContinue": "Wähle ein Modell für Konfiguration A.",
      "selectComparisonToContinue":
        "Wähle ein Modell für Konfiguration B oder entferne den Vergleich.",
      "selectRecordingToContinue": "Wähle eine Aufnahme, um fortzufahren.",
      "selectSampleToContinue": "Wähle ein Beispiel, um fortzufahren.",
      "showAllRecordings": "Alle Aufnahmen anzeigen",
      "sourceHint":
        "Beispiel = Audio mit Referenztranskript für WER-Bewertung. Aufnahme = beliebige Aufnahme aus der DB, keine Referenz.",
      "sourceModeRecording": "Aufnahme aus DB",
      "sourceModeSample": "Beispiel mit Referenz",
      "sourceSectionTitle": "Quell-Audio auswählen",
      "thinking": {
        "HIGH": "Hoch",
        "LOW": "Niedrig",
        "MEDIUM": "Mittel",
        "MINIMAL": "Minimal",
        "off": "Aus",
      },
      "thinkingLevel": "Denkstufe",
      "title": "Neuer Transkriptions-Benchmark",
    },
    "show": {
      "configuration": "Konfiguration",
      "diffToggle": "Diff zur Referenz",
      "enabled": "Aktiviert",
      "hidePrompt": "Prompt ausblenden",
      "reference": "Referenz",
      "rerun": "Erneut ausführen",
      "responseDialog": {
        "cachedTokens": "Gecachte Tokens",
        "completionTokens": "Completion-Tokens",
        "iteration": "Iteration",
        "noTokenUsage":
          "Für diesen Lauf wurden keine Token-Nutzungsdaten gespeichert.",
        "noTrace": "Für diesen Lauf wurde kein Request-Trace gespeichert.",
        "promptTokens": "Prompt-Tokens",
        "rawResponse": "Raw Response",
        "textContent": "Textinhalt",
        "thoughtsTokens": "Denk-Tokens",
        "tokenUsage": "Token-Nutzung",
        "totalTokens": "Gesamt-Tokens",
        "trace": "Trace",
        "triggerLabel": "Antwort",
        "words": "Wörter",
      },
      "showPrompt": "Prompt anzeigen",
    },
    "status": {
      "completed": "Abgeschlossen",
      "failed": "Fehlgeschlagen",
      "pending": "Ausstehend",
      "running": "Läuft",
    },
  },
  "transcriptionBenchmarkSamples": {
    "edit": {
      "replaceAudio": "Audio ersetzen (optional)",
      "replaceAudioHint":
        "Leer lassen, um das aktuelle Audio zu behalten. Eine Datei zu wählen ersetzt es.",
      "save": "Änderungen speichern",
      "title": "Ground-Truth-Beispiel bearbeiten",
    },
    "index": {
      "confirmDelete": "Dieses Beispiel löschen?",
      "createdAt": "Erstellt",
      "duration": "Dauer",
      "empty":
        "Noch keine Beispiele. Erstelle eines, um Anbieter damit zu vergleichen.",
      "label": "Bezeichnung",
      "newSample": "Neues Beispiel",
      "title": "Ground-Truth-Beispiele",
    },
    "new": {
      "audioFile": "Audiodatei",
      "label": "Bezeichnung",
      "labelPlaceholder": "z. B. Schlecht — lautes Handstück",
      "redactionHint":
        "Füge das korrigierte Referenztranskript genau so ein, wie das Audio transkribiert werden soll. Es wird unverändert gespeichert und als WER-Referenz verwendet.",
      "reference": "Referenztranskript (optional)",
      "referenceOptionalHint":
        "Optional: leer lassen für reine Audio-Uploads ohne WER-Bewertung (z. B. zur Untersuchung von Max-Token-Ausfällen).",
      "referencePlaceholder": "Korrigiertes Ground-Truth-Transkript einfügen",
      "save": "Beispiel speichern",
      "title": "Neues Ground-Truth-Beispiel",
    },
  },
  "unsavedChanges": {
    "confirmLeave":
      "Sie haben ungespeicherte Änderungen. Möchten Sie die Seite wirklich verlassen?",
  },
  "uploads": {
    "backToRecordings": "Zu den Aufzeichnungen",
    "cta": {
      "start": "Upload starten",
      "uploading": "Wird hochgeladen...",
    },
    "description":
      "Praxis: {{practiceName}}. Ziehen Sie eine Audio-Datei hier hinein oder wählen Sie eine Datei aus.",
    "dropzone": {
      "subtitle": "oder klicken, um eine Audio-Datei auszuwählen",
      "title": "Datei hier ablegen",
    },
    "emptyAudioFile":
      "Die Audiodatei ist leer. Bitte wählen oder erstellen Sie eine neue Aufnahme.",
    "failed": "Upload fehlgeschlagen",
    "invalidAudioFile": "Bitte wählen Sie eine gültige Audio-Datei aus.",
    "item": {
      "error": "Fehlgeschlagen",
      "pending": "Bereit",
      "success": "Fertig",
      "uploading": "Wird hochgeladen...",
    },
    "recordingCreateFailed": "Aufzeichnung konnte nicht erstellt werden.",
    "removeSelectedFile": "Ausgewählte Datei entfernen",
    "signedOut":
      "Sie wurden abgemeldet. Die Aufnahme ist gesichert. Melden Sie sich in einem neuen Tab an.",
    "submitFailed": "Die Datei konnte nicht erfolgreich hochgeladen werden.",
    "success": "Datei erfolgreich hochgeladen.",
    "title": "Audio-Dateien hochladen",
  },
  "versions": {
    "events": {
      "create": "Erstellt",
      "destroy": "Gelöscht",
      "update": "Geändert",
    },
    "fields": {
      "additional_address": "Adresszusatz",
      "address": "Adresse",
      "admin": "Administrator",
      "amount_cents": "Betrag",
      "analog_description": "Analogbeschreibung",
      "annotated_private": "Annotiert (privat)",
      "annotated_public": "Annotiert (gesetzlich)",
      "apply_complexes": "Komplexe anwenden",
      "audio_quality_level": "Audioqualität",
      "audio_upload_enabled": "Audio-Upload aktiviert",
      "billing_exempt": "Abrechnungsbefreit",
      "can_review_billing_suggestions": "Kann Abrechnung prüfen",
      "city": "Stadt",
      "class_name": "Klassenname",
      "classification": "Klassifizierung",
      "confidence": "Konfidenz",
      "content": "Inhalt",
      "deactivated_at": "Deaktiviert am",
      "description": "Beschreibung",
      "email": "E-Mail",
      "factor": "Faktor",
      "first_name": "Vorname",
      "improved": "Strukturierte Dokumentation",
      "improved_original": "Verbesserte Fassung",
      "included_for_sync": "Für Sync eingeschlossen",
      "insurance": "Versicherung",
      "integration_ivoris_entry_id": "Ivoris Eintrag-ID",
      "integration_ivoris_patient_id": "Ivoris Patienten-ID",
      "integration_ivoris_synchronised_at": "Ivoris synchronisiert am",
      "integration_teemer_chunking": "Teemer Chunking",
      "integration_teemer_domain": "Teemer Domain",
      "integration_teemer_seal_short_name": "Teemer Siegel",
      "integration_teemer_session_id": "Teemer Sitzungs-ID",
      "integration_teemer_synchronised_at": "Teemer synchronisiert am",
      "key": "Schlüssel",
      "kzv": "KZV",
      "laboratory_tasks": "Laboraufgaben",
      "last_name": "Nachname",
      "name": "Name",
      "notes": "Notizen",
      "original": "Originaltranskript",
      "patient_id": "Patienten-ID",
      "patient_id_numeric": "Patientennummer",
      "position_code": "Positionscode",
      "pvs_system": "PVS-System",
      "reason": "Begründung",
      "recorded_at": "Aufgenommen am",
      "reference_factor": "Referenzfaktor",
      "report_message": "Fehlermeldung",
      "retention_period_audio": "Audio-Aufbewahrungsfrist",
      "role": "Rolle",
      "short_summary": "Kurzzusammenfassung",
      "source": "Quelle",
      "status": "Status",
      "summary": "Zusammenfassung",
      "synchronization_status": "Synchronisierungsstatus",
      "template": "Vorlage",
      "title": "Titel",
      "transcript": "Transkript",
      "transcription_provider": "Transkriptionsanbieter",
      "treated_at": "Behandelt am",
      "trigger_words": "Triggerwörter",
      "value": "Wert",
      "zip": "PLZ",
    },
    "filters": {
      "allTypes": "Alle Typen",
      "clearRecording": "Filter Aufnahme {{id}} entfernen",
      "date": "Datum",
      "prefixIdPlaceholder": "Datensatz-ID",
      "recording": "Aufnahme {{id}}",
      "recordTypePlaceholder": "Datensatztyp",
      "userPlaceholder": "Nach Benutzer suchen",
    },
    "index": {
      "deletedUser": "Gelöschter Benutzer",
      "empty": "Keine Einträge im Änderungsprotokoll gefunden.",
      "table": {
        "changes": "Änderungen",
        "date": "Datum",
        "event": "Ereignis",
        "model": "Datensatz",
        "user": "Benutzer",
      },
      "title": "Änderungsprotokoll",
      "viaCustomizationChat": "über Einrichtungsassistent",
    },
    "itemTypes": {
      "AnalogPosition": "Analogposition",
      "Assistant": "Assistent",
      "BillingPosition": "Abrechnungsposition",
      "Combination": "Kombination",
      "CustomPrompt": "Benutzerdefinierter Prompt",
      "DentalChart": "Zahnstatus",
      "Exclusion": "Ausschluss",
      "Justification": "Begründung",
      "KzvbRule": "KZVB-Regel",
      "LaboratoryPrice": "Laborpreis",
      "LaboratoryService": "Laborleistung",
      "OnboardingPackage": "Onboarding-Paket",
      "Practice": "Praxis",
      "PracticeAnalogPosition": "Praxis-Analogposition",
      "PracticeComplex": "Komplex",
      "PracticeDefaultFactor": "Standardfaktor",
      "PracticeMembership": "Praxiszugehörigkeit",
      "Recording": "Aufnahme",
      "RegulationPosition": "Regulierungsposition",
      "Setting": "Einstellung",
      "Treatment": "Behandlung",
      "User": "Benutzer",
    },
    "sheet": {
      "noChanges": "Keine Feldänderungen aufgezeichnet.",
      "redacted": "Inhalt geändert (nicht gespeichert)",
      "title": "Änderungsdetails",
    },
  },
} as const;
